import React, { useState, useEffect, useRef } from "react";
import { addHours } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as fullStar, faStarHalfAlt, faStar as emptyStar } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";
import {MdKeyboardDoubleArrowLeft,MdKeyboardDoubleArrowRight,MdOutlineKeyboardArrowUp} from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { BiSolidEdit } from "react-icons/bi";
import {  format,addMonths,subMonths,startOfWeek,endOfWeek,addDays,subDays,} from "date-fns";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import image1 from "../assets/house.png";
import fridgeCleaning from "../assets/fridge.png";
import ovenCleaning from "../assets/oven.png";
import windowCleaning from "../assets/windows.png";
import Bed from "../assets/beds.png";
import axios from "axios";
import { BaseUrl } from "../App";
// import { Circles } from "react-loader-spinner";
import { FadeLoader } from 'react-spinners';
// import { useAuth } from "../components/AuthContext";

const Calendar = () => {
  const [isChecked, setIsChecked] = useState(false);
  // const { isAuthenticated } = useAuth();
  const [zipCodeError, setZipCodeError] = useState("");
  const [settings, setSettings] = useState({});
  const [selectedQty, setSelectedQty] = useState({});
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [activeView, setActiveView] = useState("month"); // Manage active view: 'month', 'week', or 'day'
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [staffdata, setstaffdata] = useState([]);
  const [appliedPromoCode, setAppliedPromoCode] = useState(null);
  const [promoCodes, setPromoCodes] = useState([]);
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showBookingSummary, setShowBookingSummary] = useState(false);
  const [showBookingSummary2, setShowBookingSummary2] = useState(false);
  const [isServiceOpen, setIsServiceOpen] = useState(false); // Toggle "Choose Services"
  const [isCalendarOpen, setIsCalendarOpen] = useState(false); // Toggle Calendar panel
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [allServices, setallServices] = useState([]);
  const [optiondata, setoptiondata] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState([]);
   const [getidbyadmin, setgetidbyadmin] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [methodRates, setMethodRates] = useState({});
  const [methodQuantities, setMethodQuantities] = useState({});
  const [editedMethodQuantities, setEditedMethodQuantities] = useState({});
  const [editedAddonQuantities, setEditedAddonQuantities] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
   const [idpromocode, setidpromocode] = useState(null);
  const [useriddata, setuseriddata] = useState(null);
  const [daySelected, setDaySelected] = useState(null); // Track selected day
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  console.log(useriddata);
  const [promoCode, setPromoCode] = useState("");
  const [showSelected, setShowSelected] = useState(false);
  const [userId, setUserId] = useState(null);
  const [showEditServiceModal, setShowEditServiceModal] = useState(false);
  const [userSelectedMethods, setUserSelectedMethods] = useState(null);
  const [userSelectedMethodsId, setUserSelectedMethodsId] = useState(null);
  const [userSelectedMethodsUnitsId, setUserSelectedMethodsUnitsId] =
    useState(null);
  const [userSelectedMethodsSmqty, setUserSelectedMethodsSmqty] =
    useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  console.log(selectedAppointment);
  const [order_id_appointment, setorder_id_appointment] = useState(0);
  const [userSelectedAddon, setUserSelectedAddon] = useState(null);
  const [services, setServices] = useState([]);
  console.log(selectedStaff);
  const [personalDetails, setPersonalDetails] = useState({
    streetAddress: "",
    zipCode: "",
    city: "",
    state: "",
  });
  const [appointmentDetails, setAppointmentDetails] = useState({
    streetAddress: "",
    zipCode: "",
    city: "",
    state: "",
  });
  const [hoveredEvent, setHoveredEvent] = useState(null);
  const [userType, setUserType] = useState("new");
  const [vacuum, setVacuum] = useState("no");
  const [parking, setParking] = useState("no");
  const [access, setAccess] = useState("");
  const [allsetdata, setallsetdata] = useState();
  const [sameAsAbove, setSameAsAbove] = useState(false);
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState(0);
  const [Distext, setSelectedDistext] = useState(10);
  const [text, setText] = useState();
  const navigate = useNavigate();
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  console.log(selectedDate, selectedTime);
  const [selectedservices, setselectedservices] = useState(0);
  const [showImageSection, setShowImageSection] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [residential, setResidential] = useState(false);
  const [commercial, setCommercial] = useState(false);
  const [bookingBill, setBookingBill] = useState([]);
  const [bedroom, setBedroom] = useState({});
  const [bathroom, setBathroom] = useState(0);
  const [quantities, setQuantities] = useState([0, 0, 0]);
  const [officeresidential, setofficeResidential] = useState(false);
  const [officecommercial, officesetCommercial] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [bookedSlots, setBookedSlots] = useState({});
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [bookingappointment, setbookingappointment] = useState([]);
  console.log(bookingappointment);
  const [propertyQuantities, setPropertyQuantities] = useState({
    Build_walls: 0,
    Build_doors: 0,
    Build_windows: 0,
  });
  const [officeQuantities, setOfficeQuantities] = useState({
    desk: 0,
    window: 0,
  });
  const [tax, settax] = useState(0);
  const [damagedFloors, setDamagedFloors] = useState(0);
  const [doorJams, setDoorJams] = useState(0);
  const [packing, setPacking] = useState(0);
  const [storeroom, setStoreroom] = useState(0);
  const [area, setArea] = useState(0);
  const [timeSlots, setTimeSlots] = useState([]);
  const [error, setError] = useState("");
  console.log(timeSlots);
  const [officearea, setOfficeArea] = useState(0);
  const [extraDamagedFloors, setExtraDamagedFloors] = useState(0);
  const [extraDoorJams, setExtraDoorJams] = useState(0);
  const [Disamount, setDisamount] = useState(0);
  const [officeextraDamagedFloors, setofficeExtraDamagedFloors] = useState(0);
  const [officeextraDoorJams, setofficeExtraDoorJams] = useState(0);
  const [adminData, setAdminData] = useState(null);
  console.log(adminData);
  const [calenderdata, setcalenderdata] = useState([]);
  const [Services_frequently_discount, setServices_frequently_discount] =
    useState([]);
  const [icon, setIcon] = useState("+"); // State to control the icon (either "+" or "-")
  const [activeTab, setActiveTab] = useState("Residential");
  const [formData, setFormData] = useState({
    serviceLocation: "",
    zipCode: "",
    selectedService: "",
    image: image1,
    showHouseOptions: false,
    showPlumbingOptions: false,
    showCarpenterOptions: false,
    showOfficeOptions: false,

    bedroomCount: "",
    bathroomCount: "",
  });
  const [crmgetdata, setcrmgetdata] = useState([]);
  const [dayseleted, setdayseleted] = useState(null);
  const [timeSelected, settimeSelected] = useState(null);
  const [userDetails, setUserDetails] = useState({
    id: "",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    phone: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    postalCode: "",
    specialRequests: "",
  });
  const [databooking, setdatabooking] = useState([]);
  const [activeService, setActiveService] = useState(null);
  const [serviceCounts, setServiceCounts] = useState({});
  const extraServices = [
    { image: fridgeCleaning, name: "Fridge Cleaning", price: "$50" },
    { image: ovenCleaning, name: "Oven Cleaning", price: "$40" },
    { image: windowCleaning, name: "Inside Window Cleaning", price: "$30" },
  ];
  const [paymentMethod, setPaymentMethod] = useState("payLocally"); // Set default to 'payLocally'
  const [showAllEvents, setShowAllEvents] = useState(false);
  const [totalTime, setTotalTime] = useState(0); // To track total time
  const [detailsdata, setDetailsdata] = useState({});
  console.log(detailsdata);
  const [Detailsiud, setDetailsiud] = useState(null); // Set default to
  // const [showForm, setShowForm] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");
  const [rescheduleDate, setRescheduleDate] = useState(""); // Changed name here
  const [rescheduledData, setRescheduledData] = useState(null);
  const [subtotale, setsubtotale] = useState(0);
  const [isBookingComplete, setIsBookingComplete] = useState(false);
  const [Detailsiuddata, setDetailsiuddata] = useState(null);
  const [totelamount, setTotelamount] = useState(0); // Already declared as abctotelamount, but misspelled
  const [disType, setDisType] = useState(null)
  const handleRescheduleClick = (id) => {
    setShowRescheduleModal(true);
    setDetailsiuddata(id);
  };
  // Close modal
  const closeRescheduleModal = () => {
    // Changed name here
    setShowRescheduleModal(false);
  };
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  const handleSelectChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(
      (option) => option.value
    );
    setSelectedStaff(selectedOptions);
  };
  const fetchSettings = async () => {
    setLoading(true); // Use your existing loading state
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/settings.php`,
        {
          action: "get_all_settings",
          api_key: "1",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.data.status === "true" && response.data.statuscode === 200) {
        const fetchedSettings = response.data.response.reduce((acc, item) => {
          if (item.option_name === "ct_postal_code") {
            acc[item.option_name] = item.postalcode; // Store postal codes as a comma-separated string
          } else {
            acc[item.option_name] = item.option_value;
          }
          return acc;
        }, {});
  
        setSettings((prevSettings) => ({
          ...prevSettings,
          ...fetchedSettings,
        }));
      } else {
        throw new Error(response.data.response || "Failed to fetch settings");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  // Call fetchSettings on component mount
useEffect(() => {
  fetchSettings();
}, []);
const handleZipCodeChange = (e) => {
  const value = e.target.value;
  setFormData({
    ...formData,
    zipCode: value,
  });
  // Split postal codes into an array for comparison
  const validZipCodes = settings["ct_postal_code"]?.split(",") || [];
  // Check if the entered zip code matches any valid postal code
  if (value.length > 0 && !validZipCodes.includes(value)) {
    setZipCodeError("Our service is not available at your location");
  } else {
    setZipCodeError(""); // Clear error if valid or empty
  }
};
  const fetchPromoCodes = async () => {
    try {
      const payload = {
        action: "get_all_coupons",
        api_key: "1",
      };

      const response = await axios.post(
        `${BaseUrl}/backend/api/promocode.php`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);
      if (response.data.status === "true") {
        setPromoCodes(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching promo codes:", error);
    }
  };

  // Add this useEffect to fetch promocodes on component mount
  useEffect(() => {
    fetchPromoCodes();
  }, []);

  useEffect(() => {
    if (detailsdata?.staff_ids && detailsdata.staff_ids.length > 0) {
      setSelectedStaff(detailsdata.staff_ids);
    }
  }, [detailsdata?.staff_ids]);
 
  const handleEditClick = async () => {
    setLoading(true);
    setShowSelected(!showSelected);
    try {
      // Define the request payload
      const payload = {
        action: "staff_assign_to_booking",
        api_key: "1",
        order_id: detailsdata.id,
        staff_ids: selectedStaff, // This will contain only currently selected staff IDs
      };
  
      console.log("Payload being sent:", payload);
  
      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/staff_assign.php`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      console.log("API Response:", response);
  
      // Check if the response contains valid data
      if (response.data.status === "true") {
        setSuccessMessage("Staff assignment updated successfully!");
        console.log("Updated staff data:", response.data);
      } else {
        console.log("API response indicates failure:", response.data);
        setSuccessMessage("Failed to update staff assignment");
      }
      getappointmentdetails();
      bookeddata(); // Refresh the data
      handleCloseModal();
    } catch (error) {
      console.log("Error updating staff assignment:", error);
      setSuccessMessage("Error updating staff assignment");
    } finally {
      setLoading(false);
    }
  };
  const handleUpdate = async (e, rescheduleDate) => {
    e.preventDefault();
    setLoading(true);
    // Validate the rescheduleDate
    if (!rescheduleDate || isNaN(new Date(rescheduleDate).getTime())) {
      alert("Invalid date. Please provide a valid date.");
      return;
    }
    // Format the reschedule date into a readable format
    const formattedDate = new Date(rescheduleDate)
      .toISOString()
      .slice(0, 19)
      ?.replace("T", " ");
    // Data to save
    const [date, time] = formattedDate.split(" "); // Split into date and time

    // Log data to the console (optional)
    console.log("Rescheduled Data:", date, time, Detailsiuddata, notes);
    try {
      // Define the request payload
      const payload = {
        action: "reschedule_appointment", // Fixed value to identify the action
        api_key: 1, // Your system's API key for authentication
        order_id: Detailsiuddata, // The ID of the appointment to reschedule
        notes: notes, // Any notes about the reschedule
        date: date, // New date (YYYY-MM-DD format)
        time: time, // New time (HH:mm format)
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_reshedule.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data.status === "true") {
        const services = response.data;
        setSuccessMessage("Appointment Reschdule successfully!");
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      getappointmentdetails();
      bookeddata();
      setRescheduledData(response.data);
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
    closeRescheduleModal();
  };

  const handleRejectClick = () => {
    setShowForm(!showForm); // Toggle form visibility
  };

  const handleReject = async (id, e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Reject Reason:", rejectReason, id);
    // Add your logic here to handle the reject reason
    try {
      // Define the request payload
      const payload = {
        action: "reject_appointment", // Action to fetch all services
        api_key: 1,
        order_id: id,
        reject_reason: rejectReason,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_reject.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);
      // Check if the response contains valid data
      if (response.data.status === "true") {
        const services = response.data;
        setSuccessMessage("Appointment rejected successfully!");
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      getappointmentdetails();
      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }

    setShowForm(false); // Close the form after submission
  };

  const handlePaymentChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleBedroomChange = (unitId, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [unitId]: value,
    }));
    setBedroom((prevSelections) => ({
      ...prevSelections,
      [unitId]: value,
    }));
  };
  const addItemToBill = (id, itemName, quantity, pricePerItem, serviceTitle) => {
    setBookingBill((prevBill) => {
      // Find if the item already exists in the bill
      const existingItemIndex = prevBill.findIndex(
        (item) => item.unit_id === id && item.name === itemName
      );
  
      let updatedBill;
  
      if (existingItemIndex !== -1) {
        // If the item exists, replace it with the new quantity
        updatedBill = [...prevBill];
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            method_id: selectedMethod.method_id,
            service_id: selectedService,
            unit_id: id,
            type: "unit",
            name: itemName,
            service_title: serviceTitle,
            qty: quantity, // Replace the old quantity with the new one
            rate: quantity * pricePerItem, // Recalculate the price
          };
        } else {
          // If quantity is 0, remove the item
          updatedBill.splice(existingItemIndex, 1);
        }
      } else if (quantity > 0) {
        // If the item doesn't exist and quantity > 0, add it as a new entry
        updatedBill = [
          ...prevBill,
          {
            method_id: selectedMethod.method_id,
            service_id: selectedService,
            unit_id: id,
            type: "unit",
            name: itemName,
            service_title: serviceTitle,
            qty: quantity,
            rate: quantity * pricePerItem,
          },
        ];
      } else {
        // If quantity is 0 and item doesn't exist, return the bill unchanged
        updatedBill = [...prevBill];
      }
  
      // Recalculate total time based on the updated bill
      const newTotalTime = updatedBill.reduce(
        (time, item) => time + (item.qty || 0) * 60,
        0
      );
      setTotalTime(newTotalTime);
  
      return updatedBill;
    });
  };
  const toggleSelection = (unitId, quantity) => {
    setSelectedQty((prevSelectedQtys) => {
      const newSelectedQtys = { ...prevSelectedQtys };
      if (
        newSelectedQtys[unitId] &&
        newSelectedQtys[unitId].includes(quantity)
      ) {
        // If already selected, remove it
        newSelectedQtys[unitId] = newSelectedQtys[unitId].filter(
          (qty) => qty !== quantity
        );
      } else {
        // If not selected, add it
        newSelectedQtys[unitId] = [
          ...(newSelectedQtys[unitId] || []),
          quantity,
        ];
      }
      return newSelectedQtys;
    });
  };
  const editItemToBill = (units_id, itemName, quantity, pricePerItem) => {
    setBookingBill((prevBill) => {
      const existingItemIndex = prevBill.findIndex(
        (item) => item.units_id === units_id && item.type === "method_units"
      );
      let updatedBill = [...prevBill];
  
      if (existingItemIndex !== -1) {
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            s_m_qty: quantity,
            s_m_rate: quantity * parseFloat(pricePerItem),
          };
        } else {
          updatedBill.splice(existingItemIndex, 1);
        }
      } else if (quantity > 0) {
        updatedBill.push({
          type: "method_units",
          service_id: selectedService,
          method_id: selectedMethod?.method_id,
          units_id: units_id,
          name: itemName,
          s_m_qty: quantity,
          s_m_rate: quantity * parseFloat(pricePerItem),
        });
      }
  
      calculateDiscountedTotalEdit(updatedBill);
      return updatedBill;
    });
  };
  const calculateTotal = () => {
    // Existing calculation for first two services
    const existingTotal = bookingBill.reduce(
      (total, item) => total + item.rate,
      0
    );

    // Calculation for third service
    if (selectedService === 3) {
      const propertyTotal =
        propertyQuantities.walls * 10 +
        propertyQuantities.doors * 10 +
        propertyQuantities.windows * 10 +
        damagedFloors * 10 +
        doorJams * 10;
      const areaTotal = area * 2 + extraDamagedFloors * 10 + extraDoorJams * 10;
      return existingTotal + propertyTotal + areaTotal;
    }
    if (selectedService === 4) {
      const officeTotal =
        (officeQuantities.rooms || 0) * 10 +
        (officeQuantities.bathrooms || 0) * 10 +
        (officeQuantities.kitchens || 0) * 10 +
        (packing || 0) * 10 +
        (storeroom || 0) * 10;

      const areaTotal =
        (officearea || 0) * 2 +
        (officeextraDamagedFloors || 0) * 10 +
        (officeextraDoorJams || 0) * 10;

      return existingTotal + officeTotal + areaTotal;
    }
    return existingTotal;
  };
  const calculateTotalEdit = () => {
    const existingTotal = bookingBill.reduce(
      (total, item) => total + item.s_m_rate,
      0
    );
    return existingTotal;
  };
  const calculateDiscountedTotal = () => {
    const total = calculateTotal(); // Get the total price
    setsubtotale(total);
    if (isNaN(total)) {
      console.error("Total calculation resulted in NaN:", total);
      return 0; // Return 0 if the total is invalid
    }
    const discountPercentage = selectedDiscount; // Get the discount based on the frequency
    const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
    const totalAfterDiscount = total - discountAmount; // Subtract the discount from the total
    // const text = totalAfterDiscount + 10 ;
    const taxsum = total === 0 ? 0 : 10;

    console.log(promoDiscount);

    const finalTotal = totalAfterDiscount - promoDiscount + taxsum;
    console.log(
      "finalTotal",
      totalAfterDiscount,
      promoDiscount,
      taxsum,
      finalTotal
    );
    setDisamount(discountAmount ? discountAmount : 0);
    settax(taxsum ? taxsum : 0);
    setText(finalTotal ? finalTotal : 0);

    return totalAfterDiscount;
  };
  const calculateDiscountedTotalEdit = () => {
    const total = calculateTotalEdit(); // Get the total price
    setsubtotale(total);
    if (isNaN(total)) {
      console.error("Total calculation resulted in NaN:", total);
      return 0; // Return 0 if the total is invalid
    }
    const discountPercentage = selectedDiscount; // Get the discount based on the frequency
    const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
    const totalAfterDiscount = total - discountAmount; // Subtract the discount from the total
    // const text = totalAfterDiscount + 10 ;
    const taxsum = total === 0 ? 0 : 10;
    console.log(promoDiscount);
    const finalTotal = totalAfterDiscount - promoDiscount + taxsum;
    console.log(
      "finalTotal",
      totalAfterDiscount,
      promoDiscount,
      taxsum,
      finalTotal
    );
    setDisamount(discountAmount ? discountAmount : 0);
    settax(taxsum ? taxsum : 0);
    setText(finalTotal ? finalTotal : 0);

    return totalAfterDiscount;
  };
  const handaldeleted = async (id) => {
    setLoading(true);
    try {
      // Define the request payload
      const payload = {
        action: "delete_booking", // Action to fetch all services
        api_key: 1,
        order_id: id,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data.status === "true") {
        const services = response.data;
        setSuccessMessage("Appointment Delete successfully!");
        console.log(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      getappointmentdetails();
      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handalconfirm_appointment = async (id) => {
    setLoading(true);
    console.log(id, "DADSA");
    try {
      // Define the request payload
      const payload = {
        action: "confirm_appointment", // Action to fetch all services
        api_key: "1",
        order_id: id,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_confirm.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );
      console.log(response);
      // Check if the response contains valid data
      if (response.data.status == "true") {
        const services = response.data;
        setSuccessMessage("Appointment confirmed successfully!");
        console.log(services);
        setIsBookingComplete(true);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      getappointmentdetails();

      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const handalapointment_complete = async (id) => {
    setLoading(true);
    console.log(id, "DADSA");
    try {
      // Define the request payload
      const payload = {
        action: "complete_appointment", // Action to fetch all services
        api_key: "1",
        order_id: id,
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/appointment_complete.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);

      // Check if the response contains valid data
      if (response.data.status === "true") {
        const services = response.data;
        setSuccessMessage("Appointment completed successfully!");
        console.log(services);
        setIsBookingComplete(true);
      } else {
        console.log("API response indicates failure:", response.data);
      }
      getappointmentdetails();
      bookeddata();
      handleCloseModal();
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const crmget = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BaseUrl}/backend/api/add_customer.php?action=getuser`
      );

      console.log(response);
      if (response.data.status === "true") {
        setcrmgetdata(response.data.data);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    } finally {
      setLoading(false); // Ensure loading stops in all case
    }
  };

  const calendardata = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BaseUrl}/backend/api/services.php?action=week_days_available`
      );

      console.log(response);
      if (response.data.status === "true") {
        setcalenderdata(response.data.data);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const generateTimeSlots = async () => {
      const today = new Date();
      const currentWeek = Math.ceil(today.getDate() / 7); // Week of the month (1st, 2nd, etc.)
      const currentDayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, etc.
      console.log(currentWeek, currentDayOfWeek);

      // Filter schedule for the current week and weekday
      const selectedSchedule = calenderdata.find(
        (schedule) => schedule.provider_schedule_type === "weekly"
      );
      console.log(selectedSchedule);
      if (!selectedSchedule) {
        setTimeSlots([]); // If no schedule for the day, return empty slots
        return;
      }
      const dayStartTime = selectedSchedule.day_start_time;
      const dayEndTime = selectedSchedule.day_end_time;
      const slotDurationMinutes = 30;
      const startTime = new Date(`1970-01-01T${dayStartTime}Z`);
      const endTime = new Date(`1970-01-01T${dayEndTime}Z`);
      const slots = [];
      let currentTime = new Date(startTime);
      let slotId = 1;

      while (currentTime < endTime) {
        const slotStart = new Date(currentTime);
        const slotEnd = new Date(
          currentTime.getTime() + slotDurationMinutes * 60000
        );
        const formatTime = (time) => {
          let hours = time.getUTCHours();
          let minutes = time.getUTCMinutes().toString().padStart(2, "0");
          let period = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          return `${hours}:${minutes} ${period}`;
        };
        const isToday =
          today.toDateString() === new Date(selectedDate).toDateString();
        const isPastSlot =
          isToday &&
          (today.getHours() > slotEnd.getUTCHours() ||
            (today.getHours() === slotEnd.getUTCHours() &&
              today.getMinutes() > slotEnd.getUTCMinutes()));

        slots.push({
          slot_id: slotId,
          slot_start: formatTime(slotStart),
          slot_end: formatTime(slotEnd),
          disabled: isPastSlot,
        });
        currentTime = slotEnd;
        slotId += 1;
      }
      setTimeSlots(slots);
    };
    generateTimeSlots();
    const interval = setInterval(generateTimeSlots, 60000);
    return () => clearInterval(interval);
  }, [selectedDate]);
  useEffect(() => {
    calendardata();
  }, []);
  useEffect(() => {
    crmget();
  }, []);

  useEffect(() => {calculateDiscountedTotal();  }, [
    promoDiscount,selectedService,bookingBill,propertyQuantities,area, damagedFloors,
    doorJams,officeQuantities,officearea,packing,storeroom, ]);

  useEffect(() => {  calculateDiscountedTotalEdit(); }, [
    selectedService,bookingBill, propertyQuantities,area,damagedFloors,
    doorJams,officeQuantities, officearea, packing,storeroom, ]);

  useEffect(() => {
    const fetchAdminData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${BaseUrl}/backend/api/services.php?action=getadmindata`
        );
        console.log(response);
  
        if (response.data.status === "true") {
          const filteredAdminData = response.data.data.filter((provider) => {
            const serviceIdsArray = provider.service_ids
              .split(",")
              .map((id) => id.trim());
          
            const matchesService = selectedService
              ? serviceIdsArray.includes(selectedService.toString())
              : true;
          
            const bookingEnabled = provider.enable_booking === "Y";
          
            return matchesService && bookingEnabled;
          });
          console.log(filteredAdminData)
            setAdminData(filteredAdminData); // Set filtered data
        } else {
          console.log(response.data.message);
        }
      } catch (err) {
        console.error("An error occurred while fetching data:", err);
        setError("Failed to fetch admin data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchAdminData();
  }, [selectedService]); 

  useEffect(() => {
    // Update bedrooms and bathrooms directly in the bill
    const updateOrAddToBill = (itemName, quantity, pricePerItem) => {
      const existingItemIndex = bookingBill.findIndex(
        (item) => item.name === itemName
      );

      if (existingItemIndex !== -1) {
        const updatedBill = [...bookingBill];
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            quantity,
            price: quantity * pricePerItem,
          };
        } else {
          updatedBill.splice(existingItemIndex, 1); // Remove the item if quantity is zero
        }
        setBookingBill(updatedBill);
      } else if (quantity > 0) {
        setBookingBill([
          ...bookingBill,
          { type: itemName, qty: quantity, rate: quantity * pricePerItem },
        ]);
      }
    };

    updateOrAddToBill("Bedrooms", bedroom, 5);
    updateOrAddToBill("Bathrooms", bathroom, 5);
  }, [bedroom, bathroom]);

  useEffect(() => {
    if (selectedService === 3) {
      // Initialize or reset variables related to Service 3
      setPropertyQuantities({
        walls: 0,
        doors: 0,
        windows: 0,
      });
      setDamagedFloors(0);
      setDoorJams(0);
      setArea(0);
      setExtraDamagedFloors(0);
      setExtraDoorJams(0);
    }
  }, [selectedService]); // Whenever `selectedService` changes handaldeleted  deleteallbooking

  useEffect(() => {
    if (selectedService === 4) {
      // Initialize or reset variables related to Service 4
      setOfficeQuantities({
        rooms: 0,
        bathrooms: 0,
        kitchens: 0,
      });
      setPacking(0);
      setStoreroom(0);
      setOfficeArea(0);
      setofficeExtraDamagedFloors(0);
      setofficeExtraDoorJams(0);
    }
  }, [selectedService]); // Whenever `selectedService` changes

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Log the value for the selected bedroom
    if (name === "bedroomCount") {
      console.log(`Selected Bedroom: ${value}`);
    }
  };

  const generateCalendar = (year, month) => {
    const date = new Date(year, month);
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const startDay = new Date(year, month, 1).getDay();
    const calendar = [];

    let currentDay = 1;

    for (let week = 0; week < 6; week++) {
      const weekDays = [];

      for (let day = 0; day < 7; day++) {
        if (week === 0 && day < startDay) {
          weekDays.push(null);
        } else if (currentDay <= daysInMonth) {
          weekDays.push(currentDay);
          currentDay++;
        } else {
          weekDays.push(null);
        }
      }

      calendar.push(weekDays);
    }

    return calendar;
  };

  const calendar = generateCalendar(
    currentDate.getFullYear(),
    currentDate.getMonth()
  );
  useEffect(() => {
    const fetchedUserId = sessionStorage.getItem("userId");
    console.log("Fetched userId:", fetchedUserId); // Check what is logged
    if (fetchedUserId) {
      setUserId(fetchedUserId);
    }
  }, []);
  const fetchTimeSlots = async (date) => {
    // Pehle check karo ke staff_id (userId) available hai ya nahi
    if (!getidbyadmin) {
      alert("Staff ID missing! Please select a provider.");
      return;
    }
    if (!date) {
      alert("Please select a date.");
      return;
    }
    const formattedDate = format(date, "dd-MM-yyyy");
    const payload = {
      action: "get_slots",
      api_key: "1",
      selected_date: formattedDate,
      staff_id: getidbyadmin, // Ensure ID is present
    };
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/slots.php`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data.response);
      setTimeSlots(response.data.response);
    } catch (error) {
      console.error("Error fetching time slots:", error);
      alert(response.data.response)
      setTimeSlots([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedDate && userId) {
      fetchTimeSlots(selectedDate);
    }
  }, [selectedDate, userId]); // Make sure it depends on both selectedDate and userId

  const renderRatingStars = (rating) => {
    return (
      <div className="flex items-center space-x-1">
        {[1, 2, 3, 4, 5].map((star) => {
          const isFilled = star <= Math.floor(rating);
          const isHalfFilled = star === Math.floor(rating) + 1 && rating % 1 !== 0;
          return (
            <span key={star} className="text-lg text-yellow-500">
              {isFilled ? (
                <FontAwesomeIcon icon={fullStar} />
              ) : isHalfFilled ? (
                <FontAwesomeIcon icon={faStarHalfAlt} />
              ) : (
                <FontAwesomeIcon icon={emptyStar} className="text-gray-300" />
              )}
            </span>
          );
        })}
      </div>
    );
  };

  const handleDateClick = (day) => {
    setDaySelected(day);
    if (day) {
      const selectedDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        day
      );

      // Compare only the date (year, month, day) without time, ensuring past dates are blocked
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time part to compare just the date

      if (selectedDay < today) {
        alert("Sorry, past date booking is not possible.");
        return;
      }

      // Format the date to MM/DD/YYYY
      const formattedDate = selectedDay.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
      const key = formattedDate; // Use formattedDate as the key
      if (bookedSlots[key]?.length === timeSlots.length) {
        alert("Sorry, this date's time slots are fully booked.");
        return;
      }

      setSelectedDate(key);
      setSelectedTime(null);
      setShowForm(false); // Hide form initially
    }
  };
  const handleTimeSelect = (time) => {
    console.log(time, "D");
    setSelectedTime(time); // Store selected time
    console.log("Selected Time:", time);
  };
  const today = new Date();
  const toggleCalendarPanel = () => {
    setIsCalendarOpen((prev) => !prev); // Toggle this panel
    if (!isCalendarOpen) {
      // If opening this panel
      setIsServiceOpen(false); // Close others
      setIsFormOpen(false);
    }
  };

  const toggleFormPanel = () => {
    setIsFormOpen((prev) => !prev); // Toggle this panel
    if (!isFormOpen) {
      // If opening this panel
      setIsServiceOpen(false); // Close others
      setIsCalendarOpen(false);
    }
  };
  useEffect(() => {
    const userId = sessionStorage.getItem("userId"); // Retrieve user ID from localStorage
    console.log("Retrieved userId from localStorage: ", userId);
    if (userId) {
      // fetchAppointments(userId); // Fetch appointments
      getservicesdata(); // Fetch services
    } else {
      console.log("No user ID found, handle accordingly");
      // setLoading(false); // Stop loading spinner if no user ID
    }
  }, [showEditServiceModal]);

  const getbooking = async (id) => {
    if (!id) {
      console.error("❌ No order_id provided for get_service_cart_list API");
      return null;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        {
          action: "get_service_cart_list",
          api_key: "1",
          order_id: id,
        }
      );

      if (response.status === 200 && response.data.status === "true") {
        return response.data.response; // Return fresh data
      } else {
        console.error("❌ Unexpected response:", response.data);
        return null;
      }
    } catch (error) {
      console.error("🚨 Error fetching get_service_cart_list:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };
  const parseCurrency = (str) => {
    if (!str || typeof str !== "string") return 0;
    return parseFloat(str.replace(/[^0-9.-]+/g, "")) || 0;
  };
  const totalAmount = parseCurrency(allsetdata?.total_amount); // ₹82.00 -> 82
  const discountAmount = parseCurrency(allsetdata?.discount); // ₹8.00 -> 8
  const taxAmount = parseCurrency(allsetdata?.cart_tax); // ₹10.00 -> 10
  // const frequentDiscount = parseCurrency(allsetdata?.frequent_discount); // - ₹1.00 -> -1
  const frequencyMapData = {
    Once: 0,
    Weekly: 15,
    "Bi-Weekly": 12.5,
    Monthly: 10,
  };
  const total = calculateTotalEdit(); // Sum of s_m_rate from bookingBill
  const subTotalEdit = total; // Use bookingBill total instead of totalAmount
  // const discountedTotal = discountAmount + Math.abs(frequentDiscount); // Combine discount and frequent_discount
  console.log(allsetdata?.discount_typename)
  const discountedTotal = subTotalEdit / frequencyMapData[allsetdata?.discount_typename] ; // Combine discount and frequent_discount
  const finelamount = subTotalEdit - discountedTotal + taxAmount;
  console.log({
    totalAmount,
    discountAmount,
    taxAmount,
    // frequentDiscount,
    total,
    subTotalEdit,
    discountedTotal,
    finelamount,
  });
  const openEditServiceModal = async (id) => {
    setLoading(true);
    setorder_id_appointment(detailsdata.id);
    setBookingBill([]);
    setTotalTime(0);
    setSelectedService(null);
    setSelectedMethod(null);
    setUserSelectedMethods([]);
    setUserSelectedMethodsId([]);
    setUserSelectedMethodsUnitsId([]);
    setUserSelectedMethodsSmqty([]);
    setUserSelectedAddon([]);
    setQuantities([0, 0, 0]);
    setallsetdata(null);

    try {
      const bookingResponse = await getbooking(detailsdata.id);
      if (bookingResponse) {
        setallsetdata(bookingResponse);
        setSelectedAppointment(bookingResponse);
        setShowEditServiceModal(true);

        // Extract cart items and service/method details
        const cartItems = bookingResponse.cart_items || [];
        const serviceIds = [...new Set(cartItems.map(item => item.service_id))];
        const methodIds = cartItems
          .filter(item => item.type === "method_units")
          .map(item => item.method_id);
        const unitsIds = cartItems.map(item => item.units_id);
        const s_m_qty = cartItems.map(item => parseInt(item.s_m_qty) || 0);
        const addonIds = cartItems
          .filter(item => item.type === "addon")
          .map(item => item.units_id);

        // Set selected service and method
        setUserSelectedMethods(serviceIds);
        setUserSelectedMethodsId(methodIds);
        setUserSelectedMethodsUnitsId(unitsIds);
        setUserSelectedMethodsSmqty(s_m_qty);
        setUserSelectedAddon(addonIds);

        setSelectedService(serviceIds[0] || bookingResponse.service_id);
        const selectedServiceData = services.find(
          s => s.service_id === serviceIds[0]
        );
        const selectedMethodData = selectedServiceData?.methods.find(
          m => methodIds.includes(m.method_id)
        );
        if (selectedMethodData) {
          handleMethodSelection(selectedMethodData, selectedMethodData.method_id);
        }

        // Initialize bookingBill from cart_items
        const newBookingBill = cartItems.map(item => ({
          type: item.type,
          service_id: item.service_id,
          method_id: item.method_id || null,
          units_id: item.units_id,
          name: item.method_name || item.addon_name || "Unknown",
          s_m_qty: parseInt(item.s_m_qty) || 0,
          s_m_rate: parseFloat(item.s_m_rate) || 0,
        }));
        setBookingBill(newBookingBill);

        // Initialize addon quantities
        const addonQuantities = selectedServiceData?.addons?.map(addon => {
          const addonItem = cartItems.find(
            item => item.type === "addon" && item.units_id === addon.addon_id
          );
          return addonItem ? parseInt(addonItem.s_m_qty) || 0 : 0;
        }) || [0, 0, 0];
        setQuantities(addonQuantities);

        // Calculate financials
        const subtotal = cartItems.reduce(
          (sum, item) => sum + (parseFloat(item.s_m_rate) || 0),
          0
        );
        const discountType = bookingResponse.discount_typename || selectedFrequency;
        const discountPercentage = frequencyMap[discountType] || 0;
        const calculatedDiscount = subtotal * (discountPercentage / 100);
        const tax = parseCurrency(bookingResponse.cart_tax) || 0;
        const total = subtotal - calculatedDiscount + tax;

        setsubtotale(subtotal);
        setDisamount(calculatedDiscount);
        settax(tax);
        settotelamount(subtotal);
        setfinelamount(total);
        setdiscountedTotal(calculatedDiscount);

        // Set total time
        setTotalTime(parseInt(bookingResponse.order_duration) || 0);
      }
    } catch (error) {
      console.error("Error fetching booking:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddonSelection = (addonId) => {
    // Check if the add-on is already selected
    if (userSelectedAddon.includes(addonId)) {
      // If selected, remove it
      setUserSelectedAddon(userSelectedAddon.filter((id) => id !== addonId));
    } else {
      // If not selected, add it
      setUserSelectedAddon([...userSelectedAddon, addonId]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);
    if (!hasAtLeastOneUnit) {
      alert("You must select at least one unit.");
      setLoading(false);
      return;
    }
    if (!isChecked) {
      alert("Please accept the Terms & Conditions before proceeding.");
      return;
    }

    setLoading(true);

    const formattedData = {
      action: "book_appointment",
      api_key: "1",
      user_id: userDetails.id || useriddata,
      staff_id: selectedProvider?.id || "",
      payment_method: paymentMethod,
      // sub_total: subtotale,
      sub_total: promoDiscount ? subtotale - promoDiscount : subtotale,

      discount: Disamount,
      order_duration: totalTime,
      tax: tax,
      booking_date_time: `${selectedDate} ${selectedTime}`,
      service_id: selectedService,
      method_id: selectedMethod?.method_id,
      cart_detail: bookingBill,
      net_amount: text,
      recurrence_id: selectedservices,
      freq_discount_amount: 1,
    };

    console.log("Formatted Booking Data:", formattedData);

    try {
      axios
        .post(`${BaseUrl}/backend/api/book_appointment.php`, formattedData, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log(response.data.status);
          if (response.data.status === "true") {
            setSuccessMessage("Appointment Add successfully!");
              if (idpromocode) {
                        const promoData = {
                          action: "increment_coupon_used",
                          api_key: "1",
                          coupon_id: idpromocode
                        };
            
                        axios
                          .post("http://10.27.1.104/megaclean(20-03-2025)/megaclean/backend/api/promocode.php", promoData, {
                            headers: {
                              "Content-Type": "application/json",
                            },
                          })
                          .then((promoResponse) => {
                            console.log("Promocode incremented successfully:", promoResponse.data);
                          })
                          .catch((promoError) => {
                            console.error("Error incrementing promocode:", promoError);
                            // Note: Not showing alert here to avoid disrupting user experience
                          });
                      }
            console.log(response.data.status);
          } else {
            console.log(response.data.response);
          }

          handleClosebookingSummary();
          bookeddata();
        })
        .catch((error) => {
          console.error("Error occurred while submitting:", error);
          alert("There was an error submitting the form. Please try again.");
        });
    } catch (error) {
      console.error("Unexpected error:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitEdit = async () => {

    setLoading(true);
    const hasAtLeastOneUnit = bookingBill.some(item => item.method_id);
    if (!hasAtLeastOneUnit) {
      alert("You must select at least one unit.");
      setLoading(false);
      return;
    }

    const formattedBookingBill = bookingBill.map(item => ({
      type: item.type || "method_units",
      service_id: selectedService,
      method_id: item.method_id,
      units_id: item.units_id,
      s_m_qty: item.s_m_qty,
      s_m_rate: item.s_m_rate,
    }));

    const frequencyMapIds = { Once: 1, Weekly: 2, "Bi-Weekly": 3, Monthly: 4 };
    const frequent_discount1 = allsetdata?.discount_typename || selectedFrequency;
    setDisType(allsetdata?.discount_typename)
    const discountID = frequencyMapIds[frequent_discount1] || null;

    const formattedData = {
      action: "edit_booking_info",
      api_key: "1",
      order_id: order_id_appointment,
      amount: subtotale.toFixed(2),
      taxes: tax.toFixed(2),
      discount: Disamount.toFixed(2),
      net_amount: finelamount.toFixed(2),
      frequent_discount: discountID,
      frequent_discount_amount: "0.00",
      ct_cart: { method: formattedBookingBill },
      time_duration: totalTime.toString(),
    };

    try {
      const response = await axios.post(`${BaseUrl}/backend/api/book_appointment.php`, formattedData);
      if (response.data.status === "true") {
        setSuccessMessage("Appointment Updated Successfully!");
        const updatedBookingData = await getbooking(order_id_appointment);
        if (updatedBookingData) {
          setallsetdata(updatedBookingData);
          setAppointments(prev => prev.map(appointment =>
            appointment.order_id === order_id_appointment ? { ...appointment, ...updatedBookingData } : appointment
          ));
        }
        setShowEditServiceModal(false);
      }
      handleClosebookingSummary();
    } catch (error) {
      console.error("Error updating booking:", error);
      // alert("An error occurred while updating the booking.");
    } finally {
      setLoading(false);
    }
    handleClosebookingSummary()
  };

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);

  // Function to navigate to next month or week
  const nextMonth = () => {
    if (activeView === "month") {
      setCurrentMonth(addMonths(currentMonth, 1)); // Navigate to the next month
    } else if (activeView === "week") {
      const nextWeekStart = addDays(endOfWeek(currentMonth), 1); // Go to the start of the next week
      setCurrentMonth(nextWeekStart);
    }
  };

  // Function to navigate to the next day
  const nextDay = () => {
    setCurrentMonth(addDays(currentMonth, 1)); // Navigate to the next day
  };

  // Function to navigate to the previous day
  const prevDay = () => {
    setCurrentMonth(subDays(currentMonth, 1)); // Navigate to the previous day
  };
  // Function to navigate to previous month or week
  const prevMonth = () => {
    if (activeView === "month") {
      setCurrentMonth(subMonths(currentMonth, 1)); // Navigate to the previous month
    } else if (activeView === "week") {
      const prevWeekStart = subDays(startOfWeek(currentMonth), 1); // Go to the start of the previous week
      setCurrentMonth(prevWeekStart);
    }
  };
  const renderDaysInMonth = () => {
    const startDate = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      1
    );
    const endDate = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      0
    );
    const days = [];
    let dayIndex = startDate.getDay();
    let dayOfMonth = 1;

    const today = new Date();
    const todayDate = format(today, "yyyy-MM-dd");

    while (dayIndex > 0) {
      days.push(<div key={`empty-${dayIndex}`} className="p-4 border"></div>);
      dayIndex--;
    }

    while (dayOfMonth <= endDate.getDate()) {
      const date = new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth(),
        dayOfMonth
      );

      console.log(bookingappointment)
      const eventsForDay = bookingappointment.filter(
        (event) =>
          format(event?.booking_date_time, "yyyy-MM-dd") ===
          format(date, "yyyy-MM-dd")
      );
      const isToday = format(date, "yyyy-MM-dd") === todayDate;
      const isPastDate = format(date, "yyyy-MM-dd") < todayDate;
      const eventsToShow = eventsForDay.slice(0, 4);
      const remainingEvents = eventsForDay.length - 1;
      console.log(eventsForDay)
      days.push(
        <div
          key={dayOfMonth}
          className={`p-1 border border-gray-300 h-32 relative ${
            isToday ? "bg-gray-200" : ""
          } ${isPastDate ? "bg-gray-200" : ""}`}
          onClick={
            !isPastDate
              ? () => handleShowBookingSummary2(date)
              : () => alert("You can't select a past date")
          }
        >
          <p
            className={clsx("text-center", {
              " text-center rounded-full bg-blue-700 text-white w-8 h-8 flex items-center justify-center mx-auto font-bold":
                isToday,
            })}
          >
            {dayOfMonth}
          </p>
          {eventsForDay.length > 0 && (
            
            <div className="absolute bottom-0 left-0 w-full px-2 py-1 space-y-1">
              {/* Show first THREE events only */}
              
              {eventsForDay.slice(0, 2).map((event, index) => {
                
                const shortTitle =
                  event.title && event.title.length > 2
                    ? `${event.title.slice(0, 2)}...`
                    : event.title;

                return (
                  <button
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShowModal(event);
                      setDetailsiud(event.order_id);
                    }}
                    className="relative group text-sm bg-customlightGreen text-blue-700 px-2 py-1 rounded mb-1 w-full text-left" >
                  {/* <span className="absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-2 text-sm font-medium bg-black text-white rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition duration-200 z-50 whitespace-nowrap">
                    Edit Right Now click
                  </span>  */}
              <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-0.5 text-xs bg-gray-800 text-white rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
  ✏️ Edit – Right now
</span>

                    {/* Mobile view: hidden on md+ */}
                    <span className="block md:hidden">{shortTitle || "Details"}</span>
                    {/* Laptop/Desktop view: hidden on mobile */}
                    <span className="hidden md:block">{event.title || "Details"}</span>
                  </button>
                );
              })}
              {/* +More button that shows a popup with all remaining events */}
              {eventsForDay.length > 2 && (
                <button
                  className="text-xs text-blue-500 w-full text-center relative"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAllEvents(!showAllEvents);
                  }}>
                +{eventsForDay.length - 2} More
                  {/* Popup that shows all remaining events */}
                  {showAllEvents && (
                    <div className="absolute bottom-full left-0 bg-white text-black p-4 rounded-lg shadow-lg z-30 border border-gray-200 w-64 mb-2">
                      <div className="flex justify-between items-center mb-2 border-b pb-1">
                        <h3 className="font-bold text-lg">All Events</h3>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowAllEvents(false);
                          }}
                          className="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded"
                        >
                          Close
                        </button>
                      </div>

                      <div className="max-h-64 overflow-y-auto">
                        {eventsForDay.slice(2).map((event, index) => (
                          <div
                            key={index}
                            className="border-b py-2 last:border-0"
                          >
                            <div className="flex justify-between items-center">
                              <h4 className="font-medium">
                                {event.title || "Appointment"}
                              </h4>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShowModal(event);
                                  setDetailsiud(event.order_id);
                                  setShowAllEvents(false);
                                }}
                                className="text-xs bg-blue-600 text-white px-3 py-1 rounded mt-2"
                              >
                                View Details
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </button>
              )}
            </div>
          )}
        </div>
      );
      dayOfMonth++;
    }
    return days;
  };

  const renderWeekView = () => {
    const weekStart = startOfWeek(currentMonth, { weekStartsOn: 0 });
    const weekEnd = endOfWeek(currentMonth, { weekStartsOn: 0 });
    const weekDays = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
    const formattedRange = `${format(weekStart, "MMM d")} — ${format(
      weekEnd,
      "MMM d, yyyy"
    )}`;
    const today = new Date();
    const todayDate = format(today, "yyyy-MM-dd");

    return (
      <div className="w-full mx-auto ">
        <div className="grid grid-cols-8 border border-gray-300 text-center text-sm font-semibold bg-gray-50">
          <div className="col-span-1 border border-gray-200"></div>
          {weekDays.map((date, index) => {
            const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
            return (
              <div
                key={index}
                className={`py-2 border lg:text-base md:text-base border-gray-200 min-[320px]:text-[11px] max-[640px]:text-[11px] ${
                  isToday ? "bg-blue-100 font-bold" : ""
                }`}
              >
                {`${daysOfWeek[date.getDay()]} ${format(date, "MM/dd")}`}
              </div>
            );
          })}
        </div>
        <div className="grid grid-cols-8 divide-x border border-gray-300 text-sm">
          <div className="border-r border-gray-300">
            {hours.map((hour, index) => (
              <div
                key={index}
                className="h-16 flex items-center justify-end pr-2 border-b border-gray-300"
              >
                {hour}
              </div>
            ))}
          </div>
          {weekDays.map((date, dayIndex) => {
            const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
            const isPastDate = format(date, "yyyy-MM-dd") < todayDate; // Check if it's a past date
            return (
              <div
                key={dayIndex}
                className={`border-b border-gray-300 ${
                  isToday ? "bg-blue-50" : ""
                }`}
                onClick={
                  !isPastDate
                    ? () => handleShowBookingSummary2(date)
                    : () => alert("You can't select a past date")
                }
              >
                {hours.map((hour, hourIndex) => {
                  // Corrected hour calculation based on the `date`
                  const hourStart = format(addHours(date, hourIndex), "HH:00"); // Use `date` here instead of `new Date()`
                  const hourEnd = format(
                    addHours(date, hourIndex + 1),
                    "HH:00"
                  );
                  // Filter events for the current hour (for the given date and hour)
                  const eventsForHour = bookingappointment.filter((event) => {
                    const eventDateTime = format(
                      new Date(event?.booking_date_time),
                      "yyyy-MM-dd HH:00"
                    ); // Full date and hour
                    const checkDateTime =
                      format(date, "yyyy-MM-dd") + " " + hourStart;
                    return eventDateTime === checkDateTime;
                  });

                  return (
                    <div
                      key={hourIndex}
                      className={`h-16 border-b border-gray-300 ${
                        isToday
                          ? "bg-blue-100"
                          : hourIndex % 2 === 0
                          ? "bg-gray-50"
                          : "bg-white"
                      }`}
                    >
                      {/* Render event buttons for this hour */}
                      {eventsForHour.length > 0 && (
                        <div className="space-y-1">
                          {eventsForHour.map((event, eventIndex) => (
                            <button
                              key={eventIndex}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleShowModal(event); // Show modal with event details
                                setDetailsiud(event.order_id); // Set the event's order_id
                              }}
                              className="text-xs bg-customlightGreen text-blue-700 px-2 py-1 rounded mb-1"
                            >
                              {event.title || "Details"}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  const renderDayView = () => {
    const day = currentMonth; // Assuming currentMonth is the date representing the current day view
    const formattedDay = format(day, "EEEE, MMM d, yyyy");
    const today = new Date();
    const todayDate = format(today, "yyyy-MM-dd");
    const isToday = format(day, "yyyy-MM-dd") === todayDate;
    const isFutureDate = format(day, "yyyy-MM-dd") > todayDate;
    return (
      <div className="w-full mx-auto">
        <div className="text-center text-lg font-medium">{formattedDay}</div>
        <div className="grid grid-cols-1 divide-y border border-gray-300 text-sm">
          {hours.map((hour, index) => {
            const hourStart = format(addHours(formattedDay, index), "HH:00"); // Calculate start time for each hour
            const hourEnd = format(addHours(formattedDay, index + 1), "HH:00"); // Calculate end time for each hour
            const eventsForHour = bookingappointment.filter((event) => {
              const eventDateTime = format(
                new Date(event?.booking_date_time),
                "yyyy-MM-dd HH:00"
              );
              const checkDateTime =
                format(formattedDay, "yyyy-MM-dd") + " " + hourStart;
              return eventDateTime === checkDateTime;
            });
            return (
              <div
                key={index}
                onClick={
                  isToday || isFutureDate
                    ? () => handleShowBookingSummary2(day)
                    : () => alert("You can't select a past date")
                }
                className={`py-4 flex items-center px-2 text-base border-b border-gray-300 ${
                  isToday ? "bg-blue-100" : ""
                }`}
              >
                <div className="pr-20">{hour}</div>
                {eventsForHour.length > 0 && (
                  <div className="space-y-1">
                    {eventsForHour.map((event, eventIndex) => (
                      <button
                        key={eventIndex}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent event propagation
                          handleShowModal(event); // Show modal with event details
                          setDetailsiud(event.order_id); // Set the event's order_id
                        }}
                        className="text-xs bg-customlightGreen text-blue-700 px-2 py-1 rounded mb-1"
                      >
                        {event.title || "Details"}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const handleShowModal = (event) => {
    console.log(event);
    setSelectedEvent(event);
    setShowModal(true);
    setShowEditModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };
  const handleShowEditModal = () => {
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleShowBookingSummary = () => {
    setShowBookingSummary(true);
  };

  const handleShowBookingSummary2 = () => {
    setShowBookingSummary2(true);
  };
  const handleCloseBookingSummary = () => {
    setShowBookingSummary(false);
    setShowBookingSummary2(false);
  };
  const handleGoToToday = () => {
    setCurrentMonth(new Date()); // Set currentMonth to today's date
  };

  const handlePersonalDetailsChange = (e) => {
    const { name, value } = e.target;
    setPersonalDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // Handle same as above toggle
  const handleSameAsAbove = (e) => {
    setSameAsAbove(e.target.checked);
    if (e.target.checked) {
      setAppointmentDetails(personalDetails);
    }
  };
  // Handle change for appointment details
  const handleAppointmentDetailsChange = (e) => {
    const { name, value } = e.target;
    setAppointmentDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleQuantityChange = (
    idx,
    increment,
    addon_name,
    addon_price,
    max_quantity
  ) => {
    // Update quantities array
    const newQuantities = [...quantities];
    if (increment) {
      if (newQuantities[idx] >= max_quantity) {
        alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
      } else {
        newQuantities[idx] += 1;
      }
    } else {
      newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
    }
    setQuantities(newQuantities);
  
    // Update bookingBill
    const quantity = newQuantities[idx];
    const totalPrice = quantity * addon_price;
  
    setBookingBill((prevBill) => {
      const existingItemIndex = prevBill.findIndex(
        (item) => item.type === addon_name
      );
  
      let updatedBill = [...prevBill];
  
      if (existingItemIndex !== -1) {
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            qty: quantity,
            rate: totalPrice,
            service_id: idx, // Using index as a unique identifier for addon
          };
        } else {
          updatedBill.splice(existingItemIndex, 1);
        }
      } else if (quantity > 0) {
        updatedBill.push({
          type: addon_name,
          qty: quantity,
          rate: totalPrice,
          service_id: idx,
        });
      }
      const newTotalTime = updatedBill.reduce(
        (time, item) => time + (item.qty || 0) * 60,
        0
      );
      setTotalTime(newTotalTime);
  
      return updatedBill;
    });
  };
  const handleQuantityChangeEdit = (idx, increment, addon_name, addon_price, max_quantity) => {
    const newQuantities = [...quantities];
    if (increment) {
      if (newQuantities[idx] >= max_quantity) {
        alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
        return;
      }
      newQuantities[idx] += 1;
    } else {
      newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
    }
    setQuantities(newQuantities);
  
    const quantity = newQuantities[idx];
    const totalPrice = quantity * addon_price;
  
    setBookingBill((prevBill) => {
      const addon = services
        .find((s) => s.service_id === selectedService)
        ?.addons[idx];
      const addonId = addon?.addon_id;
      const existingItemIndex = prevBill.findIndex(
        (item) => item.type === "addon" && item.units_id === addonId
      );
      let updatedBill = [...prevBill];
  
      if (existingItemIndex !== -1) {
        if (quantity > 0) {
          updatedBill[existingItemIndex] = {
            ...updatedBill[existingItemIndex],
            s_m_qty: quantity,
            s_m_rate: totalPrice,
          };
        } else {
          updatedBill.splice(existingItemIndex, 1);
        }
      } else if (quantity > 0) {
        updatedBill.push({
          type: "addon",
          service_id: selectedService,
          method_id: selectedMethod?.method_id || null,
          units_id: addonId,
          name: addon_name,
          s_m_qty: quantity,
          s_m_rate: totalPrice,
        });
      }
  
      calculateDiscountedTotal(updatedBill);
      return updatedBill;
    });
  };
  const getappointmentdetails = async () => {
    setLoading(true);
    try {
      // Define the request payload
      const payload = {
        action: "getbookingdetails", // Action to fetch all services
        order_id: Detailsiud, // API key for authentication
      };
      // ake the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );
      console.log(response);
      // Check if the response contains valid data
      if (response.data) {
        const services = response.data;

        setDetailsdata(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getappointmentdetails();
  }, [Detailsiud]);

  const deleteallbooking = async (id) => {
    setLoading(true);
    try {
      // Define the request payload
      const payload = {
        action: "delete_recurring_booking", // Action to fetch all services
        recurring_id: id,
        api_key: "1", // API key for authentication
      };

      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );
      console.log(response);
      // Check if the response contains valid data
      if (response.data.status === "true") {
        const services = response.data;
        setSuccessMessage("Delete Recurring Booking Successfully!");
        console.log(services);
        // setDetailsdata(services);
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
    bookeddata();
    handleCloseModal();
  };

  useEffect(() => {
    deleteallbooking();
  }, []);

  const getservicesdata = async () => {
    setLoading(true);
    try {
      // Define the request payload
      const payload = {
        action: "all_services", // Action to fetch all services
        api_key: "1", // API key for authentication
      };
      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/services.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );

      console.log(response);
      // Check if the response contains valid data
      if (response.data && response.data.status === "true") {
        const services = response.data;
        console.log(services.response);
        setallServices(services.response);
        setServices(services.response);

        if (Array.isArray(services.response)) {
          console.log("Fetched Data:", services); // Log the fetched data
          // setTableData(services); // Uncomment to update the table
        } else {
          console.log("No valid array in response data:", response.data);
        }
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const bookeddata = async () => {
    setLoading(true);
    try {
      const currentDate = new Date(); // Current date
      // Format the current date in YYYY-MM-DD format (start date)
      const start_date = currentDate.toISOString().split("T")[0];
      // Calculate end date (6 months from the current date)
      const endDate = new Date(currentDate);
      endDate.setMonth(currentDate.getMonth() + 6); // Add 6 months to the current date
      const end_date = endDate.toISOString().split("T")[0]; // Format the end date to YYYY-MM-DD

      // Define the request payload
      const payload = {
        action: "getallbookings", // Action to fetch all services
        api_key: "1", // API key for authentication
        start_date: "2024-01-01",
        end_date: end_date,
      };
      // Make the POST request with the payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/book_appointment.php`,
        payload, // Request body
        {
          headers: {
            "Content-Type": "application/json", // Specify JSON format
          },
        }
      );
      console.log(response);
      // Check if the response contains valid data
      if (response.data && response.data.status === "true") {
        const services = response.data;
        console.log(services.response);

        if (Array.isArray(services.response)) {
          console.log("Fetched Data:", services); // Log the fetched data
          setbookingappointment(services.response);
          // setTableData(services); // Uncomment to update the table
        } else {
          console.log("No valid array in response data:", response.data);
        }
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    bookeddata();
  }, []);

  useEffect(() => {
    getservicesdata();
  }, []);
  useEffect(() => {
    calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
  }, [selectedDiscount]);

  const frequently_discount = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BaseUrl}/backend/api/services.php?action=frequently_discount`
      );
      console.log("Raw Response:", response.data);
      // Parse the response if necessary
      let responseData = response.data;
      if (typeof responseData === "string") {
        try {
          responseData = JSON.parse(responseData.trim()); // Remove extra whitespace and parse
        } catch (error) {
          console.log("Error parsing response data:", error);
          return;
        }
      }
      // Handle the parsed response
      if (responseData.status === "true") {
        const services = responseData.data;
        console.log("Fetched Data:", services);
        setServices_frequently_discount(services); // Update state
      } else {
        console.log("API response indicates failure:", responseData.message);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    frequently_discount();
  }, []);

  const handleApplyPromoCode = () => {
    if (!selectedService || selectedService.length === 0) {
      alert("Please select at least one service");
      return;
    }

    const today = new Date();
    const foundPromo = promoCodes.find(
      (promo) =>
        promo.coupon_code === promoCode &&
        promo.status === "on" &&
        new Date(promo.coupon_expiry) >= today &&
        parseInt(promo.coupon_used) < parseInt(promo.coupon_limit)
    );

    console.log(foundPromo);

    if (foundPromo) {
      setidpromocode(foundPromo.id)
      setAppliedPromoCode(foundPromo);
      const discountValue =
        foundPromo.coupon_type === "P"
          ? (calculateTotal() * parseFloat(foundPromo.coupon_value)) / 100
          : parseFloat(foundPromo.coupon_value);

      console.log(discountValue);
      setPromoDiscount(discountValue);
      setSuccessMessage("Promo code applied successfully!");
      setError("");
    } else {
      setAppliedPromoCode(null);
      setPromoDiscount(0);
      setError("Invalid or expired promo code");
    }
  };

  const handleClick = () => {
    navigate("admin");
  };
  const handleClosebookingSummary = () => {
    setShowBookingSummary(false);
    setShowBookingSummary2(false);
    setShowEditServiceModal(false);

    // Reset states to clear stale data
    setBookingBill([]);
    setTotalTime(0);
    setSelectedService(null);
    setSelectedMethod(null);
    setUserSelectedMethods([]);
    setUserSelectedMethodsId([]);
    setUserSelectedMethodsUnitsId([]);
    setUserSelectedMethodsSmqty([]);
    setUserSelectedAddon([]);
    setQuantities([0, 0, 0]);
    setallsetdata(null);
  };
  const toggleServicePanel = () => {
    setIsServiceOpen((prev) => !prev); // Toggle this panel
    if (!isServiceOpen) {
      // If opening this panel
      setIsCalendarOpen(false); // Close others
      setIsFormOpen(false);
    }
  };
  useEffect(() => {
    const maxAddons = Math.max(
      ...allServices.map((s) => (s.addons ? s.addons.length : 0)),
      extraServices.length
    );
    setQuantities(Array(maxAddons).fill(0));
  }, [allServices]);
  const removeItem = (idx) => {
    setBookingBill((prevBill) => {
      const updatedBill = prevBill.filter((_, index) => index !== idx);
      const removedItem = prevBill[idx];
  
      // Reset the quantity in the quantities array if the removed item is an addon
      if (removedItem.type) {
        const addonIndex = extraServices.findIndex(
          (addon) => addon.name === removedItem.type
        );
        if (addonIndex !== -1) {
          setQuantities((prevQuantities) => {
            const newQuantities = [...prevQuantities];
            newQuantities[addonIndex] = 0; // Reset to 0 when removed
            return newQuantities;
          });
        } else {
          // If the addon is from a service's addons (not extraServices), find it dynamically
          allServices.forEach((service) => {
            if (service.addons) {
              const serviceAddonIndex = service.addons.findIndex(
                (addon) => addon.addon_name === removedItem.type
              );
              if (serviceAddonIndex !== -1) {
                setQuantities((prevQuantities) => {
                  const newQuantities = [...prevQuantities];
                  newQuantities[serviceAddonIndex] = 0; // Reset to 0
                  return newQuantities;
                });
              }
            }
          });
        }
      }
      const newTotalTime = updatedBill.reduce(
        (time, item) => time + (item.qty || 0) * 60,
        0
      );
      setTotalTime(newTotalTime);
  
      return updatedBill;
    });
  };
  const removeItemEdit = (idx) => {
    setBookingBill((prevBill) => {
      const itemToRemove = prevBill[idx];
      const updatedBill = prevBill.filter((_, index) => index !== idx);
      if (itemToRemove.type === "method_units") {
      }
      if (itemToRemove.type === "addon") {
        const addonIndex = services
          .find((s) => s.service_id === selectedService)
          ?.addons.findIndex((a) => a.addon_id === itemToRemove.units_id);
        if (addonIndex !== undefined) {
          setQuantities((prev) => {
            const newQuantities = [...prev];
            newQuantities[addonIndex] = 0;
            return newQuantities;
          });
          setUserSelectedAddon((prev) =>
            prev.filter((id) => id !== itemToRemove.units_id)
          );
        }
      }
  
      return updatedBill;
    });
  };

  const handleMethodSelection = (method, id) => {
    switch ((method.method_title, id)) {
      case "Residential Services":
        setResidential(true);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(false);
        break;
      case "Commercial Services":
        setResidential(false);
        setCommercial(true);
        setofficeResidential(false);
        officesetCommercial(false);
        break;
      case "Property Based":
        setResidential(false);
        setCommercial(false);
        setofficeResidential(true);
        officesetCommercial(false);
        break;
      case "Area Based (Feet)":
        setResidential(false);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(true);
        break;
      default:
        // Reset all states if no match is found
        setResidential(false);
        setCommercial(false);
        setofficeResidential(false);
        officesetCommercial(false);
    }

    setSelectedMethod(method, id);
  };

  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };

  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  const handleUserTypeChange = (value) => {
    setUserType(value); // Set the user type

    if (value === "new") {
      // Reset the form fields for a new user
      setUserDetails({
        id: "",
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        phone: "",
        streetAddress: "",
        zipCode: "",
        city: "",
        state: "",
        specialRequests: "",
      });
    } else if (value === "existing") {
      // Optionally, handle the reset when switching to "Existing User"
      setUserDetails({
        id: optiondata?.id || "",
        email: optiondata?.user_email || "",
        password: optiondata?.user_pwd || "",
        firstName: optiondata?.first_name || "",
        lastName: optiondata?.last_name || "",
        phone: optiondata?.phone || "",
        streetAddress: optiondata?.address || optiondata?.street_address || "",
        city: optiondata?.city || "",
        state: optiondata?.state || "",
        zipCode: optiondata?.zip || "",
        specialRequests: optiondata?.notes || "",
      });
    }
  };

  const handleConfirmClick = (id) => {
    console.log(`Confirming appointment with ID: ${id}`);
    // Add logic for confirming the appointment here
  };

  const handleChangedata = (event) => {
    const selectedId = event.target.value;
    setSelectedOption(selectedId); // Update the selected option

    const selectedUser = crmgetdata.find((user) => user.id === selectedId); // Find the selected user
    setoptiondata(selectedUser);

    if (selectedUser) {
      // Populate the form fields with the selected user's data
      setUserDetails({
        id: selectedUser.id || "",
        email: selectedUser.user_email || "",
        password: selectedUser.user_pwd || "",
        firstName: selectedUser.first_name || "",
        lastName: selectedUser.last_name || "",
        phone: selectedUser.phone || "",
        streetAddress:
          selectedUser.address || selectedUser.street_address || "",
        city: selectedUser.city || "",
        state: selectedUser.state || "",
        zipCode: selectedUser.zip || "",
        specialRequests: selectedUser.notes || "",
      });
    } else {
      // Reset the form if no user is selected
      setUserDetails({
        id: "",
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        phone: "",
        streetAddress: "",
        zipCode: "",
        city: "",
        state: "",
        specialRequests: "",
      });
    }
  };

  const handleUserDetailsChange = (event) => {
    const { name, value } = event.target;
    setUserDetails({ ...userDetails, [name]: value });
  };
  const validateForm = () => {
    const newErrors = {};
    if (!userDetails.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(userDetails.email)) {
      newErrors.email = "Email is invalid";
    }
    // Password Validation
    if (!userDetails.password) {
      newErrors.password = "Password is required";
    } else if (userDetails.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }
    if (!userDetails.firstName) {
      newErrors.firstName = "First Name is required";
    }
    if (!userDetails.lastName) {
      newErrors.lastName = "Last Name is required";
    }
    if (!userDetails.phone) {
      newErrors.phone = "Phone is required";
    }
    if (!userDetails.streetAddress) {
      newErrors.streetAddress = "Street Address is required";
    }
    if (!userDetails.zipCode) {
      newErrors.zipCode = "Zip Code is required";
    }
    if (!userDetails.city) {
      newErrors.city = "City is required";
    }
    if (!userDetails.state) {
      newErrors.state = "State is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
const handleSubmitdata = (e) => {
  e.preventDefault(); // Prevent the default form submission behavior
  const newErrors = {};
  if (!userDetails.email) {
    newErrors.email = "Email is required.";
  } else if (!/\S+@\S+\.\S+/.test(userDetails.email)) {
    newErrors.email = "Please enter a valid email address.";
  }

  if (!userDetails.password) {
    newErrors.password = "Password is required.";
  } else if (userDetails.password.length !== 8) {
    newErrors.password = "Password must be exactly 8 characters.";
  }

  if (!userDetails.firstName) {
    newErrors.firstName = "First Name is required.";
  }

  if (!userDetails.lastName) {
    newErrors.lastName = "Last Name is required.";
  }

  if (!userDetails.phone) {
    newErrors.phone = "Phone number is required.";
  } else if (!/^\d{10}$/.test(userDetails.phone)) {
    newErrors.phone = "Phone number must be exactly 10 digits.";
  }

  if (!userDetails.streetAddress) {
    newErrors.streetAddress = "Street Address is required.";
  }

  if (!userDetails.zipCode) {
    newErrors.zipCode = "Zip Code is required.";
  } else if (!/^\d{6}$/.test(userDetails.zipCode)) {
    newErrors.zipCode = "Zip Code must be exactly 6 digits.";
  }

  if (!userDetails.city) {
    newErrors.city = "City is required.";
  }

  if (!userDetails.state) {
    newErrors.state = "State is required.";
  }
  setErrors(newErrors);
  if (Object.keys(newErrors).length > 0) {
    return;
  }
  setLoading(true);
  const data = {
    action: "add_customerdata",
    api_key: "1",
    email: userDetails.email,
    password: userDetails.password,
    first_name: userDetails.firstName,
    last_name: userDetails.lastName,
    phone: userDetails.phone,
    address: userDetails.streetAddress,
    zipcode: userDetails.zipCode,
    city: userDetails.city,
    state: userDetails.state,
    notes: userDetails.specialRequests,
    vc_status: vacuum === "yes" ? "Y" : "N",
    p_status: parking === "yes" ? "Y" : "N",
    contact_status: access === "home" ? "Active" : access,
  };

  console.log(data);
  // Send the data using axios POST request
  axios
    .post(`${BaseUrl}/backend/api/add_customer.php`, data)
    .then((response) => {
      console.log(response.data);

      if (response.data.status === "true") {
        alert("Customer created successfully!");
        setSuccessMessage("Add Customer successfully!");
        getservicesdata();
        setuseriddata(response.data.customer_data.id);
      } else {
        getservicesdata();
      }
    })
    .catch((error) => {
      console.error("Error occurred while submitting:", error);
      alert("There was an error submitting the form. Please try again.");
    })
    .finally(() => {
      setLoading(false);
    });
};
  const handleCancelPromo = () => {
    setPromoDiscount(0);
    setAppliedPromoCode(null);
    setPromoCode(""); // Reset input field
    setError(""); // Clear error messages
  };
  const scrollRef = useRef(null);
  const scroll = (direction) => {
    const container = scrollRef.current;
    if (container) {
      const scrollAmount = container.offsetWidth * 0.8; // Scroll 80% of container width
      container.scrollBy({
        left: direction === "next" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         

        <div className="container mx-auto mt-8 xl:px-24 ">
        {successMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{successMessage}</span>
            </div>
          )}

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{error}</span>
            </div>
          )}
          <div className="flex flex-wrap space-x-4 mb-3">
            <h1 className="text-[rgb(0,182,255)]  font-semibold">✔ confirm</h1>
            <h1 className="text-green-500 font-semibold">👍 Complete</h1>
            <h1 className="text-blue-500 font-semibold">↻ Reschedule</h1>
            <h1 className="text-black font-semibold">👎🏻 Reject</h1>
            <h1 className="text-red-500 font-semibold">❌ Delete</h1>
            <h1 className="text-red-500 font-semibold">
              🗑️ Delete All Recurring
            </h1>
          </div>

          <div className="flex sm:flex-col min-[320px]:flex-col max-[640px]:flex-col lg:flex-row lg:justify-between lg:items-center mb-4 text-teal-50 bg-customGreen p-4 sm:justify-start sm:items-start min-[320px]:justify-start max-[640px]:justify-start min-[320px]:items-start max-[640px]:items-start bg-blue-800 ">
            <div className="lg:w-1/4">
              <div className="flex flex-col items-center space-y-3 sm:space-y-">
                <div className="flex items-center space-x-4">
                  <button
                    onClick={activeView === "day" ? prevDay : prevMonth}
                    className="text-lg"
                  >
                    <MdKeyboardDoubleArrowLeft />
                  </button>

                  <p
                    className="text-white-400 font-bold text-xs sm:text-xs md:text-base cursor-pointer hover:text-white"
                    onClick={handleGoToToday}
                  >
                    Today
                  </p>

                  <button
                    onClick={activeView === "day" ? nextDay : nextMonth}
                    className="text-lg "
                  >
                    <MdKeyboardDoubleArrowRight />
                  </button>
                </div>
              </div>
            </div>

            <div className="lg:w-2/4 flex justify-center items-center">
              <span className="text-lg font-bold">
                {activeView === "month" ? (
                  <>
                    <span>
                      {format(currentMonth, "MMMM")}-
                      {format(currentMonth, "yyyy")}
                    </span>
                  </>
                ) : activeView === "week" ? (
                  `${format(startOfWeek(currentMonth), "MMM d")} — ${format(
                    endOfWeek(currentMonth),
                    "MMM d, yyyy"
                  )}`
                ) : (
                  format(currentMonth, "MMMM d, yyyy")
                )}
              </span>
            </div>
            <div className="lg:w-1/4">
              <div className="mt-sm flex justify-center lg:justify-end w-full space-x-2">
                <p
                  className={`py-sm px-md text-base pr-3 cursor-pointer ${
                    activeView === "month"
                      ? `bg-slate-dark rounded-md shadow-md font-bold hover:bg-slate-darker`
                      : `bg-transparent hover:bg-gray-dark rounded-md shadow-md`
                  }`}
                  onClick={() => setActiveView("month")}
                >
                  Month
                </p>

                <p
                  className={`py-sm px-md text-base pr-3 cursor-pointer ${
                    activeView === "week"
                      ? `bg-slate-dark rounded-md shadow-md font-bold hover:bg-slate-darker`
                      : `bg-transparent hover:bg-gray-dark rounded-md shadow-md`
                  }`}
                  onClick={() => setActiveView("week")}
                >
                  Week
                </p>

                <p
                  className={`py-sm px-md text-base pr-3 cursor-pointer ${
                    activeView === "day"
                      ? `bg-slate-dark rounded-md shadow-md font-bold hover:bg-slate-darker`
                      : `bg-transparent hover:bg-gray-dark rounded-md shadow-md`
                  }`}
                  onClick={() => setActiveView("day")}
                >
                  Day
                </p>
              </div>
            </div>
          </div>

          {activeView === "month" && (
            <>
              <div className="grid grid-cols-7  text-center ">
                {daysOfWeek?.map((day) => (
                  <div key={day}>{day}</div>
                ))}
              </div>
              <div className="grid grid-cols-7 border-red-700">
                {renderDaysInMonth()}
              </div>
            </>
          )}
          {activeView === "week" && renderWeekView()}
          {activeView === "day" && renderDayView()}

          {showModal && detailsdata && (
            <div className="fixed inset-0 py-16 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 ">
              <div className="bg-white p-6 overflow-y-auto   h-[500px] rounded-lg w-full max-w-md sm:max-w-lg md:w-auto  lg:max-w-2xl xl:max-w-3xl min-[320px]:w-3/4 max-[640px]:w-3/4  overflow-auto">
                {/* Modal Header */}
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Booking Details</h2>
                  <button
                    onClick={handleCloseModal}
                    className="text-gray-500 hover:text-gray-700 font-bold"
                  >
                    X
                  </button>
                </div>

                {/* Booking Info */}
                <div className="space-y-6">
                <div className="flex flex-col sm:flex-row justify-between items-center">
                  <span className="font-medium mb-3">Booking Status:</span>
                  <span className="font-bold mb-3 text-green-600">
                    {detailsdata.booking_status}
                  </span>
                  <div className="flex items-center">
                    {detailsdata.booking_status !== "CO" &&
                    new Date(detailsdata?.appointment_starttime || detailsdata?.appointment_start_time) > new Date() ? (
                      <button
                        onClick={() => openEditServiceModal(detailsdata)}
                        className="text-black flex items-center gap-2 p-2 border rounded-md hover:bg-blue-500 hover:text-white"
                      >
                        <FaEdit /> Edit Booking Details
                      </button>
                    ) : (
                      <div className="w-[150px]"></div> // Placeholder to maintain layout
                    )}
                  </div>
                </div>  

                  <div className="space-y-4">
                    <table>
                      <tr>
                        <td className="font-bold w-24">Booking Date </td>

                        <td>
                          {detailsdata?.appointment_starttime}
                          {detailsdata?.appointment_start_time}
                        </td>
                      </tr>
                      <tr>
                        <td className="font-bold">Service</td>
                        <td>{detailsdata?.service_title}</td>
                      </tr>
                      <tr>
                        <td className="font-bold">Methods</td>
                        <td>{detailsdata?.method_title}</td>
                      </tr>
                      <tr>
                        <td className="font-bold">Units</td>
                        <td>{detailsdata?.unit_title}</td>
                      </tr>{" "}
                      <tr>
                        <td className="font-bold">Addons</td>
                        <td>{detailsdata?.addons_title}</td>
                      </tr>{" "}
                      <tr>
                        <td className="font-bold">Price</td>
                        <td>{detailsdata?.booking_price}</td>
                      </tr>{" "}
                      <tr>
                        <td className="font-bold">Duration</td>
                        <td>{detailsdata?.booking_duration}</td>
                      </tr>
                    </table>
                  </div>
                  <div className="flex justify-between">
                    <h2 className="text-xl font-bold">Customer Detail</h2>
                    <Link to={`/admin/editcustomer/${selectedEvent.client_id}`}>
                      <button className="text-blue-500 mt-2 sm:mt-0">
                        <span className="text-2xl">
                          <BiSolidEdit />
                        </span>
                      </button>
                    </Link>
                  </div>

                  {/* Customer Information */}
                  <div className="space-y-4">
                    <table>
                      <tr>
                        <td className="font-bold w-20">Name</td>
                        <td>{detailsdata?.client_name}</td>
                      </tr>
                      <tr>
                        <td className="font-bold ">Email </td>
                        <td>{detailsdata?.client_email}</td>
                      </tr>
                      <tr>
                        <td className="font-bold ">Phone:</td>
                        <td>{detailsdata?.client_phone}</td>
                      </tr>
                      <tr>
                        <td className="font-bold">Address:</td>
                        <td>
                          <a
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                              detailsdata?.client_address
                            )}`}
                            target="_blank"
                            style={{ color: "blue" }}
                            rel="noopener noreferrer"
                          >
                            {detailsdata?.client_address}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td className="font-bold ">Payment:</td>
                        <td>{detailsdata?.payment_type}</td>
                      </tr>
                    </table>
                  </div>
                  {/* Assign Appointment */}
                  <div className="flex-col sm:flex-row justify-between items-center mt-4">
                      <div className="flex items-center sm:w-auto">
                        <div className="border p-2 rounded-md bg-white w-full shadow-md space-y-2  max-h-72 overflow-y-auto">
                          <div className="p-2 text-gray-700 font-medium">Assign Appointment to Staff:</div>
                          {adminData?.length > 0 ? (
                            <div className="grid grid-cols-1 sm:grid-cols-5 gap-2 p-2">
                              {adminData.map((staff) => (
                                <div
                                  key={staff.id}
                                  className="flex items-center space-x-3 hover:bg-gray-100 p-1 rounded"
                                >
                                  <input
                                    type="checkbox"
                                    value={staff?.id}
                                    checked={selectedStaff.includes(staff?.id)}
                                    onChange={(e) => {
                                      const id = e?.target?.value;
                                      setSelectedStaff((prev) =>
                                        e?.target?.checked
                                          ? [...prev, id]
                                          : prev?.filter((staffId) => staffId !== id)
                                      );
                                    }}
                                    className="h-4 w-4 text-blue-600 cursor-pointer focus:ring-blue-500"
                                  />
                                  <span className="text-gray-800">{staff.fullname}</span>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-gray-500 text-center">No staff available</p>
                          )}
                           <div className="mt-2 flex justify-end ">
                        <button className="text-blue-500 bg-gray-200 border border-gray-400 rounded-md p-1 hover:bg-gray-300 transition-colors"  onClick={handleEditClick}>
                          <span className="text-2xl">
                            <BiSolidEdit />
                          </span>
                        </button>
                      </div>
                        </div>
                      </div>
                  </div>
                </div>
                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
                  {detailsdata.booking_status === "R" && (
                    <>
                      <button
                        type="button"
                        onClick={() => handaldeleted(detailsdata.id)}
                        className="text-red-500 font-semiboldpx-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        ✖ Delete
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          deleteallbooking(detailsdata.recurring_id)
                        }
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        🗑️ Delete All Recurring
                      </button>
                    </>
                  )}

                  {detailsdata.booking_status === "A" && (
                    <>
                      <button
                        type="button"
                        onClick={() =>
                          handalconfirm_appointment(detailsdata.id)
                        }
                        className="text-[rgb(0,182,255)] font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                      >
                        ✔ confirm
                      </button>

                      <button
                        type="button"
                        onClick={() => handleRescheduleClick(detailsdata.id)}
                        className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                      >
                        ↻ Reschedule
                      </button>

                      <button
                        type="button"
                        onClick={handleRejectClick}
                        className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        👎🏻 Reject
                      </button>

                      {/* Reschedule Modal */}
                      {detailsdata && showRescheduleModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                          <div className="bg-white p-6 rounded-md shadow-lg w-96">
                            <h2 className="text-lg font-semibold mb-4">
                              Reschedule Appointment
                            </h2>
                            {/* Amount Input */}
                            <div className="mb-4">
                              <label
                                htmlFor="amount"
                                className="block text-gray-700 mb-2"
                              >
                                Amount:
                              </label>
                              <input
                                type="number"
                                id="amount"
                                value={
                                  detailsdata?.booking_price
                                    ? detailsdata.booking_price.replace(
                                        /[^0-9.-]+/g,
                                        ""
                                      )
                                    : ""
                                }
                                className="w-full px-3 py-2 border rounded-md"
                              />
                            </div>

                            {/* Date Picker (Calendar) */}
                            <div className="mb-4">
                              <label
                                htmlFor="date"
                                className="block text-gray-700 mb-2"
                              >
                                Select Date:
                              </label>
                              <input
                                type="datetime-local"
                                id="date"
                                value={rescheduleDate}
                                onChange={(e) =>
                                  setRescheduleDate(e.target.value)
                                }
                                className="w-full px-3 py-2 border rounded-md"
                              />
                            </div>

                            {/* Notes Input */}
                            <div className="mb-4">
                              <label
                                htmlFor="notes"
                                className="block text-gray-700 mb-2"
                              >
                                Notes:
                              </label>
                              <textarea
                                id="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                className="w-full px-3 py-2 border rounded-md"
                                placeholder="Add any notes"
                              />
                            </div>

                            {/* Action Buttons */}
                            <div className="flex justify-end gap-4">
                              <button
                                type="button"
                                onClick={closeRescheduleModal}
                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                onClick={(e) => handleUpdate(e, rescheduleDate)}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md"
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Reject Form */}
                      {showForm && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                          <form
                            onSubmit={(e) => handleReject(detailsdata.id, e)}
                            className="bg-white p-6 rounded-md shadow-lg w-96"
                          >
                            <h2 className="text-lg font-semibold mb-4">
                              Enter Reject Reason
                            </h2>
                            <label
                              htmlFor="rejectReason"
                              className="block text-gray-700 mb-2"
                            >
                              Reason:
                            </label>
                            <input
                              type="text"
                              id="rejectReason"
                              value={rejectReason}
                              onChange={(e) => setRejectReason(e.target.value)}
                              className="w-full px-3 py-2 border rounded-md mb-4"
                              placeholder="Reason for rejection"
                            />
                            <div className="flex justify-end gap-4">
                              <button
                                type="button"
                                onClick={() => setShowForm(false)}
                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                className="bg-red-500 text-white px-4 py-2 rounded-md"
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      )}

                      <button
                        type="button"
                        onClick={() => handaldeleted(detailsdata.id)}
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        ✖ Delete
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          deleteallbooking(detailsdata.recurring_id)
                        }
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        🗑️ Delete All Recurring
                      </button>
                    </>
                  )}

                  {detailsdata.booking_status === "C" && (
                    <>
                      <button
                        type="button"
                        onClick={() =>
                          handalapointment_complete(detailsdata.id)
                        }
                        className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                      >
                        👍 Complete
                      </button>

                      <button
                        type="button"
                        onClick={() => handaldeleted(detailsdata.id)}
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        ✖ Delete
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          deleteallbooking(detailsdata.recurring_id)
                        }
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        🗑️ Delete All Recurring
                      </button>
                    </>
                  )}
                  {detailsdata.booking_status === "RS" && (
                    <>
                      <button
                        type="button"
                        onClick={() =>
                          handalapointment_complete(detailsdata.id)
                        }
                        className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                      >
                        👍 Complete
                      </button>

                      <button
                        type="button"
                        onClick={() => handleRescheduleClick(detailsdata.id)}
                        className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
                      >
                        ↻ Reschedule
                      </button>

                      <button
                        type="button"
                        onClick={handleRejectClick}
                        className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        👎🏻 Reject
                      </button>

                      {/* Reschedule Modal */}
                      {detailsdata && showRescheduleModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                          <div className="bg-white p-6 rounded-md shadow-lg w-96">
                            <h2 className="text-lg font-semibold mb-4">
                              Reschedule Appointment
                            </h2>
                            {/* Amount Input */}
                            <div className="mb-4">
                              <label
                                htmlFor="amount"
                                className="block text-gray-700 mb-2"
                              >
                                Amount:
                              </label>
                              <input
                                type="number"
                                id="amount"
                                value={
                                  detailsdata?.booking_price
                                    ? detailsdata.booking_price?.replace(
                                        /[^0-9.-]+/g,
                                        ""
                                      )
                                    : ""
                                }
                                className="w-full px-3 py-2 border rounded-md"
                              />
                            </div>

                            <div className="mb-4">
                              <label
                                htmlFor="date"
                                className="block text-gray-700 mb-2"
                              >
                                Select Date:
                              </label>
                              <input
                                type="datetime-local"
                                id="date"
                                value={rescheduleDate}
                                onChange={(e) =>
                                  setRescheduleDate(e.target.value)
                                }
                                className="w-full px-3 py-2 border rounded-md"
                              />
                            </div>

                            {/* Notes Input */}
                            <div className="mb-4">
                              <label
                                htmlFor="notes"
                                className="block text-gray-700 mb-2"
                              >
                                Notes:
                              </label>
                              <textarea
                                id="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                className="w-full px-3 py-2 border rounded-md"
                                placeholder="Add any notes"
                              />
                            </div>

                            {/* Action Buttons */}
                            <div className="flex justify-end gap-4">
                              <button
                                type="button"
                                onClick={closeRescheduleModal}
                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                onClick={(e) => handleUpdate(e, rescheduleDate)}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md"
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Reject Form */}
                      {showForm && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                          <form
                            onSubmit={(e) => handleReject(detailsdata.id, e)}
                            className="bg-white p-6 rounded-md shadow-lg w-96"
                          >
                            <h2 className="text-lg font-semibold mb-4">
                              Enter Reject Reason
                            </h2>
                            <label
                              htmlFor="rejectReason"
                              className="block text-gray-700 mb-2"
                            >
                              Reason:
                            </label>
                            <input
                              type="text"
                              id="rejectReason"
                              value={rejectReason}
                              onChange={(e) => setRejectReason(e.target.value)}
                              className="w-full px-3 py-2 border rounded-md mb-4"
                              placeholder="Reason for rejection"
                            />
                            <div className="flex justify-end gap-4">
                              <button
                                type="button"
                                onClick={() => setShowForm(false)}
                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                className="bg-red-500 text-white px-4 py-2 rounded-md"
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      )}

                      <button
                        type="button"
                        onClick={() => handaldeleted(detailsdata.id)}
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        ✖ Delete
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          deleteallbooking(detailsdata.recurring_id)
                        }
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        🗑️ Delete All Recurring
                      </button>
                    </>
                  )}

                  {detailsdata.booking_status === "CO" && (
                    <>
                      <div className="text-gray-500">
                        This Appointment Is Completed
                      </div>

                      <button
                        type="button"
                        onClick={() => handaldeleted(detailsdata.id)}
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        ✖ Delete
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          deleteallbooking(detailsdata.recurring_id)
                        }
                        className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
                      >
                        🗑️ Delete All Recurring
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}

          {showEditServiceModal && (
            <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-auto max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white z-10 px-6 py-4 border-b flex justify-between items-center">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Edit Booking
                  </h2>
                  <button
                    onClick={handleClosebookingSummary}
                    className="text-gray-500 hover:text-gray-700 transition-colors p-2 rounded-full hover:bg-gray-100"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-6">
                  {/* Left Column - Booking Form */}
                  <div className="lg:col-span-2">
                    <form onSubmit={handleSubmitEdit} className="space-y-6">
                      {/* Service Selection Panel */}
                      <div className="bg-white rounded-lg shadow-md border border-gray-100">
                        <div
                          className="flex justify-between items-center bg-gradient-to-r from-blue-500 to-blue-600 p-4 rounded-t-lg cursor-pointer text-white"
                          onClick={toggleServicePanel}
                        >
                          <h3 className="font-medium">Choose Service</h3>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </div>

                        <div className="p-4">
                          {/* Services Grid */}
                          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
                            {services?.map((service) => (
                              <div
                                key={service.service_id}
                                onClick={() => {
                                  if (service.service_id) {
                                    if (selectedService === service.service_id) {
                                      // If the same service is clicked again, unselect it
                                      setSelectedService(null);
                                      setUserSelectedMethods([]); // Clear userSelectedMethods to sync with single selection
                                    } else {
                                      // Select the new service
                                      setSelectedService(service.service_id);
                                      setUserSelectedMethods([service.service_id]); // Update userSelectedMethods for single selection
                                    }
                                  } else {
                                    console.error("Service ID is missing", service);
                                  }
                                }}
                                className={`cursor-pointer border rounded-lg overflow-hidden shadow-sm transition೭all duration-200 hover:shadow-md ${
                                  userSelectedMethods.includes(service.service_id)
                                    ? "ring-2 ring-blue-400"
                                    : ""
                                } ${
                                  selectedService === service.service_id
                                    ? "ring-2 ring-blue-500 transform scale-[1.02]"
                                    : ""
                                }`}
                              >
                                <div className="relative">
                                  <img
                                    src={service?.service_image}
                                    className="w-full h-32 object-cover"
                                    // alt={service?.service_title || "Service"}
                                  />
                                  <div className="absolute inset-0 flex items-center justify-center text-white font-medium bg-black bg-opacity-40 text-center p-2">
                                    {service?.service_title}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Selected Service Details */}
                          {selectedService && (
                            <div className="mt-6 space-y-6">
                              {services
                                .filter((s) => s.service_id === selectedService)
                                ?.map((service) => (
                                  <div key={service.service_id}>
                                    {/* Units Section */}
                                    {service.units &&
                                      service.units.length > 0 && (
                                        <div className="bg-gray-50 p-4 rounded-lg mb-6">
                                          <h3 className="font-medium text-gray-700 mb-4">
                                            Units
                                          </h3>
                                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            {service.units?.map((unit) => (
                                              <div
                                                key={unit.units_id}
                                                className="flex items-center space-x-4"
                                              >
                                                <div className="w-full">
                                                  <div className="flex items-center space-x-2 mb-2">
                                                    <label className="block font-medium text-gray-700">
                                                      {unit.unit_title}
                                                    </label>
                                                    <img
                                                      src={Bed}
                                                      className="w-5 h-5"
                                                      alt="Unit Icon"
                                                    />
                                                  </div>
                                                  <select
                                                    className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-white"
                                                    value={
                                                      bedroom[unit.units_id] ||
                                                      unit.unit_min
                                                    }
                                                    onChange={(e) =>
                                                      handleBedroomChange(
                                                        unit.units_id,
                                                        parseInt(e.target.value)
                                                      )
                                                    }
                                                  >
                                                    {Array.from(
                                                      {
                                                        length:
                                                          unit.unit_max -
                                                          unit.unit_min +
                                                          1,
                                                      },
                                                      (_, i) => (
                                                        <option
                                                          key={
                                                            i + unit.unit_min
                                                          }
                                                          value={
                                                            i + unit.unit_min
                                                          }
                                                        >
                                                          {i}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}


                                    {/* Methods Section */}
                                    {service.methods &&
                                      service.methods.length > 0 && (
                                        <div className="space-y-6">
                                          <div>
                                            <h3 className="font-medium text-gray-700 mb-3">
                                              Methods
                                            </h3>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                              {service.methods?.map(
                                                (method) => (
                                                  <button
                                                    type="button"
                                                    key={method.method_id}
                                                    onClick={() => {
                                                      handleMethodSelection(
                                                        method,
                                                        method.method_id
                                                      );
                                                    }}
                                                    className={`p-3 border rounded-lg text-center transition-all duration-200 ${
                                                      (selectedMethod &&
                                                        selectedMethod.method_id ===
                                                          method.method_id) ||
                                                      userSelectedMethodsId.includes(
                                                        method.method_id
                                                      )
                                                        ? "bg-blue-500 text-white border-blue-500 shadow-md"
                                                        : "bg-white hover:bg-blue-50 border-gray-200"
                                                    }`}
                                                  >
                                                    {method?.method_title}
                                                  </button>
                                                )
                                              )}
                                            </div>
                                          </div>
                                         {selectedMethod && (
                                          <div className="mt-6">
                                            {selectedMethod.submethods && selectedMethod.submethods.length > 0 ? (
                                              <div className="space-y-4">
                                                <h3 className="font-medium text-gray-700">Options</h3>
                                                {selectedMethod.submethods.map((submethod) => {
                                                  const bookedItem = bookingBill.find(
                                                    (item) => item.units_id === submethod.unit_id && item.type === "method_units"
                                                  );
                                                  return (
                                                    <div
                                                      key={submethod.unit_id}
                                                      className={`${
                                                        userSelectedMethodsUnitsId.includes(submethod.unit_id)
                                                          ? "border-blue-200 bg-blue-50"
                                                          : "border-gray-200"
                                                      } p-4 border rounded-lg shadow-sm transition-all duration-300`}
                                                    >
                                                      <h4 className="font-medium text-gray-700 mb-3">
                                                        {submethod.unit_title} (₹{submethod.unit_price})
                                                      </h4>
                                                      <div className="mb-4">
                                                        <label className="block font-medium mb-2">Select Quantity</label>
                                                        <select
                                                          className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                          value={bookedItem?.s_m_qty || ""}
                                                          onChange={(e) => {
                                                            const quantity = parseInt(e.target.value, 10) || 0;
                                                            editItemToBill(
                                                              submethod.unit_id,
                                                              submethod.unit_title,
                                                              quantity,
                                                              submethod.unit_price
                                                            );
                                                          }}
                                                        >
                                                          <option value="">Select Quantity</option>
                                                          {[...Array(submethod.unit_max - submethod.unit_min + 1).keys()].map(
                                                            (qty) => {
                                                              const quantity = qty + 1;
                                                              return (
                                                                <option key={quantity} value={quantity}>
                                                                  {quantity}
                                                                </option>
                                                              );
                                                            }
                                                          )}
                                                        </select>
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            ) : (
                                              <p className="text-gray-500 italic">No options available for this method.</p>
                                            )}
                                          </div>
                                        )}
                                        </div>
                                      )}

                                    {/* Add-ons Section */}
                                    {selectedMethod && service.addons?.length > 0 && (
                                        <div className="mt-8">
                                          <h3 className="font-medium text-gray-700 mb-4">Add-ons</h3>
                                          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                            {service.addons.map((addon, index) => (
                                              <div
                                                key={addon.addon_id}
                                                className={`border rounded-lg overflow-hidden shadow-sm transition-all duration-200 ${
                                                  userSelectedAddon.includes(addon.addon_id)
                                                    ? "border-blue-300 bg-blue-50"
                                                    : "border-gray-200 bg-white hover:border-blue-200"
                                                }`}
                                                onClick={() => handleAddonSelection(addon.addon_id)}
                                              >
                                                <div className="p-4">
                                                  <div className="text-center mb-3">
                                                    <p className="font-medium text-gray-800">{addon.addon_name}</p>
                                                  </div>
                                                  <div className="text-center mb-4">
                                                    <p className="text-blue-600 font-medium">₹{addon.addon_price}</p>
                                                  </div>
                                                  <div className="flex items-center justify-center gap-3">
                                                    <button
                                                      type="button"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleQuantityChangeEdit(
                                                          index,
                                                          false,
                                                          addon.addon_name,
                                                          addon.addon_price,
                                                          addon.addon_maxqty
                                                        );
                                                      }}
                                                      className="p-1 w-8 h-8 flex items-center justify-center bg-red-100 text-red-600 rounded-full hover:bg-red-200 transition-colors"
                                                    >
                                                      -
                                                    </button>
                                                    <span className="text-lg font-medium w-8 text-center">
                                                      {quantities[index]}
                                                    </span>
                                                    <button
                                                      type="button"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleQuantityChangeEdit(
                                                          index,
                                                          true,
                                                          addon.addon_name,
                                                          addon.addon_price,
                                                          addon.addon_maxqty
                                                        );
                                                      }}
                                                      className="p-1 w-8 h-8 flex items-center justify-center bg-green-100 text-green-600 rounded-full hover:bg-green-200 transition-colors"
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}
                                                                
                                    {selectedAppointment && (
                                    <div className="mt-8">
                                      <h3 className="font-medium text-gray-700 mb-4">Select Provider</h3>
                                      <div className="flex flex-wrap gap-4">
                                        {selectedAppointment.staff_names ? (
                                          selectedAppointment.staff_names.split(",").map((name, index) => (
                                            <div key={index} className="text-center">
                                              <div className="w-20 h-20 bg-blue-500 text-white rounded-full flex items-center justify-center text-xl font-semibold">
                                                Provider
                                              </div>
                                              <p className="mt-2 text-gray-700">{name.trim() || "N/A"}</p>
                                            </div>
                                          ))
                                        ) : (
                                          <p className="text-gray-500 italic">No staff assigned.</p>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  </div>
                                ))}
                            </div>
                          )}

                        </div>
                      </div>

                          {/* Submit Button */}
                          <div className="flex justify-center">
                            <button
                              type="submit"
                              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition duration-200 shadow-md hover:shadow-lg"
                            >
                              Submit Booking
                            </button>
                          </div>
                        </form>
                      </div>

                        {/* Right Column - Bhhhhhooking Summary */}
                        <div className="lg:col-span-1">
                          <div className="bg-white border rounded-lg shadow-lg p-6 sticky top-24">
                            <h2 className="text-lg font-bold text-gray-800 border-b pb-3 mb-4">
                              Booking Summary
                            </h2>

                            {/* Date and Time */}
                            <div className="space-y-4 mb-6">
                              <div className="flex items-center text-sm text-gray-600">
                                <div className="flex items-center space-x-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <rect
                                      x="3"
                                      y="4"
                                      width="18"
                                      height="18"
                                      rx="2"
                                      ry="2"
                                    ></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                  </svg>
                                  <span className="font-medium text-gray-700">
                                    Date & Time:
                                  </span>
                                  <div>
                                    {selectedDate && selectedTime ? (
                                      <p>
                                        {selectedDate} @ {selectedTime}
                                      </p>
                                    ) : allsetdata?.booking_date_time ? (
                                      <p>{allsetdata?.booking_date_time}</p>
                                    ) : (
                                      <p className="text-gray-400 italic">
                                        Not selected
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>

                                {/* Frequency */}
                                <div className="flex items-center text-sm text-gray-600">
                                  <div className="flex items-center space-x-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    >
                                      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                                    </svg>
                                    <span className="font-medium text-gray-700">
                                      Frequency:
                                    </span>
                                    <p>
                                      {allsetdata?.discount_typename
                                        ? allsetdata?.discount_typename
                                        : selectedFrequency}
                                    </p>
                                  </div>
                                </div>

                                {/* Duration */}
                                <div className="flex items-center text-sm text-gray-600">
                                  <div className="flex items-center space-x-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <polyline points="12 6 12 12 16 14"></polyline>
                                    </svg>
                                    <span className="font-medium text-gray-700">
                                      Duration:{" "}
                                      {allsetdata?.order_duration
                                        ? `${Math.round(
                                            allsetdata?.order_duration / 60
                                          )} Hours`
                                        : "-"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="mb-6">
                                <h3 className="font-bold text-gray-800 mb-3">Cart Items:</h3>
                                {bookingBill.length === 0 ? (
                                  <div>
                                    <div className="flex items-center text-sm text-gray-600">
                                      <span className="font-medium text-gray-700">Service:</span>
                                      <p>{allsetdata?.service_id || "N/A"}</p>
                                    </div>
                                    {allsetdata?.cart_items?.map((item, idx) => (
                                      <div key={idx} className="flex items-center text-sm text-gray-600">
                                        <span className="font-medium text-gray-700">
                                          {item.type === "method_units" ? "Method" : "Addon"}:
                                        </span>
                                        <p>{item.method_name || "N/A"} (x{item.s_m_qty}) - ₹{item.s_m_rate}</p>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                              
                              <ul className="space-y-2">
                              {bookingBill.map((item, idx) => (
                                <li
                                  key={idx}
                                  className="flex justify-between items-center py-2 border-b border-gray-100"
                                >
                                  <span className="text-gray-700">{item.name}</span>
                                  <span className="text-gray-700">
                                    <span className="text-gray-500 text-sm">(x{item.s_m_qty})</span>
                                  </span>
                                  <div className="flex gap-4">
                                    <span>₹{item.s_m_rate}</span>
                                    <span onClick={() => removeItemEdit(idx)} className="text-red-500 cursor-pointer">
                                      X
                                    </span>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div className="border-t pt-4">
                        <div className="flex justify-between mb-2">
                          <p>Sub Total:</p>
                          <p>₹{subtotale.toFixed(2)}</p>
                        </div>
                        <div className="flex justify-between mb-2">
                          <p>Discount:</p>
                          <p>- ₹{discountedTotal.toFixed(2)}</p>
                        </div>
                        <div className="flex justify-between mb-4">
                          <p>Tax:</p>
                          <p>₹{tax.toFixed(2)}</p>
                        </div>
                        <div className="flex justify-between font-bold text-lg">
                          <p>Total:</p>
                          <p>₹{finelamount.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showBookingSummary2 && (
            <>
              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                <div className="flex flex-col overflow-auto scrollbar-none rounded-lg bg-white p-4 md:p-6 lg:p-8 w-full max-w-md md:max-w-2xl lg:max-w-4xl h-[80vh] md:h-auto max-h-screen">
                  <div className="w-full mx-auto">
                    <div className="">
                      {/* Left Section - Booking Form */}
                      <div className="col-span-2  px-4 ">
                        <div className="flex justify-between items-center">
                          {/* <button
                            onClick={handleClick}
                            className="px-4 py-2 mt-3 bg-blue-500 text-white flex items-end justify-end rounded-md hover:bg-blue-600 transition duration-200"
                          >
                            My Booking
                          </button> */}
                          <div></div>
                          <button
                            className=" text-2xl"
                            onClick={handleClosebookingSummary}
                          >
                            x
                          </button>
                        </div>
                        <h1 className="text-3xl font-medium text-center text-blue-800 mb-6 min-[320px]:pt-4 max-[640px]:pt-4 min-[320px]:text-[24px] max-[640px]:text-[24px]">
                          Add Manual Booking
                        </h1>
                        {/* <p className="text-center text-gray-700 mb-4">Amroli Surat</p> */}

                        <form onSubmit={handleSubmit} className="">
                          <div
                            className="flex justify-between bg-gray-400 p-2 rounded-sm text-lg font-medium"
                            onClick={toggleServicePanel}
                          >
                            <p>Choose Services</p>
                            {/* Toggling icons */}
                            <p className="px-3">
                              {isServiceOpen ? (
                                <MdOutlineKeyboardArrowUp />
                              ) : (
                                <MdOutlineKeyboardArrowDown />
                              )}
                            </p>
                          </div>
                          <div
                            className={`transition-all ease-in-out duration-1000 scrollbar-none mb-4 border border-gray-300 overflow-hidden ${
                              isServiceOpen
                                ? "opacity-100 translate-y-0 max-h-[500px] overflow-y-auto"
                                : "opacity-0 translate-y-4 max-h-0"
                            }`}
                          >
                            {isServiceOpen && (
                              <div className="p-4   ">
                                {/* Service Location */}
                                <div>
                                  <label
                                    htmlFor="serviceLocation"
                                    className="block text-lg font-medium text-gray-800 pb-2"
                                  >
                                    Where would you like us to provide service?
                                  </label>
                                </div>

                                {/* Zip Code Input */}
                                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
                                <div className="flex flex-col w-full">
                                    <label
                                      htmlFor="zipCode"
                                      className="block text-lg font-medium text-gray-800"
                                    >
                                      Zip Code
                                    </label>
                                    <input
                                      type="text"
                                      id="zipCode"
                                      name="zipCode"
                                      value={formData.zipCode}
                                      onChange={handleZipCodeChange} // Use new handler
                                      className="mt-2 p-2 w-full border border-gray-400 rounded-md"
                                      placeholder="Enter Zip Code"
                                      onInput={(e) => {
                                        if (e.target.value.length > 6) {
                                          e.target.value = e.target.value.slice(0, 6); // Max 6 digits
                                        }
                                      }}
                                    />
                                    {/* Display error message if zip code is invalid */}
                                    {zipCodeError && (
                                      <p className="text-red-500 text-sm mt-1">{zipCodeError}</p>
                                    )}
                                    
                                  </div>
                                </div>

                                {/* Choose Service */}
                                <div>
                                  <label
                                    htmlFor="selectedService"
                                    className="block text-lg font-medium text-gray-800 min-[320px]:pt-4  max-[640px]:pt-4"
                                  >
                                    Choose Service
                                  </label>
                                </div>

                                {/* Services */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6 min-[320px]:grid-cols-2 max-[640px]:grid-cols-2">
                                  {allServices?.map((service) => (
                                    <div
                                      key={service.service_id}
                                      onClick={() => {
                                        if (service.service_id) {
                                          if (selectedService === service.service_id) {
                                            // If the same service is clicked again, unselect it
                                            setSelectedService(null);
                                          } else {
                                            // Select the new service
                                            setSelectedService(service.service_id);
                                          }
                                        } else {
                                          console.error("Service ID is missing", service);
                                        }
                                      }}
                                      className={`cursor-pointer border rounded-lg text-center transition-all duration-300 ${
                                        selectedService === service.service_id
                                          ? "bg-blue-400 text-white shadow-lg shadow-blue-500"
                                          : "bg-white hover:bg-blue-300"
                                      }`}
                                    >
                                      {service?.service_image ? (
                                        // If image exists, show image with title overlay
                                        <div className="relative">
                                          <img
                                            src={service.service_image}
                                            className="w-full h-52 object-cover rounded-md min-[320px]:h-36 max-[640px]:h-36"
                                          />
                                          <div className="absolute inset-0 flex items-center justify-center text-white font-bold bg-black bg-opacity-50 rounded-md">
                                            {service?.service_title}
                                          </div>
                                        </div>
                                      ) : (
                                        // If no image, show only title with a colored background
                                        <div className="flex items-center justify-center h-20 p-4 text-white font-bold bg-blue-500 rounded-md">
                                          {service?.service_title}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>

                                {/* Conditionally render the selected service details */}
                                {selectedService && (
                                  <div>
                                    {/* Find the selected service */}
                                    {allServices
                                      .filter(
                                        (s) => s.service_id === selectedService
                                      )
                                      ?.map((service) => (
                                        <>
                                          <div>
                                            {/* Dropdowns */}
                                            {service.units &&
                                              service.units.length > 0 && (
                                                <div>
                                                  {service.units?.map(
                                                    (unit) => (
                                                      <div
                                                        key={unit.unit_id}
                                                        className="flex gap-4 mb-6"
                                                      >
                                                        <div>
                                                          <div className="flex items-center space-x-2">
                                                            {/* Display the unit title */}
                                                            <label className="block font-medium mb-2">
                                                              {unit.unit_title}
                                                            </label>
                                                            <img
                                                              src={Bed}
                                                              className="w-6 h-6"
                                                              alt="Unit Icon"
                                                            />
                                                          </div>
                                                          <select
                                                            className={`w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-400 ${
                                                              selectedOptions[
                                                                unit.unit_id
                                                              ]
                                                                ? "bg-green-500"
                                                                : "bg-white"
                                                            }`}
                                                            value={
                                                              bedroom[
                                                                unit.unit_id
                                                              ] || unit.unit_min
                                                            } // Default to `unit_min`
                                                            onChange={(e) =>
                                                              handleBedroomChange(
                                                                unit.unit_id,
                                                                parseInt(
                                                                  e.target.value
                                                                )
                                                              )
                                                            }
                                                          >
                                                            {Array.from(
                                                              {
                                                                length:
                                                                  unit.unit_max -
                                                                  unit.unit_min +
                                                                  1,
                                                              },
                                                              (_, i) => (
                                                                <option
                                                                  key={
                                                                    i +
                                                                    unit.unit_min
                                                                  }
                                                                  value={
                                                                    i +
                                                                    unit.unit_min
                                                                  }
                                                                >
                                                                  {i}
                                                                </option>
                                                              )
                                                            )}
                                                          </select>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              )}

                                            {/* Render methods */}
                                            {service.methods &&
                                              service.methods.length > 0 && (
                                                <div className="flex flex-col space-y-6">
                                                  {/* Upper part: Methods Buttons */}
                                                  <div>
                                                    <h3>Methods</h3>
                                                    <div className="grid grid-cols-2 gap-4">
                                                      {service.methods?.map(
                                                        (method) => (
                                                          <button
                                                            type="button"
                                                            key={
                                                              method.method_id
                                                            }
                                                            onClick={() => {
                                                              // Handle method selection
                                                              handleMethodSelection(
                                                                method,
                                                                method.method_id
                                                              );
                                                            }}
                                                            className={`p-4 border rounded-lg text-center shadow-md ${
                                                              selectedMethod &&
                                                              selectedMethod.method_id ===
                                                                method.method_id
                                                                ? "bg-blue-400 text-white"
                                                                : "bg-white"
                                                            }`}
                                                          >
                                                            {
                                                              method.method_title
                                                            }
                                                          </button>
                                                        )
                                                      )}
                                                    </div>
                                                  </div>

                                                  {/* Bottom part: Submethods and Quantity Buttons */}
                                                  <div>
                                                    {selectedMethod && (
                                                      <div className="mt-6">
                                                        {selectedMethod.submethods &&
                                                        selectedMethod
                                                          .submethods.length >
                                                          0 ? (
                                                          <>
                                                            {/* Mobile View - Dropdown */}
                                                            <div className="md:hidden">
                                                              {selectedMethod.submethods.map(
                                                                (submethod) => (
                                                                  <div
                                                                    key={
                                                                      submethod.unit_id
                                                                    }
                                                                    className="mb-4"
                                                                  >
                                                                    <label className="block font-medium mb-2">
                                                                      {
                                                                        submethod.unit_title
                                                                      }
                                                                      {
                                                                        submethod.unit_price
                                                                      }
                                                                    </label>
                                                                    <select
                                                                      className="w-full p-2 border rounded-lg"
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        const selectedQuantity =
                                                                          parseInt(
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            10
                                                                          );
                                                                        addItemToBill(
                                                                          submethod.unit_id,
                                                                          submethod.unit_title,
                                                                          selectedQuantity,
                                                                          submethod.unit_price
                                                                        );
                                                                      }}
                                                                    >
                                                                      <option value="">
                                                                        Select
                                                                        Quantity
                                                                      </option>
                                                                      {[
                                                                        ...Array(
                                                                          submethod.unit_max -
                                                                            submethod.unit_min +
                                                                            1
                                                                        ).keys(),
                                                                      ].map(
                                                                        (
                                                                          qty
                                                                        ) => {
                                                                          const quantity =
                                                                            1 +
                                                                            qty;
                                                                          return (
                                                                            <option
                                                                              key={
                                                                                quantity
                                                                              }
                                                                              value={
                                                                                quantity
                                                                              }
                                                                            >
                                                                              {
                                                                                quantity
                                                                              }
                                                                            </option>
                                                                          );
                                                                        }
                                                                      )}
                                                                    </select>
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>

                                                            {/* Desktop View - Buttons */}
                                                            <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-2 gap-2">
                                                              {selectedMethod.submethods.map(
                                                                (submethod) => (
                                                                  <div
                                                                    key={
                                                                      submethod.unit_id
                                                                    }
                                                                    className="mb-4"
                                                                  >
                                                                    <label className="block font-medium mb-2">
                                                                      {
                                                                        submethod.unit_title
                                                                      }{" "}
                                                                      &nbsp;(₹
                                                                      {
                                                                        submethod.unit_price
                                                                      }
                                                                      )
                                                                    </label>
                                                                    <select
                                                                      className="w-full p-2 border rounded-lg"
                                                                      onChange={(e) => {
                                                                        const selectedQuantity = parseInt(e.target.value, 10);
                                                                        addItemToBill(
                                                                          submethod.unit_id,
                                                                          submethod.unit_title,
                                                                          selectedQuantity,
                                                                          submethod.unit_price,
                                                                          service.service_title
                                                                        );
                                                                      }}
                                                                      value={
                                                                        bookingBill.find((item) => item.unit_id === submethod.unit_id)?.qty || ""
                                                                      }
                                                                    >
                                                                     <option value="">Select Quantity</option>
                                                                      {[...Array(submethod.unit_max - submethod.unit_min + 1).keys()].map((qty) => {
                                                                        const quantity = qty + 1;
                                                                        return (
                                                                          <option key={quantity} value={quantity}>
                                                                            {quantity}
                                                                          </option>
                                                                        );
                                                                      })}
                                                                    </select>
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </>
                                                        ) : (
                                                          <p>
                                                            No submethods
                                                            available for this
                                                            method.
                                                          </p>
                                                        )}
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              )}

                                                      {selectedMethod && (
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                                          {service.addons?.map((addon, index) => (
                                                            <div
                                                              key={index}
                                                              className="p-4 border rounded-lg text-center bg-white shadow-md"
                                                            >
                                                              <p className="text-lg font-semibold mb-2">{addon.addon_name}</p>
                                                              <p className="text-lg mb-2">Price: ₹{addon.addon_price}</p>
                                                             {quantities[index] >= addon.addon_maxqty && (
                                                             <p className="text-xs text-red-500 mb-3">
                                                                 {addon.addon_name} are Max {addon.addon_maxqty} reached
                                                                </p>
                                                             )}  
                                                              <div className="flex items-center justify-center gap-2">
                                                                <button
                                                                  type="button"
                                                                  onClick={() =>
                                                                    handleQuantityChange(
                                                                      index,
                                                                      false,
                                                                      addon.addon_name,
                                                                      addon.addon_price,
                                                                      addon.addon_maxqty
                                                                    )
                                                                  }
                                                                  className="p-2 bg-red-400 text-white rounded-lg"
                                                                >
                                                                  -
                                                                </button>
                                                                <span className="text-lg">{quantities[index] || 0}</span>
                                                                <button
                                                                  type="button"
                                                                  onClick={() =>
                                                                    handleQuantityChange(
                                                                      index,
                                                                      true,
                                                                      addon.addon_name,
                                                                      addon.addon_price,
                                                                      addon.addon_maxqty
                                                                    )
                                                                  }
                                                                  className="p-2 bg-green-400 text-white rounded-lg"
                                                                  disabled={quantities[index] >= addon.addon_maxqty}
                                                                >
                                                                  +
                                                                </button>
                                                              </div>
                                                            </div>
                                                          ))}
                                                        </div>
                                                      )}
                                          </div>
                                        </>
                                      ))}
                                  </div>
                                )}

                           <div className="p-4">
                          <h2 className="text-lg font-semibold mb-4 text-center sm:text-left">
                            How often would you like us to provide service ? ( Four Month Booking schedule Manage ) 
                          </h2>
                          <div className="flex flex-wrap justify-center sm:justify-start gap-4">
                            {Services_frequently_discount?.map((v) => {
                              // Construct the dynamic message using days and booking_count
                              const message =
                                v.discount_typename === "Once"
                                  ? "One-time booking."
                                  : `Service every ${v.days} days, ${v.booking_count} bookings counted annually.`;

                                  return (
                                    <div key={v.id} className="flex flex-col items-center w-28 sm:w-auto">
                                      <button
                                        type="button"
                                        className={`px-6 py-2 w-full sm:w-auto border rounded-md ${
                                          selectedFrequency === v.discount_typename
                                            ? "border-teal-500 text-teal-500"
                                            : "border-gray-300"
                                        }`}
                                        onClick={() => {
                                          if (selectedFrequency === v.discount_typename) {
                                            // If the same button is clicked again, unselect it
                                            setSelectedFrequency(null); // Clear the selected frequency
                                            setSelectedDiscount(null); // Clear the selected discount
                                            setselectedservices(null); // Clear the selected service
                                          } else {
                                            // Select the new frequency
                                            setSelectedFrequency(v.discount_typename);
                                            setSelectedDiscount(v.rates);
                                            setselectedservices(v.id);
                                          }
                                        }}
                                      >
                                        {v.discount_typename}
                                      </button>
                                      {/* Display the original labels */}
                                      <p className="text-sm text-gray-500 mt-2">{v.labels}</p>
                                      {/* Display the dynamic message only for the selected frequency with bold and improved styling */}
                                      {selectedFrequency === v.discount_typename && (
                                        <p className="text-sm font-bold text-gray-700 mt-1 text-center">
                                          {message}
                                        </p>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                                {/* Service Provider Section */}
                                <div>
                                      <h2 className="text-lg font-semibold mb-4">
                                        Please select provider
                                      </h2>

                                      <div className="relative px-4 pb-4">
                                        {/* Previous Button */}
                                        <button
                                          type="button"
                                          onClick={() => scroll("prev")}
                                          className="absolute left-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-6 h-6"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M15 19l-7-7 7-7"
                                            />
                                          </svg>
                                        </button>

                                        {/* Scrollable Container */}
                                        <div
                                          ref={scrollRef}
                                          className="flex overflow-x-auto lg:flex lg:space-x-8 px-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
                                        >
                                          {adminData?.length > 0 ? (
                                            adminData.map((provider, index) => (
                                              <div
                                                key={index}
                                                className={`flex flex-col items-center cursor-pointer flex-shrink-0 ${
                                                  selectedProvider === provider
                                                    ? "border-teal-500"
                                                    : "border-gray-300"
                                                } border rounded-md p-4 m-2 sm:m-5 w-full sm:w-auto max-w-xs mx-auto`}
                                                onClick={() => {
                                                  if (selectedProvider === provider) {
                                                    // If the same provider is clicked again, unselect it
                                                    setSelectedProvider(null);
                                                    setgetidbyadmin(null); // Clear the staff ID
                                                  } else {
                                                    // Select the new provider
                                                    setSelectedProvider(provider);
                                                    setgetidbyadmin(provider.id); // Set the staff ID
                                                  }
                                                }}
                                              >
                                                <img
                                                  src={provider.image || "default-image.jpg"} // Fallback image if none provided
                                                  className="w-16 h-16 sm:w-24 sm:h-24 rounded-full mb-2 object-cover"
                                                />
                                                <p className="font-semibold text-gray-800 text-center text-sm sm:text-base">
                                                  {provider.fullname}
                                                </p>
                                                <p>{renderRatingStars(provider.rating)}</p>
                                              </div>
                                            ))
                                          ) : (
                                            <p className="text-gray-500 text-center w-full">
                                              No staff available for the selected service.
                                            </p>
                                          )}
                                        </div>

                                        {/* Next Button */}
                                        <button
                                          type="button"
                                          onClick={() => scroll("next")}
                                          className="absolute right-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-6 h-6"
                                            fill="none"
                                            viewBox="0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M9 5l7 7-7 7"
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                              </div>
                            )}
                          </div>

                          {/* Calendar Section */}
                          <div>
                            <div
                              className="flex justify-between bg-gray-400 p-2  rounded-sm text-lg font-medium"
                              onClick={toggleCalendarPanel}
                            >
                              <p>Calendar</p>

                              {/* Toggling icons */}
                              <p className="px-3">
                                {isCalendarOpen ? (
                                  <MdOutlineKeyboardArrowUp />
                                ) : (
                                  <MdOutlineKeyboardArrowDown />
                                )}
                              </p>
                            </div>

                            <div
                              className={`transition-all ease-in-out duration-1000  mb-4 overflow-hidden scrollbar-none  ${
                                isCalendarOpen
                                  ? "opacity-100 translate-y-0 max-h-[500px] overflow-y-auto"
                                  : "opacity-0 translate-y-4 max-h-0"
                              }`}
                            >
                              {isCalendarOpen && (
                                <div className="flex flex-col items-center mb-6 px-2 py-2 overflow-hidden border border-gray-300">
                                  <div className="flex justify-between items-center w-full max-w-4xl px-4 mb-4">
                                    <button
                                      type="button"
                                      onClick={handlePrevMonth}
                                      className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
                                    >
                                      Previous
                                    </button>
                                    <h2 className="text-xl font-semibold text-gray-700">
                                      {currentDate.toLocaleString("default", {
                                        month: "long",
                                      })}{" "}
                                      {currentDate.getFullYear()}
                                    </h2>
                                    <button
                                      type="button"
                                      onClick={handleNextMonth}
                                      className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
                                    >
                                      Next
                                    </button>
                                  </div>

                                  <div className="grid grid-cols-4 sm:grid-cols-7 gap-4 p-4 bg-gray-100 rounded-2xl shadow-inner">
                                  {calendar?.map((week, index) => (
                                    <div key={index} className="contents">
                                      {week?.map((day, dayIndex) => {
                                        const currentDay = new Date(
                                          currentDate.getFullYear(),
                                          currentDate.getMonth(),
                                          day
                                        );
                                        const isPastDate =
                                          currentDay < new Date().setHours(0, 0, 0, 0);
                                        const isSelected = daySelected === day && !isPastDate;
                                        const isToday =
                                          day === new Date().getDate() &&
                                          currentDate.getMonth() === new Date().getMonth() &&
                                          currentDate.getFullYear() === new Date().getFullYear();

                                        return (
                                          <button
                                            key={dayIndex}
                                            type="button"
                                            className={`w-12 h-12 sm:w-16 sm:h-12 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out 
                                              ${day ? "cursor-pointer" : "cursor-default"}
                                              ${day ? "hover:bg-blue-200 hover:text-white hover:shadow-lg hover:scale-110" : "opacity-0"}
                                              ${
                                                isPastDate
                                                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                : isSelected
                                                ? "!bg-blue-500 !text-white"
                                                : isToday
                                                ? "bg-red-500 text-gray-800"
                                                : "bg-white text-gray-700 border border-gray-200"
                                              }`}
                                            onClick={() => handleDateClick(day)}
                                            disabled={!day || isPastDate}
                                          >
                                            {day}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  ))}
                                </div>
                                {/* Today Button */}
                          <div className="flex justify-center mt-4">
                            <button
                              type="button"
                              onClick={() => {
                                const today = new Date();
                                setCurrentDate(today);
                                handleDateClick(today.getDate());
                                setSelectedDate(today);
                              }}
                              className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600 transition duration-200"
                            >
                              Today
                            </button>
                          </div>

                          {selectedDate && (
                                <div className="mt-4">
                                  <h3 className="text-lg text-red-800 font-semibold mb-4">
                                    Available Times for {format(selectedDate, "dd-MM-yyyy")}
                                  </h3>
                                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                                    {timeSlots?.map((slot, index) => {
                                      const [hours, minutes] = slot.split(":");
                                      const slotDate = new Date(selectedDate);
                                      slotDate.setHours(parseInt(hours), parseInt(minutes), 0);
                                      const isPast = slotDate < new Date();

                                      return (
                                        <button
                                          type="button"
                                          key={index}
                                          onClick={() => !isPast && handleTimeSelect(slot)}
                                          disabled={isPast}
                                          className={`
                                            py-3 px-4 rounded-xl text-sm font-semibold transition-all duration-200
                                            ${
                                              isPast
                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-60"
                                                : selectedTime === slot
                                                ? "bg-blue-600 text-white shadow-md transform scale-105"
                                                : "bg-white text-gray-800 hover:bg-blue-50 hover:text-blue-600 border border-gray-200"
                                            }
                                          `}
                                        >
                                          <div className="flex flex-col items-center space-y-1">
                                            <span>{slot}</span>
                                            <span className="text-xs font-normal">
                                              {isPast ? "Not Available" : "Available"}
                                            </span>
                                          </div>
                                        </button>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Form Section */}
                          <div>
                            <div
                              className="flex justify-between bg-gray-400 p-2  rounded-sm text-lg font-medium"
                              onClick={toggleFormPanel}
                            >
                              <p>Form</p>

                              {/* Toggling icons */}
                              <p className="px-3">
                                {isFormOpen ? (
                                  <MdOutlineKeyboardArrowUp />
                                ) : (
                                  <MdOutlineKeyboardArrowDown />
                                )}
                              </p>
                            </div>

                            <div
                              className={`transition-all scrollbar-none ease-in-out duration-1000 overflow-hidden ${
                                isFormOpen
                                  ? "opacity-100 translate-y-0 max-h-[500px] overflow-y-auto"
                                  : "opacity-0 translate-y-4 max-h-0"
                              }`}
                            >
                              <div className=" mx-auto p-6 border border-gray-300 ">
                                <h2 className="text-xl font-bold mb-4">
                                  Your Personal Details
                                </h2>
                                <p className="text-sm text-gray-600 mb-4">
                                  Please provide your address and contact
                                  details
                                </p>

                                {/* User Type Selector */}
                                <div className="flex items-center space-x-6 mb-6">
                                  <label className="flex items-center">
                                    <input
                                      type="radio"
                                      name="userType"
                                      value="existing"
                                      checked={userType === "existing"}
                                      onChange={() =>
                                        handleUserTypeChange("existing")
                                      }
                                      className="mr-2"
                                    />
                                    Existing User
                                  </label>
                                  <label className="flex items-center">
                                    <input
                                      type="radio"
                                      name="userType"
                                      value="new"
                                      checked={userType === "new"}
                                      onChange={() =>
                                        handleUserTypeChange("new")
                                      }
                                      className="mr-2"
                                    />
                                    New User
                                  </label>
                                </div>
                                {userType === "existing" ? (
                                  <div>
                                    <select
                                      id="crm-dropdown"
                                      value={selectedOption || ""}
                                      onChange={handleChangedata}
                                      className="border p-2 rounded-md bg-white focus:ring-2 focus:ring-blue-500"
                                    >
                                      <option value="">-- Select --</option>
                                      {crmgetdata.map((option) => (
                                        <option
                                          key={option.id}
                                          value={option.id}
                                        >
                                          {option.first_name} {option.last_name}
                                        </option>
                                      ))}
                                    </select>
                                    <form className="mt-5 grid grid-cols-1 gap-4 mb-6">
                                      <input
                                        type="email"
                                        name="email"
                                        placeholder="Preferred Email"
                                        value={userDetails.email || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md w-full"
                                      />
                                      <input
                                        type="password"
                                        name="password"
                                        placeholder="Preferred Password"
                                        value={userDetails.password || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md w-full"
                                      />
                                      <div className="grid grid-cols-2 gap-4">
                                        <input
                                          type="text"
                                          name="firstName"
                                          placeholder="First Name"
                                          value={userDetails.firstName || ""}
                                          onChange={handleUserDetailsChange}
                                          className="border p-2 rounded-md"
                                        />
                                        <input
                                          type="text"
                                          name="lastName"
                                          placeholder="Last Name"
                                          value={userDetails.lastName || ""}
                                          onChange={handleUserDetailsChange}
                                          className="border p-2 rounded-md"
                                        />
                                      </div>
                                      <div className="grid grid-cols-2 gap-4">
                                        <input
                                          type="text"
                                          name="phone"
                                          placeholder="Phone"
                                          value={userDetails.phone || ""}
                                          onChange={handleUserDetailsChange}
                                          className="border p-2 rounded-md"
                                        />
                                        <input
                                          type="text"
                                          name="streetAddress"
                                          placeholder="Street Address"
                                          value={
                                            userDetails.streetAddress || ""
                                          }
                                          onChange={handleUserDetailsChange}
                                          className="border p-2 rounded-md w-full"
                                        />
                                      </div>
                                      <div className="grid grid-cols-3 gap-4">
                                        <input
                                          type="text"
                                          name="zipCode"
                                          placeholder="Zip CodeHHHHHHHH"
                                          value={userDetails.zipCode || ""}
                                          onChange={handleUserDetailsChange}
                                          className="border p-2 rounded-md"
                                        />
                                        <input
                                          type="text"
                                          name="city"
                                          placeholder="City"
                                          value={userDetails.city || ""}
                                          onChange={handleUserDetailsChange}
                                          className="border p-2 rounded-md"
                                        />
                                        <input
                                          type="text"
                                          name="state"
                                          placeholder="State"
                                          value={userDetails.state || ""}
                                          onChange={handleUserDetailsChange}
                                          className="border p-2 rounded-md"
                                        />
                                      </div>
                                      <textarea
                                        name="specialRequests"
                                        placeholder="Special Requests (Notes)"
                                        value={
                                          userDetails.specialRequests || ""
                                        }
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md w-full"
                                        rows="3"
                                      ></textarea>
                                    </form>
                                  </div>
                                ) : (
                                  <div className="grid grid-cols-1 gap-4 mb-6 p-6 bg-white shadow-lg rounded-lg max-w-lg mx-auto">
                                    {/* Email */}
                                    <div>
                                    <input
                                      type="email"
                                      name="email"
                                      placeholder="Preferred Email"
                                      value={userDetails.email || ""}
                                      onChange={handleUserDetailsChange}
                                      className="border p-2 rounded-md w-full"
                                    />
                                    {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                                  </div>

                                  {/* Password */}
                                  <div>
                                    <input
                                      type="password"
                                      name="password"
                                      placeholder="Preferred Password"
                                      value={userDetails.password || ""}
                                      onChange={handleUserDetailsChange}
                                      className="border p-2 rounded-md w-full"
                                    />
                                    {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
                                  </div>

                                  {/* First Name and Last Name */}
                                  <div className="grid grid-cols-2 gap-4">
                                    <div>
                                      <input
                                        type="text"
                                        name="firstName"
                                        placeholder="First Name"
                                        value={userDetails.firstName || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md"
                                      />
                                      {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
                                    </div>
                                    <div>
                                      <input
                                        type="text"
                                        name="lastName"
                                        placeholder="Last Name"
                                        value={userDetails.lastName || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md"
                                      />
                                      {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
                                    </div>
                                  </div>

                                  {/* Phone and Street Address */}
                                  <div className="grid grid-cols-2 gap-4">
                                    <div>
                                      <input
                                        type="text"
                                        name="phone"
                                        placeholder="Phone"
                                        value={userDetails.phone || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md"
                                      />
                                      {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
                                    </div>
                                    <div>
                                      <input
                                        type="text"
                                        name="streetAddress"
                                        placeholder="Street Address"
                                        value={userDetails.streetAddress || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md w-full"
                                      />
                                      {errors.streetAddress && <p className="text-red-500 text-sm mt-1">{errors.streetAddress}</p>}
                                    </div>
                                  </div>

                                  {/* Zip Code, City, and State */}
                                  <div className="grid grid-cols-3 gap-4">
                                    <div>
                                      <input
                                        type="text"
                                        name="zipCode"
                                        placeholder="Zip Code"
                                        value={userDetails.zipCode || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md"
                                      />
                                      {errors.zipCode && <p className="text-red-500 text-sm mt-1">{errors.zipCode}</p>}
                                    </div>
                                    <div>
                                      <input
                                        type="text"
                                        name="city"
                                        placeholder="City"
                                        value={userDetails.city || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md"
                                      />
                                      {errors.city && <p className="text-red-500 text-sm mt-1">{errors.city}</p>}
                                    </div>
                                    <div>
                                      <input
                                        type="text"
                                        name="state"
                                        placeholder="State"
                                        value={userDetails.state || ""}
                                        onChange={handleUserDetailsChange}
                                        className="border p-2 rounded-md"
                                      />
                                      {errors.state && <p className="text-red-500 text-sm mt-1">{errors.state}</p>}
                                    </div>
                                  </div>
                                    {/* Special Requests */}
                                    <textarea
                                      name="specialRequests"
                                      placeholder="Special Requests (Notes)"
                                      value={userDetails.specialRequests || ""}
                                      onChange={handleUserDetailsChange}
                                      className="border p-2 rounded-md w-full"
                                      rows="3"
                                    ></textarea>

                                    {/* Vacuum Cleaner */}
                                    <div className="flex justify-between items-center mb-4">
                                      <span className="text-gray-700">
                                        Do you have a vacuum cleaner?
                                      </span>
                                      <div className="flex space-x-4">
                                        <label className="flex items-center space-x-1">
                                          <input
                                            type="radio"
                                            name="vacuum"
                                            value="yes"
                                            checked={vacuum === "yes"}
                                            onChange={() => setVacuum("yes")}
                                            className="accent-blue-500"
                                          />
                                          <span>Yes</span>
                                        </label>
                                        <label className="flex items-center space-x-1">
                                          <input
                                            type="radio"
                                            name="vacuum"
                                            value="no"
                                            checked={vacuum === "no"}
                                            onChange={() => setVacuum("no")}
                                            className="accent-gray-500"
                                          />
                                          <span>No</span>
                                        </label>
                                      </div>
                                    </div>

                                    {/* Parking */}
                                    <div className="flex justify-between items-center mb-4">
                                      <span className="text-gray-700">
                                        Do you have parking?
                                      </span>
                                      <div className="flex space-x-4">
                                        <label className="flex items-center space-x-1">
                                          <input
                                            type="radio"
                                            name="parking"
                                            value="yes"
                                            checked={parking === "yes"}
                                            onChange={() => setParking("yes")}
                                            className="accent-blue-500"
                                          />
                                          <span>Yes</span>
                                        </label>
                                        <label className="flex items-center space-x-1">
                                          <input
                                            type="radio"
                                            name="parking"
                                            value="no"
                                            checked={parking === "no"}
                                            onChange={() => setParking("no")}
                                            className="accent-gray-500"
                                          />
                                          <span>No</span>
                                        </label>
                                      </div>
                                    </div>

                                    {/* How will we get in? */}
                                    <div className="mb-4">
                                      <label className="block text-gray-700 mb-2">
                                        How will we get in?
                                      </label>
                                      <select
                                        value={access}
                                        onChange={(e) =>
                                          setAccess(e.target.value)
                                        }
                                        className="w-full p-2 border border-gray-300 rounded-lg"
                                      >
                                        <option value="I'll be at home">
                                          I'll be at home
                                        </option>
                                        <option value="Please call me">
                                          Please call me
                                        </option>
                                        <option value="The key is with the doorman">
                                          The key is with the doorman
                                        </option>
                                        <option value="other">Other</option>
                                      </select>
                                    </div>

                                    {/* Submit Button */}
                                    <button
                                      onClick={handleSubmitdata}
                                      className="bg-blue-500 text-white p-2 rounded-md w-full"
                                    >
                                      Booked And New User Created
                                    </button>
                                  </div>
                                )}
                                <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-5 p-5 bg-white">
                                  <h3 className="text-lg font-semibold mb-3">
                                    Apply Promo Code
                                  </h3>
                                  <div className="flex gap-2">
                                    <input
                                      type="text"
                                      value={promoCode}
                                      onChange={(e) =>
                                        setPromoCode(e.target.value)
                                      }
                                      placeholder="Enter promo code"
                                      className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <button
                                      type="button"
                                      onClick={handleApplyPromoCode}
                                      className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                                    >
                                      Apply
                                    </button>
                                  </div>

                                  {/* Error Message */}
                                  {error && (
                                    <p className="text-red-600 mt-2">{error}</p>
                                  )}

                                  {/* Success Message & Cancel Button */}
                                  {appliedPromoCode && (
                                    <div className="flex justify-between items-center mt-2 p-2 bg-green-100 rounded-md">
                                      <p className="text-green-700">
                                        Promo code "
                                        {appliedPromoCode.coupon_code}" applied!
                                        ({appliedPromoCode.coupon_value}
                                        {appliedPromoCode.coupon_type === "P"
                                          ? "%"
                                          : "$"}{" "}
                                        off)
                                      </p>
                                      <button
                                        type="button"
                                        onClick={handleCancelPromo}
                                        className="text-red-600 font-semibold hover:underline"
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  )}
                                </div>

                                {/* Payment Method */}
                                <div className="mb-6">
                                  <h3 className="font-bold mb-2">
                                    Preferred Payment Method
                                  </h3>

                                  {/* Pay Locally option */}
                                  <label className="flex items-center">
                                    <input
                                      type="radio"
                                      name="paymentMethod"
                                      value="payLocally"
                                      checked={paymentMethod === "payLocally"}
                                      onChange={handlePaymentChange}
                                      className="mr-2"
                                    />
                                    Pay Locally
                                  </label>

                                  {/* Pay Online option */}
                                  <label className="flex items-center ">
                                    <input
                                      type="radio"
                                      name="paymentMethod"
                                      value="payOnline"
                                      checked={paymentMethod === "payOnline"}
                                      onChange={handlePaymentChange}
                                      className="mr-2"
                                    />
                                    Pay Online
                                  </label>
                                </div>
                                <div className="mb-6">
                                  <label className="items-center flex">
                                    <input
                                      type="checkbox"
                                      className="mr-2"
                                      checked={isChecked}
                                      onChange={() => setIsChecked(!isChecked)}
                                    />
                                    I have read and accepted the{" "}
                                    <a
                                      href="/"
                                      className="text-teal-600 underline"
                                    >
                                      Terms & Conditions
                                    </a>
                                    .
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Submit Button */}
                          <div className="flex justify-center mt-6">
                            <button
                              type="submit"
                              className="bg-blue-800 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-600 transition duration-300"
                            >
                              Submit Booking
                            </button>
                          </div>
                        </form>
                        <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-10 p-6 bg-white sticky top-10 mb-7">
                          <h2 className="text-xl font-bold text-center border-b pb-3 mb-4">
                            Booking Summary
                          </h2>

                          <div className="flex items-center  text-sm text-gray-600 mb-4">
                            {/* Booking Details */}

                            <div className="flex items-center space-x-2">
                              <span className="material-icons text-gray-500">
                                Calendar today :
                              </span>
                              {selectedDate && selectedTime && (
                                <p>
                                  {selectedDate} @ {selectedTime}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center space-x-2">
                            <span className="material-icons text-gray-500">
                              Auto renew :
                            </span>
                            <p>{selectedFrequency}</p>
                          </div>
                          <div className="flex items-center space-x-2 mb-4 text-gray-600">
                            <span className="material-icons text-gray-500">
                              Time duration :
                            </span>
                            <p>
                              {Math.floor(totalTime / 60)} hours{" "}
                              {totalTime % 60} Minutes
                            </p>
                          </div>

                          <div className="mb-6">
                            <h3 className="font-bold mb-2">Cart Items :</h3>
                            {bookingBill.length === 0 ? (
                              <p className="text-gray-500">
                                No items selected.
                              </p>
                            ) : (
                              <ul>
                                {bookingBill.map((item, idx) => (
                                  <li
                                    key={idx}
                                    className="flex justify-between mb-2"
                                  >
                                    <span>
                                      {item.name}
                                      {item.type} (x{item.qty})
                                    </span>

                                    <div className="flex gap-4">
                                      <span> ₹{item.rate}</span>
                                      <span
                                        onClick={() => removeItem(idx)}
                                        className="text-red-500 cursor-pointer"
                                      >
                                        X
                                      </span>
                                    </div>
                                  </li>
                                ))}
                                <>
                                  {Object.keys(propertyQuantities).map((item) =>
                                    propertyQuantities[item] > 0 ? (
                                      <li
                                        key={item}
                                        className="flex justify-between mb-2"
                                      >
                                        <span>
                                          {item.charAt(0).toUpperCase() +
                                            item.slice(1)}{" "}
                                          (x
                                          {propertyQuantities[item]})
                                        </span>
                                        <span>
                                          ${propertyQuantities[item] * 10}
                                        </span>
                                      </li>
                                    ) : null
                                  )}

                                  {damagedFloors > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>
                                        Damaged Floors (x{damagedFloors})
                                      </span>
                                      <span>${damagedFloors * 10}</span>
                                    </li>
                                  )}

                                  {doorJams > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>Door Jams (x{doorJams})</span>
                                      <span>${doorJams * 10}</span>
                                    </li>
                                  )}
                                </>
                                <>
                                  {area > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>Cleaning Area ({area} sq.ft)</span>
                                      <span>${area * 2}</span>
                                    </li>
                                  )}

                                  {extraDamagedFloors > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>
                                        Extra Damaged Floors (x
                                        {extraDamagedFloors})
                                      </span>
                                      <span>${extraDamagedFloors * 10}</span>
                                    </li>
                                  )}

                                  {extraDoorJams > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>
                                        Extra Door Jams (x{extraDoorJams})
                                      </span>
                                      <span>${extraDoorJams * 10}</span>
                                    </li>
                                  )}
                                </>

                                <>
                                  {Object.keys(officeQuantities).map((item) =>
                                    officeQuantities[item] > 0 ? (
                                      <li
                                        key={item}
                                        className="flex justify-between mb-2"
                                      >
                                        <span>
                                          {item.charAt(0).toUpperCase() +
                                            item.slice(1)}{" "}
                                          (x
                                          {officeQuantities[item]})
                                        </span>
                                        <span>
                                          ${officeQuantities[item] * 10}
                                        </span>
                                      </li>
                                    ) : null
                                  )}

                                  {packing > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>Packing Cleaning (x{packing})</span>
                                      <span>${packing * 10}</span>
                                    </li>
                                  )}

                                  {storeroom > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>
                                        StoreRoom Cleaning (x{storeroom})
                                      </span>
                                      <span>${storeroom * 10}</span>
                                    </li>
                                  )}
                                </>
                                <>
                                  {officearea > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>
                                        Cleaning Area ({officearea} sq.ft)
                                      </span>
                                      <span>${officearea * 2}</span>
                                    </li>
                                  )}

                                  {officeextraDamagedFloors > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>
                                        Parking Cleaning (x
                                        {officeextraDamagedFloors})
                                      </span>
                                      <span>
                                        ${officeextraDamagedFloors * 10}
                                      </span>
                                    </li>
                                  )}

                                  {officeextraDoorJams > 0 && (
                                    <li className="flex justify-between mb-2">
                                      <span>
                                        StoreRoom Cleaning (x
                                        {officeextraDoorJams})
                                      </span>
                                      <span>${officeextraDoorJams * 10}</span>
                                    </li>
                                  )}
                                </>
                              </ul>
                            )}
                          </div>

                          <div className="border-t pt-4 text-black-800">
                            <div className="flex justify-between mb-2">
                              <p>Sub Total :</p>
                              <p>
                                ₹
                                {isNaN(calculateTotal()) ? 0 : calculateTotal()}
                              </p>
                            </div>
                            <div className="flex justify-between mb-2">
                              <p>Frequently Discount:- </p>
                              <p>-{Disamount}</p>
                            </div>
                            {appliedPromoCode && (
                              <div className="flex justify-between mb-2">
                                <p>
                                  Promo Code ({appliedPromoCode.coupon_code}) :
                                </p>
                                <p>-₹{promoDiscount}</p>
                              </div>
                            )}
                            <div className="flex justify-between mb-4">
                              <p>Tax :</p>
                              <p>{tax}</p>
                            </div>
                            <div className="flex justify-between font-bold text-lg">
                              <p>Total :</p>
                              <p>₹{parseFloat(text)}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
     
    </div>
  );
};

export default Calendar;
		


  



// import React, { useState, useEffect, useRef } from "react";
// import { addHours } from "date-fns";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faStar as fullStar, faStarHalfAlt, faStar as emptyStar } from "@fortawesome/free-solid-svg-icons";
// import clsx from "clsx";
// import {MdKeyboardDoubleArrowLeft,MdKeyboardDoubleArrowRight,MdOutlineKeyboardArrowUp} from "react-icons/md";
// import { Link, useNavigate } from "react-router-dom";
// import { FaEdit } from "react-icons/fa";
// import { BiSolidEdit } from "react-icons/bi";
// import {  format,addMonths,subMonths,startOfWeek,endOfWeek,addDays,subDays,} from "date-fns";
// import { MdOutlineKeyboardArrowDown } from "react-icons/md";
// import image1 from "../assets/house.png";
// import fridgeCleaning from "../assets/fridge.png";
// import ovenCleaning from "../assets/oven.png";
// import windowCleaning from "../assets/windows.png";
// import Bed from "../assets/beds.png";
// import axios from "axios";
// import { BaseUrl } from "../App";

// // import { Circles } from "react-loader-spinner";

// import { FadeLoader } from 'react-spinners';

// // import { useAuth } from "../components/AuthContext";

// const Calendar = () => {
//   const [isChecked, setIsChecked] = useState(false);
//   // const { isAuthenticated } = useAuth();
//   const [zipCodeError, setZipCodeError] = useState("");
//   const [settings, setSettings] = useState({});
//   const [selectedQty, setSelectedQty] = useState({});
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   const [activeView, setActiveView] = useState("month"); // Manage active view: 'month', 'week', or 'day'
//   const [showModal, setShowModal] = useState(false);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [staffdata, setstaffdata] = useState([]);
//   const [appliedPromoCode, setAppliedPromoCode] = useState(null);
//   const [promoCodes, setPromoCodes] = useState([]);
//   const [promoDiscount, setPromoDiscount] = useState(0);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showBookingSummary, setShowBookingSummary] = useState(false);
//   const [showBookingSummary2, setShowBookingSummary2] = useState(false);
//   const [isServiceOpen, setIsServiceOpen] = useState(false); // Toggle "Choose Services"
//   const [isCalendarOpen, setIsCalendarOpen] = useState(false); // Toggle Calendar panel
//   const [isFormOpen, setIsFormOpen] = useState(false);
//   const [selectedOption, setSelectedOption] = useState("");
//   const [allServices, setallServices] = useState([]);
//   const [optiondata, setoptiondata] = useState([]);
//   const [selectedStaff, setSelectedStaff] = useState([]);
//    const [getidbyadmin, setgetidbyadmin] = useState(null);
//   const [selectedOptions, setSelectedOptions] = useState({});
//   const [methodRates, setMethodRates] = useState({});
//   const [methodQuantities, setMethodQuantities] = useState({});
//   const [editedMethodQuantities, setEditedMethodQuantities] = useState({});
//   const [editedAddonQuantities, setEditedAddonQuantities] = useState({});
//   const [successMessage, setSuccessMessage] = useState("");
//    const [idpromocode, setidpromocode] = useState(null);
//   const [useriddata, setuseriddata] = useState(null);
//   const [daySelected, setDaySelected] = useState(null); // Track selected day
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   console.log(useriddata);
//   const [promoCode, setPromoCode] = useState("");
//   const [showSelected, setShowSelected] = useState(false);
//   const [userId, setUserId] = useState(null);
//   const [showEditServiceModal, setShowEditServiceModal] = useState(false);
//   const [userSelectedMethods, setUserSelectedMethods] = useState(null);
//   const [userSelectedMethodsId, setUserSelectedMethodsId] = useState(null);
//   const [userSelectedMethodsUnitsId, setUserSelectedMethodsUnitsId] =
//     useState(null);
//   const [userSelectedMethodsSmqty, setUserSelectedMethodsSmqty] =
//     useState(null);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   console.log(selectedAppointment);
//   const [order_id_appointment, setorder_id_appointment] = useState(0);
//   const [userSelectedAddon, setUserSelectedAddon] = useState(null);
//   const [services, setServices] = useState([]);
//   console.log(selectedStaff);
//   const [personalDetails, setPersonalDetails] = useState({
//     streetAddress: "",
//     zipCode: "",
//     city: "",
//     state: "",
//   });
//   const [appointmentDetails, setAppointmentDetails] = useState({
//     streetAddress: "",
//     zipCode: "",
//     city: "",
//     state: "",
//   });
//   const [hoveredEvent, setHoveredEvent] = useState(null);
//   const [userType, setUserType] = useState("new");
//   const [vacuum, setVacuum] = useState("no");
//   const [parking, setParking] = useState("no");
//   const [access, setAccess] = useState("");
//   const [allsetdata, setallsetdata] = useState();
//   const [sameAsAbove, setSameAsAbove] = useState(false);
//   const [selectedFrequency, setSelectedFrequency] = useState("");
//   const [selectedDiscount, setSelectedDiscount] = useState(0);
//   const [Distext, setSelectedDistext] = useState(10);
//   const [text, setText] = useState();
//   const navigate = useNavigate();
//   const [selectedProvider, setSelectedProvider] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedTime, setSelectedTime] = useState(null);
//   console.log(selectedDate, selectedTime);
//   const [selectedservices, setselectedservices] = useState(0);
//   const [showImageSection, setShowImageSection] = useState(false);
//   const [selectedService, setSelectedService] = useState(null);
//   const [residential, setResidential] = useState(false);
//   const [commercial, setCommercial] = useState(false);
//   const [bookingBill, setBookingBill] = useState([]);
//   const [bedroom, setBedroom] = useState({});
//   const [bathroom, setBathroom] = useState(0);
//   const [quantities, setQuantities] = useState([0, 0, 0]);
//   const [officeresidential, setofficeResidential] = useState(false);
//   const [officecommercial, officesetCommercial] = useState(false);
//   const [showForm, setShowForm] = useState(false);
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [bookedSlots, setBookedSlots] = useState({});
//   const [selectedMethod, setSelectedMethod] = useState(null);
//   const [bookingappointment, setbookingappointment] = useState([]);
//   console.log(bookingappointment);
//   const [propertyQuantities, setPropertyQuantities] = useState({
//     Build_walls: 0,
//     Build_doors: 0,
//     Build_windows: 0,
//   });
//   const [officeQuantities, setOfficeQuantities] = useState({
//     desk: 0,
//     window: 0,
//   });
//   const [tax, settax] = useState(0);
//   const [damagedFloors, setDamagedFloors] = useState(0);
//   const [doorJams, setDoorJams] = useState(0);
//   const [packing, setPacking] = useState(0);
//   const [storeroom, setStoreroom] = useState(0);
//   const [area, setArea] = useState(0);
//   const [timeSlots, setTimeSlots] = useState([]);
//   const [error, setError] = useState("");
//   console.log(timeSlots);
//   const [officearea, setOfficeArea] = useState(0);
//   const [extraDamagedFloors, setExtraDamagedFloors] = useState(0);
//   const [extraDoorJams, setExtraDoorJams] = useState(0);
//   const [Disamount, setDisamount] = useState(0);
//   const [officeextraDamagedFloors, setofficeExtraDamagedFloors] = useState(0);
//   const [officeextraDoorJams, setofficeExtraDoorJams] = useState(0);
//   const [adminData, setAdminData] = useState(null);
//   console.log(adminData);
//   const [calenderdata, setcalenderdata] = useState([]);
//   const [Services_frequently_discount, setServices_frequently_discount] =
//     useState([]);
//   const [icon, setIcon] = useState("+"); // State to control the icon (either "+" or "-")
//   const [activeTab, setActiveTab] = useState("Residential");
//   const [formData, setFormData] = useState({
//     serviceLocation: "",
//     zipCode: "",
//     selectedService: "",
//     image: image1,
//     showHouseOptions: false,
//     showPlumbingOptions: false,
//     showCarpenterOptions: false,
//     showOfficeOptions: false,

//     bedroomCount: "",
//     bathroomCount: "",
//   });
//   const [crmgetdata, setcrmgetdata] = useState([]);
//   const [dayseleted, setdayseleted] = useState(null);
//   const [timeSelected, settimeSelected] = useState(null);
//   const [userDetails, setUserDetails] = useState({
//     id: "",
//     email: "",
//     password: "",
//     firstName: "",
//     lastName: "",
//     phone: "",
//     streetAddress: "",
//     city: "",
//     state: "",
//     zipCode: "",
//     postalCode: "",
//     specialRequests: "",
//   });
//   const [databooking, setdatabooking] = useState([]);
//   const [activeService, setActiveService] = useState(null);
//   const [serviceCounts, setServiceCounts] = useState({});
//   const extraServices = [
//     { image: fridgeCleaning, name: "Fridge Cleaning", price: "$50" },
//     { image: ovenCleaning, name: "Oven Cleaning", price: "$40" },
//     { image: windowCleaning, name: "Inside Window Cleaning", price: "$30" },
//   ];
//   const [paymentMethod, setPaymentMethod] = useState("payLocally"); // Set default to 'payLocally'
//   const [showAllEvents, setShowAllEvents] = useState(false);
//   const [totalTime, setTotalTime] = useState(0); // To track total time
//   const [detailsdata, setDetailsdata] = useState({});
//   console.log(detailsdata);
//   const [Detailsiud, setDetailsiud] = useState(null); // Set default to
//   // const [showForm, setShowForm] = useState(false);
//   const [rejectReason, setRejectReason] = useState("");
//   const [showRescheduleModal, setShowRescheduleModal] = useState(false);
//   const [amount, setAmount] = useState("");
//   const [notes, setNotes] = useState("");
//   const [rescheduleDate, setRescheduleDate] = useState(""); // Changed name here
//   const [rescheduledData, setRescheduledData] = useState(null);
//   const [subtotale, setsubtotale] = useState(0);
//   const [isBookingComplete, setIsBookingComplete] = useState(false);
//   const [Detailsiuddata, setDetailsiuddata] = useState(null);
//   const [totelamount, setTotelamount] = useState(0); // Already declared as abctotelamount, but misspelled
//   const [disType, setDisType] = useState(null)
//   const handleRescheduleClick = (id) => {
//     setShowRescheduleModal(true);
//     setDetailsiuddata(id);
//   };

//   // Close modal
//   const closeRescheduleModal = () => {
//     // Changed name here
//     setShowRescheduleModal(false);
//   };
//   useEffect(() => {
//     let timer;
//     if (error) {
//       timer = setTimeout(() => {
//         setError("");
//       }, 5000); // 5 seconds
//     }
//     return () => clearTimeout(timer);
//   }, [error]);
//   // const handleSelectChange = (event) => {
//   //   const selectedId = event.target.value; // Extract values
//   //   setSelectedStaff(selectedId); // Update state
//   // };
//   const handleSelectChange = (e) => {
//     const selectedOptions = Array.from(e.target.selectedOptions).map(
//       (option) => option.value
//     );
//     setSelectedStaff(selectedOptions);
//   };
//   const fetchSettings = async () => {
//     setLoading(true); // Use your existing loading state
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/settings.php`,
//         {
//           action: "get_all_settings",
//           api_key: "1",
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
  
//       if (response.data.status === "true" && response.data.statuscode === 200) {
//         const fetchedSettings = response.data.response.reduce((acc, item) => {
//           if (item.option_name === "ct_postal_code") {
//             acc[item.option_name] = item.postalcode; // Store postal codes as a comma-separated string
//           } else {
//             acc[item.option_name] = item.option_value;
//           }
//           return acc;
//         }, {});
  
//         setSettings((prevSettings) => ({
//           ...prevSettings,
//           ...fetchedSettings,
//         }));
//       } else {
//         throw new Error(response.data.response || "Failed to fetch settings");
//       }
//     } catch (error) {
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };
//   // Call fetchSettings on component mount
// useEffect(() => {
//   fetchSettings();
// }, []);
// const handleZipCodeChange = (e) => {
//   const value = e.target.value;
//   setFormData({
//     ...formData,
//     zipCode: value,
//   });

//   // Split postal codes into an array for comparison
//   const validZipCodes = settings["ct_postal_code"]?.split(",") || [];

//   // Check if the entered zip code matches any valid postal code
//   if (value.length > 0 && !validZipCodes.includes(value)) {
//     setZipCodeError("Our service is not available at your location");
//   } else {
//     setZipCodeError(""); // Clear error if valid or empty
//   }
// };
//   const fetchPromoCodes = async () => {
//     try {
//       const payload = {
//         action: "get_all_coupons",
//         api_key: "1",
//       };

//       const response = await axios.post(
//         `${BaseUrl}/backend/api/promocode.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       console.log(response.data);
//       if (response.data.status === "true") {
//         setPromoCodes(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching promo codes:", error);
//     }
//   };

//   // Add this useEffect to fetch promocodes on component mount
//   useEffect(() => {
//     fetchPromoCodes();
//   }, []);

//   useEffect(() => {
//     if (detailsdata?.staff_ids && detailsdata.staff_ids.length > 0) {
//       setSelectedStaff(detailsdata.staff_ids);
//     }
//   }, [detailsdata?.staff_ids]);
//   // Toggle the display of selected IDs
//   // const handleEditClick = async () => {
//   //   setLoading(true);
//   //   setShowSelected(!showSelected);
//   //   try {
//   //     // Define the request payload
//   //     const payload = {
//   //       action: "staff_assign_to_booking", // Action to fetch all services
//   //       api_key: "1",
//   //       order_id: detailsdata.id,
//   //       staff_ids: selectedStaff,
//   //     };

//   //     console.log(payload);

//   //     // Make the POST request with the payload
//   //     const response = await axios.post(
//   //       `${BaseUrl}/backend/api/staff_assign.php`,
//   //       payload, // Request body
//   //       {
//   //         headers: {
//   //           "Content-Type": "application/json", // Specify JSON format
//   //         },
//   //       }
//   //     );

//   //     console.log(response);

//   //     // Check if the response contains valid data
//   //     if (response.data.status === "true") {
//   //       setSuccessMessage("Assign Staff successfully!");
//   //       const services = response.data;
//   //       console.log(services);
//   //     } else {
//   //       console.log("API response indicates failure:", response.data);
//   //     }

//   //     bookeddata();
//   //     handleCloseModal();
//   //   } catch (error) {
//   //     console.log("Error fetching data:", error);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handleEditClick = async () => {
//     setLoading(true);
//     setShowSelected(!showSelected);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "staff_assign_to_booking",
//         api_key: "1",
//         order_id: detailsdata.id,
//         staff_ids: selectedStaff, // This will contain only currently selected staff IDs
//       };
  
//       console.log("Payload being sent:", payload);
  
//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/staff_assign.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
  
//       console.log("API Response:", response);
  
//       // Check if the response contains valid data
//       if (response.data.status === "true") {
//         setSuccessMessage("Staff assignment updated successfully!");
//         console.log("Updated staff data:", response.data);
//       } else {
//         console.log("API response indicates failure:", response.data);
//         setSuccessMessage("Failed to update staff assignment");
//       }
//       getappointmentdetails();
//       bookeddata(); // Refresh the data
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error updating staff assignment:", error);
//       setSuccessMessage("Error updating staff assignment");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleUpdate = async (e, rescheduleDate) => {
//     e.preventDefault();
//     setLoading(true);
//     // Validate the rescheduleDate
//     if (!rescheduleDate || isNaN(new Date(rescheduleDate).getTime())) {
//       alert("Invalid date. Please provide a valid date.");
//       return;
//     }
//     // Format the reschedule date into a readable format
//     const formattedDate = new Date(rescheduleDate)
//       .toISOString()
//       .slice(0, 19)
//       ?.replace("T", " ");
//     // Data to save
//     const [date, time] = formattedDate.split(" "); // Split into date and time

//     // Log data to the console (optional)
//     console.log("Rescheduled Data:", date, time, Detailsiuddata, notes);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "reschedule_appointment", // Fixed value to identify the action
//         api_key: 1, // Your system's API key for authentication
//         order_id: Detailsiuddata, // The ID of the appointment to reschedule
//         notes: notes, // Any notes about the reschedule
//         date: date, // New date (YYYY-MM-DD format)
//         time: time, // New time (HH:mm format)
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reshedule.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data.status === "true") {
//         const services = response.data;
//         setSuccessMessage("Appointment Reschdule successfully!");
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       getappointmentdetails();
//       bookeddata();
//       setRescheduledData(response.data);
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//     closeRescheduleModal();
//   };

//   const handleRejectClick = () => {
//     setShowForm(!showForm); // Toggle form visibility
//   };

//   const handleReject = async (id, e) => {
//     e.preventDefault();
//     setLoading(true);
//     console.log("Reject Reason:", rejectReason, id);
//     // Add your logic here to handle the reject reason
//     try {
//       // Define the request payload
//       const payload = {
//         action: "reject_appointment", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//         reject_reason: rejectReason,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_reject.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data.status === "true") {
//         const services = response.data;
//         setSuccessMessage("Appointment rejected successfully!");
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       getappointmentdetails();
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }

//     setShowForm(false); // Close the form after submission
//   };

//   const handlePaymentChange = (e) => {
//     setPaymentMethod(e.target.value);
//   };

//   const handleBedroomChange = (unitId, value) => {
//     setSelectedOptions((prev) => ({
//       ...prev,
//       [unitId]: value,
//     }));
//     setBedroom((prevSelections) => ({
//       ...prevSelections,
//       [unitId]: value,
//     }));
//   };

//   // const addItemToBill = (id, itemName, quantity, pricePerItem) => {
//   //   setBookingBill((prevBill) => {
//   //     const existingItemIndex = prevBill.findIndex(
//   //       (item) => item.name === itemName
//   //     );

//   //     let updatedBill;

//   //     if (existingItemIndex !== -1) {
//   //       updatedBill = [...prevBill];
//   //       updatedBill[existingItemIndex].quantity += quantity;
//   //       updatedBill[existingItemIndex].price += quantity * pricePerItem;
//   //     } else {
//   //       updatedBill = [
//   //         ...prevBill,
//   //         {
//   //           method_id: selectedMethod.method_id,
//   //           service_id: selectedService,
//   //           unit_id: id,
//   //           type: "unit",
//   //           name: itemName,
//   //           qty: quantity,
//   //           rate: quantity * pricePerItem,
//   //         },
//   //       ];
//   //     }

//   //     // Calculate the new total time (add 60 minutes for each new unit added)
//   //     const newTotalTime =
//   //       prevBill.reduce(
//   //         (time, item) => time + (item.qty ? item.qty : 0) * 60,
//   //         0
//   //       ) +
//   //       quantity * 60;

//   //     // Update the state for both the bill and total time
//   //     setTotalTime(newTotalTime);
//   //     return updatedBill;
//   //   });
//   // };
//   const addItemToBill = (id, itemName, quantity, pricePerItem, serviceTitle) => {
//     setBookingBill((prevBill) => {
//       // Find if the item already exists in the bill
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.unit_id === id && item.name === itemName
//       );
  
//       let updatedBill;
  
//       if (existingItemIndex !== -1) {
//         // If the item exists, replace it with the new quantity
//         updatedBill = [...prevBill];
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             method_id: selectedMethod.method_id,
//             service_id: selectedService,
//             unit_id: id,
//             type: "unit",
//             name: itemName,
//             service_title: serviceTitle,
//             qty: quantity, // Replace the old quantity with the new one
//             rate: quantity * pricePerItem, // Recalculate the price
//           };
//         } else {
//           // If quantity is 0, remove the item
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         // If the item doesn't exist and quantity > 0, add it as a new entry
//         updatedBill = [
//           ...prevBill,
//           {
//             method_id: selectedMethod.method_id,
//             service_id: selectedService,
//             unit_id: id,
//             type: "unit",
//             name: itemName,
//             service_title: serviceTitle,
//             qty: quantity,
//             rate: quantity * pricePerItem,
//           },
//         ];
//       } else {
//         // If quantity is 0 and item doesn't exist, return the bill unchanged
//         updatedBill = [...prevBill];
//       }
  
//       // Recalculate total time based on the updated bill
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);
  
//       return updatedBill;
//     });
//   };
//   const toggleSelection = (unitId, quantity) => {
//     setSelectedQty((prevSelectedQtys) => {
//       const newSelectedQtys = { ...prevSelectedQtys };
//       if (
//         newSelectedQtys[unitId] &&
//         newSelectedQtys[unitId].includes(quantity)
//       ) {
//         // If already selected, remove it
//         newSelectedQtys[unitId] = newSelectedQtys[unitId].filter(
//           (qty) => qty !== quantity
//         );
//       } else {
//         // If not selected, add it
//         newSelectedQtys[unitId] = [
//           ...(newSelectedQtys[unitId] || []),
//           quantity,
//         ];
//       }
//       return newSelectedQtys;
//     });
//   };

//   // const editItemToBill = (units_id, itemName, quantity, pricePerItem) => {
//   //   setBookingBill((prevBill) => {
//   //     const existingItemIndex = prevBill.findIndex(
//   //       (item) => item.name === itemName
//   //     );
//   //     let updatedBill;
//   //     if (existingItemIndex !== -1) {
//   //       updatedBill = [...prevBill];
//   //       updatedBill[existingItemIndex].quantity += quantity;
//   //       updatedBill[existingItemIndex].price += quantity * pricePerItem;
//   //     } else {
//   //       updatedBill = [
//   //         ...prevBill,
//   //         {
//   //           type: "method_units",
//   //           service_id: selectedService,
//   //           method_id: selectedMethod.method_id,
//   //           units_id: units_id,
//   //           name: itemName,
//   //           s_m_qty: quantity,
//   //           s_m_rate: quantity * pricePerItem,
//   //         },
//   //       ];
//   //     }
//   //     // Calculate the new total time (add 60 minutes for each new unit added)
//   //     const newTotalTime =
//   //       prevBill.reduce(
//   //         (time, item) => time + (item.s_m_qty ? item.s_m_qty : 0) * 60,
//   //         0
//   //       ) +
//   //       quantity * 60;
//   //     setTotalTime(newTotalTime);
//   //     return updatedBill;
//   //   });
//   // };
//   const editItemToBill = (units_id, itemName, quantity, pricePerItem) => {
//     setBookingBill((prevBill) => {
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.units_id === units_id && item.type === "method_units"
//       );
//       let updatedBill = [...prevBill];
  
//       if (existingItemIndex !== -1) {
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             s_m_qty: quantity,
//             s_m_rate: quantity * parseFloat(pricePerItem),
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         updatedBill.push({
//           type: "method_units",
//           service_id: selectedService,
//           method_id: selectedMethod?.method_id,
//           units_id: units_id,
//           name: itemName,
//           s_m_qty: quantity,
//           s_m_rate: quantity * parseFloat(pricePerItem),
//         });
//       }
  
//       calculateDiscountedTotalEdit(updatedBill);
//       return updatedBill;
//     });
//   };
//   const calculateTotal = () => {
//     // Existing calculation for first two services
//     const existingTotal = bookingBill.reduce(
//       (total, item) => total + item.rate,
//       0
//     );

//     // Calculation for third service
//     if (selectedService === 3) {
//       const propertyTotal =
//         propertyQuantities.walls * 10 +
//         propertyQuantities.doors * 10 +
//         propertyQuantities.windows * 10 +
//         damagedFloors * 10 +
//         doorJams * 10;
//       const areaTotal = area * 2 + extraDamagedFloors * 10 + extraDoorJams * 10;
//       return existingTotal + propertyTotal + areaTotal;
//     }
//     if (selectedService === 4) {
//       const officeTotal =
//         (officeQuantities.rooms || 0) * 10 +
//         (officeQuantities.bathrooms || 0) * 10 +
//         (officeQuantities.kitchens || 0) * 10 +
//         (packing || 0) * 10 +
//         (storeroom || 0) * 10;

//       const areaTotal =
//         (officearea || 0) * 2 +
//         (officeextraDamagedFloors || 0) * 10 +
//         (officeextraDoorJams || 0) * 10;

//       return existingTotal + officeTotal + areaTotal;
//     }
//     return existingTotal;
//   };

//   // const calculateTotalEdit = () => {
//   //   // Existing calculation for first two services
//   //   const existingTotal = bookingBill.reduce(
//   //     (total, item) => total + item.rate,
//   //     0
//   //   );

//   //   // Calculation for third service
//   //   if (selectedService === 3) {
//   //     const propertyTotal =
//   //       propertyQuantities.walls * 10 +
//   //       propertyQuantities.doors * 10 +
//   //       propertyQuantities.windows * 10 +
//   //       damagedFloors * 10 +
//   //       doorJams * 10;
//   //     const areaTotal = area * 2 + extraDamagedFloors * 10 + extraDoorJams * 10;
//   //     return existingTotal + propertyTotal + areaTotal;
//   //   }
//   //   if (selectedService === 4) {
//   //     const officeTotal =
//   //       (officeQuantities.rooms || 0) * 10 +
//   //       (officeQuantities.bathrooms || 0) * 10 +
//   //       (officeQuantities.kitchens || 0) * 10 +
//   //       (packing || 0) * 10 +
//   //       (storeroom || 0) * 10;

//   //     const areaTotal =
//   //       (officearea || 0) * 2 +
//   //       (officeextraDamagedFloors || 0) * 10 +
//   //       (officeextraDoorJams || 0) * 10;

//   //     return existingTotal + officeTotal + areaTotal;
//   //   }
//   //   return existingTotal;
//   // };
//   const calculateTotalEdit = () => {
//     const existingTotal = bookingBill.reduce(
//       (total, item) => total + item.s_m_rate,
//       0
//     );
  

//     return existingTotal;
//   };
//   const calculateDiscountedTotal = () => {
//     const total = calculateTotal(); // Get the total price
//     setsubtotale(total);
//     if (isNaN(total)) {
//       console.error("Total calculation resulted in NaN:", total);
//       return 0; // Return 0 if the total is invalid
//     }
//     const discountPercentage = selectedDiscount; // Get the discount based on the frequency
//     const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
//     const totalAfterDiscount = total - discountAmount; // Subtract the discount from the total
//     // const text = totalAfterDiscount + 10 ;
//     const taxsum = total === 0 ? 0 : 10;

//     console.log(promoDiscount);

//     const finalTotal = totalAfterDiscount - promoDiscount + taxsum;
//     console.log(
//       "finalTotal",
//       totalAfterDiscount,
//       promoDiscount,
//       taxsum,
//       finalTotal
//     );
//     setDisamount(discountAmount ? discountAmount : 0);
//     settax(taxsum ? taxsum : 0);
//     setText(finalTotal ? finalTotal : 0);

//     return totalAfterDiscount;
//   };
//   // const calculateDiscountedTotalEdit = () => {
//   //   const total = calculateTotalEdit(); // Get the total price
//   //   setsubtotale(total);
//   //   if (isNaN(total)) {
//   //     console.error("Total calculation resulted in NaN:", total);
//   //     return 0; // Return 0 if the total is invalid
//   //   }
//   //   const discountPercentage = selectedDiscount; // Get the discount based on the frequency
//   //   const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
//   //   const totalAfterDiscount = total - discountAmount; // Subtract the discount from the total
//   //   // const text = totalAfterDiscount + 10 ;
//   //   const taxsum = total === 0 ? 0 : 10;

//   //   const finalTotal = totalAfterDiscount;
//   //   setDisamount(discountAmount);
//   //   settax(taxsum);
//   //   setText(finalTotal);

//   //   return totalAfterDiscount;
//   // };

//   const calculateDiscountedTotalEdit = () => {
//     const total = calculateTotalEdit(); // Get the total price
//     setsubtotale(total);
//     if (isNaN(total)) {
//       console.error("Total calculation resulted in NaN:", total);
//       return 0; // Return 0 if the total is invalid
//     }
//     const discountPercentage = selectedDiscount; // Get the discount based on the frequency
//     const discountAmount = (total * discountPercentage) / 100; // Calculate the discount
//     const totalAfterDiscount = total - discountAmount; // Subtract the discount from the total
//     // const text = totalAfterDiscount + 10 ;
//     const taxsum = total === 0 ? 0 : 10;

//     console.log(promoDiscount);

//     const finalTotal = totalAfterDiscount - promoDiscount + taxsum;
//     console.log(
//       "finalTotal",
//       totalAfterDiscount,
//       promoDiscount,
//       taxsum,
//       finalTotal
//     );
//     setDisamount(discountAmount ? discountAmount : 0);
//     settax(taxsum ? taxsum : 0);
//     setText(finalTotal ? finalTotal : 0);

//     return totalAfterDiscount;
//   };
//   const handaldeleted = async (id) => {
//     setLoading(true);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_booking", // Action to fetch all services
//         api_key: 1,
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data.status === "true") {
//         const services = response.data;
//         setSuccessMessage("Appointment Delete successfully!");
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       getappointmentdetails();
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handalconfirm_appointment = async (id) => {
//     setLoading(true);
//     console.log(id, "DADSA");
//     try {
//       // Define the request payload
//       const payload = {
//         action: "confirm_appointment", // Action to fetch all services
//         api_key: "1",
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_confirm.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data.status == "true") {
//         const services = response.data;
//         setSuccessMessage("Appointment confirmed successfully!");
//         console.log(services);
//         setIsBookingComplete(true);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       getappointmentdetails();

//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const fetchAdminData = async () => {
//   //   setLoading(true);

//   //   try {
//   //     const response = await axios.get(
//   //       `${BaseUrl}/backend/api/staff_assign.php?action=getbookingdata`
//   //     );
//   //     console.log(response.data);
//   //     if (response.data.status === "true") {
//   //       console.log(response.data.data);
//   //       setstaffdata(response.data.data);
//   //     } else {
//   //       console.log(response.data.message);
//   //     }
//   //   } catch (error) {
//   //     console.error("An error occurred while fetching data:", error);
//   //   } finally {
//   //     setLoading(false); // Ensure loading state is updated
//   //   }
//   // };

//   // useEffect(() => {
//   //   fetchAdminData();
//   // }, []);

//   const handalapointment_complete = async (id) => {
//     setLoading(true);
//     console.log(id, "DADSA");
//     try {
//       // Define the request payload
//       const payload = {
//         action: "complete_appointment", // Action to fetch all services
//         api_key: "1",
//         order_id: id,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/appointment_complete.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data.status === "true") {
//         const services = response.data;
//         setSuccessMessage("Appointment completed successfully!");
//         console.log(services);
//         setIsBookingComplete(true);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//       getappointmentdetails();
//       bookeddata();
//       handleCloseModal();
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const crmget = async () => {
//     setLoading(true);

//     try {
//       const response = await axios.get(
//         `${BaseUrl}/backend/api/add_customer.php?action=getuser`
//       );

//       console.log(response);
//       if (response.data.status === "true") {
//         setcrmgetdata(response.data.data);
//       } else {
//         console.log(response.data.message);
//       }
//     } catch (error) {
//       console.error("An error occurred while fetching data:", error);
//     } finally {
//       setLoading(false); // Ensure loading stops in all cases
//       // setShowCancelModal(false); // Ensure modal is closed
//     }
//   };

//   const calendardata = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${BaseUrl}/backend/api/services.php?action=week_days_available`
//       );

//       console.log(response);
//       if (response.data.status === "true") {
//         setcalenderdata(response.data.data);
//       } else {
//         console.log(response.data.message);
//       }
//     } catch (error) {
//       console.error("An error occurred while fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const generateTimeSlots = async () => {
//       const today = new Date();
//       const currentWeek = Math.ceil(today.getDate() / 7); // Week of the month (1st, 2nd, etc.)
//       const currentDayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, etc.
//       console.log(currentWeek, currentDayOfWeek);

//       // Filter schedule for the current week and weekday
//       const selectedSchedule = calenderdata.find(
//         (schedule) => schedule.provider_schedule_type === "weekly"
//       );

//       console.log(selectedSchedule);

//       if (!selectedSchedule) {
//         setTimeSlots([]); // If no schedule for the day, return empty slots
//         return;
//       }

//       const dayStartTime = selectedSchedule.day_start_time;
//       const dayEndTime = selectedSchedule.day_end_time;
//       const slotDurationMinutes = 30;

//       const startTime = new Date(`1970-01-01T${dayStartTime}Z`);
//       const endTime = new Date(`1970-01-01T${dayEndTime}Z`);
//       const slots = [];
//       let currentTime = new Date(startTime);
//       let slotId = 1;

//       while (currentTime < endTime) {
//         const slotStart = new Date(currentTime);
//         const slotEnd = new Date(
//           currentTime.getTime() + slotDurationMinutes * 60000
//         );

//         const formatTime = (time) => {
//           let hours = time.getUTCHours();
//           let minutes = time.getUTCMinutes().toString().padStart(2, "0");
//           let period = hours >= 12 ? "PM" : "AM";
//           hours = hours % 12 || 12;
//           return `${hours}:${minutes} ${period}`;
//         };

//         const isToday =
//           today.toDateString() === new Date(selectedDate).toDateString();
//         const isPastSlot =
//           isToday &&
//           (today.getHours() > slotEnd.getUTCHours() ||
//             (today.getHours() === slotEnd.getUTCHours() &&
//               today.getMinutes() > slotEnd.getUTCMinutes()));

//         slots.push({
//           slot_id: slotId,
//           slot_start: formatTime(slotStart),
//           slot_end: formatTime(slotEnd),
//           disabled: isPastSlot,
//         });

//         currentTime = slotEnd;
//         slotId += 1;
//       }

//       setTimeSlots(slots);
//     };

//     generateTimeSlots();
//     const interval = setInterval(generateTimeSlots, 60000);
//     return () => clearInterval(interval);
//   }, [selectedDate]);

//   useEffect(() => {
//     calendardata();
//   }, []);

//   useEffect(() => {
//     crmget();
//   }, []);

//   useEffect(() => {
//     calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
//   }, [
//     promoDiscount,
//     selectedService,
//     bookingBill,
//     propertyQuantities,
//     area,
//     damagedFloors,
//     doorJams,
//     officeQuantities,
//     officearea,
//     packing,
//     storeroom,
//   ]);

//   useEffect(() => {
//     // Calculate discounted total whenever discount or total changes
//     calculateDiscountedTotalEdit();
//   }, [
//     selectedService,
//     bookingBill,
//     propertyQuantities,
//     area,
//     damagedFloors,
//     doorJams,
//     officeQuantities,
//     officearea,
//     packing,
//     storeroom,
//   ]);

//   useEffect(() => {
//     const fetchAdminData = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(
//           `${BaseUrl}/backend/api/services.php?action=getadmindata`
//         );
//         console.log(response);
  
//         if (response.data.status === "true") {
//           // Filter admin data based on selectedService
//           // const filteredAdminData = response.data.data.filter((provider) => {
//           //   const serviceIdsArray = provider.service_ids
//           //     .split(",")
//           //     .map((id) => id.trim()); // Split and trim the service_ids string into an array
//           //   return selectedService
//           //     ? serviceIdsArray.includes(selectedService.toString())
//           //     : true; // If no service selected, show all staff
//           // });
//           const filteredAdminData = response.data.data.filter((provider) => {
//             const serviceIdsArray = provider.service_ids
//               .split(",")
//               .map((id) => id.trim());
          
//             const matchesService = selectedService
//               ? serviceIdsArray.includes(selectedService.toString())
//               : true;
          
//             const bookingEnabled = provider.enable_booking === "Y";
          
//             return matchesService && bookingEnabled;
//           });
//           console.log(filteredAdminData)
//             setAdminData(filteredAdminData); // Set filtered data
//         } else {
//           console.log(response.data.message);
//         }
//       } catch (err) {
//         console.error("An error occurred while fetching data:", err);
//         setError("Failed to fetch admin data. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };
  
//     fetchAdminData();
//   }, [selectedService]); 

//   useEffect(() => {
//     // Update bedrooms and bathrooms directly in the bill
//     const updateOrAddToBill = (itemName, quantity, pricePerItem) => {
//       const existingItemIndex = bookingBill.findIndex(
//         (item) => item.name === itemName
//       );

//       if (existingItemIndex !== -1) {
//         const updatedBill = [...bookingBill];
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             quantity,
//             price: quantity * pricePerItem,
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1); // Remove the item if quantity is zero
//         }
//         setBookingBill(updatedBill);
//       } else if (quantity > 0) {
//         setBookingBill([
//           ...bookingBill,
//           { type: itemName, qty: quantity, rate: quantity * pricePerItem },
//         ]);
//       }
//     };

//     updateOrAddToBill("Bedrooms", bedroom, 5);
//     updateOrAddToBill("Bathrooms", bathroom, 5);
//   }, [bedroom, bathroom]);

//   useEffect(() => {
//     if (selectedService === 3) {
//       // Initialize or reset variables related to Service 3
//       setPropertyQuantities({
//         walls: 0,
//         doors: 0,
//         windows: 0,
//       });
//       setDamagedFloors(0);
//       setDoorJams(0);
//       setArea(0);
//       setExtraDamagedFloors(0);
//       setExtraDoorJams(0);
//     }
//   }, [selectedService]); // Whenever `selectedService` changes handaldeleted  deleteallbooking

//   useEffect(() => {
//     if (selectedService === 4) {
//       // Initialize or reset variables related to Service 4
//       setOfficeQuantities({
//         rooms: 0,
//         bathrooms: 0,
//         kitchens: 0,
//       });
//       setPacking(0);
//       setStoreroom(0);
//       setOfficeArea(0);
//       setofficeExtraDamagedFloors(0);
//       setofficeExtraDoorJams(0);
//     }
//   }, [selectedService]); // Whenever `selectedService` changes

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     // Log the value for the selected bedroom
//     if (name === "bedroomCount") {
//       console.log(`Selected Bedroom: ${value}`);
//     }
//   };

//   const generateCalendar = (year, month) => {
//     const date = new Date(year, month);
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const startDay = new Date(year, month, 1).getDay();
//     const calendar = [];

//     let currentDay = 1;

//     for (let week = 0; week < 6; week++) {
//       const weekDays = [];

//       for (let day = 0; day < 7; day++) {
//         if (week === 0 && day < startDay) {
//           weekDays.push(null);
//         } else if (currentDay <= daysInMonth) {
//           weekDays.push(currentDay);
//           currentDay++;
//         } else {
//           weekDays.push(null);
//         }
//       }

//       calendar.push(weekDays);
//     }

//     return calendar;
//   };

//   const calendar = generateCalendar(
//     currentDate.getFullYear(),
//     currentDate.getMonth()
//   );
//   useEffect(() => {
//     const fetchedUserId = sessionStorage.getItem("userId");
//     console.log("Fetched userId:", fetchedUserId); // Check what is logged
//     if (fetchedUserId) {
//       setUserId(fetchedUserId);
//     }
//   }, []);

//   // const fetchTimeSlots = async (date) => {
//   //   setLoading(true);
//   //   if (!date || !userId) return;  // Ensure userId is set before making the call

//   //   const formattedDate = format(date, "dd-MM-yyyy");

//   //   const payload = {
//   //     action: "get_slots",
//   //     api_key: 1,
//   //     selected_date: formattedDate,
//   //     staff_id: userId,  // Using userId here
//   //   };

//   //   console.log(payload);

//   //   try {
//   //     const response = await axios.post(
//   //       `${BaseUrl}/backend/api/slots.php`,
//   //       payload,
//   //       {
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //         },
//   //       }
//   //     );

//   //     console.log(response);

//   //     // if (response.status !== 200) {
//   //     //   throw new Error("Network response was not ok");
//   //     // }

//   //     setTimeSlots(response?.data?.response);
//   //   } catch (error) {
//   //     console.error("Error fetching time slots:", error);
//   //     setTimeSlots([]);
//   //   }
//   //   finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const fetchTimeSlots = async (date) => {
//     // Pehle check karo ke staff_id (userId) available hai ya nahi
//     if (!getidbyadmin) {
//       alert("Staff ID missing! Please select a provider.");
//       return;
//     }

//     if (!date) {
//       alert("Please select a date.");
//       return;
//     }

//     const formattedDate = format(date, "dd-MM-yyyy");

//     const payload = {
//       action: "get_slots",
//       api_key: "1",
//       selected_date: formattedDate,
//       staff_id: getidbyadmin, // Ensure ID is present
//     };

//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/slots.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log(response.data.response);
//       setTimeSlots(response.data.response);
//     } catch (error) {
//       console.error("Error fetching time slots:", error);
//       alert(response.data.response)
//       setTimeSlots([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Use useEffect to fetch time slots only when both selectedDate and userId are available
//   useEffect(() => {
//     if (selectedDate && userId) {
//       fetchTimeSlots(selectedDate);
//     }
//   }, [selectedDate, userId]); // Make sure it depends on both selectedDate and userId

//   const renderRatingStars = (rating) => {
//     return (
//       <div className="flex items-center space-x-1">
//         {[1, 2, 3, 4, 5].map((star) => {
//           const isFilled = star <= Math.floor(rating);
//           const isHalfFilled = star === Math.floor(rating) + 1 && rating % 1 !== 0;
//           return (
//             <span key={star} className="text-lg text-yellow-500">
//               {isFilled ? (
//                 <FontAwesomeIcon icon={fullStar} />
//               ) : isHalfFilled ? (
//                 <FontAwesomeIcon icon={faStarHalfAlt} />
//               ) : (
//                 <FontAwesomeIcon icon={emptyStar} className="text-gray-300" />
//               )}
//             </span>
//           );
//         })}
//       </div>
//     );
//   };

//   const handleDateClick = (day) => {
//     setDaySelected(day);
//     if (day) {
//       const selectedDay = new Date(
//         currentDate.getFullYear(),
//         currentDate.getMonth(),
//         day
//       );

//       // Compare only the date (year, month, day) without time, ensuring past dates are blocked
//       const today = new Date();
//       today.setHours(0, 0, 0, 0); // Reset time part to compare just the date

//       if (selectedDay < today) {
//         alert("Sorry, past date booking is not possible.");
//         return;
//       }

//       // Format the date to MM/DD/YYYY
//       const formattedDate = selectedDay.toLocaleDateString("en-US", {
//         month: "2-digit",
//         day: "2-digit",
//         year: "numeric",
//       });

//       const key = formattedDate; // Use formattedDate as the key

//       if (bookedSlots[key]?.length === timeSlots.length) {
//         alert("Sorry, this date's time slots are fully booked.");
//         return;
//       }

//       setSelectedDate(key);
//       setSelectedTime(null);
//       setShowForm(false); // Hide form initially
//     }
//   };

//   const handleTimeSelect = (time) => {
//     console.log(time, "D");
//     setSelectedTime(time); // Store selected time
//     console.log("Selected Time:", time);
//   };

//   const today = new Date();

//   const toggleCalendarPanel = () => {
//     setIsCalendarOpen((prev) => !prev); // Toggle this panel
//     if (!isCalendarOpen) {
//       // If opening this panel
//       setIsServiceOpen(false); // Close others
//       setIsFormOpen(false);
//     }
//   };

//   const toggleFormPanel = () => {
//     setIsFormOpen((prev) => !prev); // Toggle this panel
//     if (!isFormOpen) {
//       // If opening this panel
//       setIsServiceOpen(false); // Close others
//       setIsCalendarOpen(false);
//     }
//   };
//   useEffect(() => {
//     const userId = sessionStorage.getItem("userId"); // Retrieve user ID from localStorage
//     console.log("Retrieved userId from localStorage: ", userId);
//     if (userId) {
//       // fetchAppointments(userId); // Fetch appointments
//       getservicesdata(); // Fetch services
//     } else {
//       console.log("No user ID found, handle accordingly");
//       // setLoading(false); // Stop loading spinner if no user ID
//     }
//   }, [showEditServiceModal]);

//   const getbooking = async (id) => {
//     if (!id) {
//       console.error("❌ No order_id provided for get_service_cart_list API");
//       return null;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         {
//           action: "get_service_cart_list",
//           api_key: "1",
//           order_id: id,
//         }
//       );

//       if (response.status === 200 && response.data.status === "true") {
//         return response.data.response; // Return fresh data
//       } else {
//         console.error("❌ Unexpected response:", response.data);
//         return null;
//       }
//     } catch (error) {
//       console.error("🚨 Error fetching get_service_cart_list:", error);
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

 
//   const parseCurrency = (str) => {
//     if (!str || typeof str !== "string") return 0;
//     return parseFloat(str.replace(/[^0-9.-]+/g, "")) || 0;
//   };
  
//   const totalAmount = parseCurrency(allsetdata?.total_amount); // ₹82.00 -> 82
//   const discountAmount = parseCurrency(allsetdata?.discount); // ₹8.00 -> 8
//   const taxAmount = parseCurrency(allsetdata?.cart_tax); // ₹10.00 -> 10
//   // const frequentDiscount = parseCurrency(allsetdata?.frequent_discount); // - ₹1.00 -> -1
//   const frequencyMapData = {
//     Once: 0,
//     Weekly: 15,
//     "Bi-Weekly": 12.5,
//     Monthly: 10,
//   };
//   const total = calculateTotalEdit(); // Sum of s_m_rate from bookingBill
//   const subTotalEdit = total; // Use bookingBill total instead of totalAmount
//   // const discountedTotal = discountAmount + Math.abs(frequentDiscount); // Combine discount and frequent_discount
//   console.log(allsetdata?.discount_typename)
//   const discountedTotal = subTotalEdit / frequencyMapData[allsetdata?.discount_typename] ; // Combine discount and frequent_discount
//   const finelamount = subTotalEdit - discountedTotal + taxAmount;
  
//   console.log({
//     totalAmount,
//     discountAmount,
//     taxAmount,
//     // frequentDiscount,
//     total,
//     subTotalEdit,
//     discountedTotal,
//     finelamount,
//   });


//   const openEditServiceModal = async (id) => {
//     setLoading(true);
//     setorder_id_appointment(detailsdata.id);
//     setBookingBill([]);
//     setTotalTime(0);
//     setSelectedService(null);
//     setSelectedMethod(null);
//     setUserSelectedMethods([]);
//     setUserSelectedMethodsId([]);
//     setUserSelectedMethodsUnitsId([]);
//     setUserSelectedMethodsSmqty([]);
//     setUserSelectedAddon([]);
//     setQuantities([0, 0, 0]);
//     setallsetdata(null);

//     try {
//       const bookingResponse = await getbooking(detailsdata.id);
//       if (bookingResponse) {
//         setallsetdata(bookingResponse);
//         setSelectedAppointment(bookingResponse);
//         setShowEditServiceModal(true);

//         // Extract cart items and service/method details
//         const cartItems = bookingResponse.cart_items || [];
//         const serviceIds = [...new Set(cartItems.map(item => item.service_id))];
//         const methodIds = cartItems
//           .filter(item => item.type === "method_units")
//           .map(item => item.method_id);
//         const unitsIds = cartItems.map(item => item.units_id);
//         const s_m_qty = cartItems.map(item => parseInt(item.s_m_qty) || 0);
//         const addonIds = cartItems
//           .filter(item => item.type === "addon")
//           .map(item => item.units_id);

//         // Set selected service and method
//         setUserSelectedMethods(serviceIds);
//         setUserSelectedMethodsId(methodIds);
//         setUserSelectedMethodsUnitsId(unitsIds);
//         setUserSelectedMethodsSmqty(s_m_qty);
//         setUserSelectedAddon(addonIds);

//         setSelectedService(serviceIds[0] || bookingResponse.service_id);
//         const selectedServiceData = services.find(
//           s => s.service_id === serviceIds[0]
//         );
//         const selectedMethodData = selectedServiceData?.methods.find(
//           m => methodIds.includes(m.method_id)
//         );
//         if (selectedMethodData) {
//           handleMethodSelection(selectedMethodData, selectedMethodData.method_id);
//         }

//         // Initialize bookingBill from cart_items
//         const newBookingBill = cartItems.map(item => ({
//           type: item.type,
//           service_id: item.service_id,
//           method_id: item.method_id || null,
//           units_id: item.units_id,
//           name: item.method_name || item.addon_name || "Unknown",
//           s_m_qty: parseInt(item.s_m_qty) || 0,
//           s_m_rate: parseFloat(item.s_m_rate) || 0,
//         }));
//         setBookingBill(newBookingBill);

//         // Initialize addon quantities
//         const addonQuantities = selectedServiceData?.addons?.map(addon => {
//           const addonItem = cartItems.find(
//             item => item.type === "addon" && item.units_id === addon.addon_id
//           );
//           return addonItem ? parseInt(addonItem.s_m_qty) || 0 : 0;
//         }) || [0, 0, 0];
//         setQuantities(addonQuantities);

//         // Calculate financials
//         const subtotal = cartItems.reduce(
//           (sum, item) => sum + (parseFloat(item.s_m_rate) || 0),
//           0
//         );
//         const discountType = bookingResponse.discount_typename || selectedFrequency;
//         const discountPercentage = frequencyMap[discountType] || 0;
//         const calculatedDiscount = subtotal * (discountPercentage / 100);
//         const tax = parseCurrency(bookingResponse.cart_tax) || 0;
//         const total = subtotal - calculatedDiscount + tax;

//         setsubtotale(subtotal);
//         setDisamount(calculatedDiscount);
//         settax(tax);
//         settotelamount(subtotal);
//         setfinelamount(total);
//         setdiscountedTotal(calculatedDiscount);

//         // Set total time
//         setTotalTime(parseInt(bookingResponse.order_duration) || 0);
//       }
//     } catch (error) {
//       console.error("Error fetching booking:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleAddonSelection = (addonId) => {
//     // Check if the add-on is already selected
//     if (userSelectedAddon.includes(addonId)) {
//       // If selected, remove it
//       setUserSelectedAddon(userSelectedAddon.filter((id) => id !== addonId));
//     } else {
//       // If not selected, add it
//       setUserSelectedAddon([...userSelectedAddon, addonId]);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);
//     if (!hasAtLeastOneUnit) {
//       alert("You must select at least one unit.");
//       setLoading(false);
//       return;
//     }
//     if (!isChecked) {
//       alert("Please accept the Terms & Conditions before proceeding.");
//       return;
//     }

//     setLoading(true);

//     const formattedData = {
//       action: "book_appointment",
//       api_key: "1",
//       user_id: userDetails.id || useriddata,
//       staff_id: selectedProvider?.id || "",
//       payment_method: paymentMethod,
//       // sub_total: subtotale,
//       sub_total: promoDiscount ? subtotale - promoDiscount : subtotale,

//       discount: Disamount,
//       order_duration: totalTime,
//       tax: tax,
//       booking_date_time: `${selectedDate} ${selectedTime}`,
//       service_id: selectedService,
//       method_id: selectedMethod?.method_id,
//       cart_detail: bookingBill,
//       net_amount: text,
//       recurrence_id: selectedservices,
//       freq_discount_amount: 1,
//     };

//     console.log("Formatted Booking Data:", formattedData);

//     try {
//       axios
//         .post(`${BaseUrl}/backend/api/book_appointment.php`, formattedData, {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         })
//         .then((response) => {
//           console.log(response.data.status);
//           if (response.data.status === "true") {
//             setSuccessMessage("Appointment Add successfully!");
//               if (idpromocode) {
//                         const promoData = {
//                           action: "increment_coupon_used",
//                           api_key: "1",
//                           coupon_id: idpromocode
//                         };
            
//                         axios
//                           .post("http://10.27.1.104/megaclean(20-03-2025)/megaclean/backend/api/promocode.php", promoData, {
//                             headers: {
//                               "Content-Type": "application/json",
//                             },
//                           })
//                           .then((promoResponse) => {
//                             console.log("Promocode incremented successfully:", promoResponse.data);
//                           })
//                           .catch((promoError) => {
//                             console.error("Error incrementing promocode:", promoError);
//                             // Note: Not showing alert here to avoid disrupting user experience
//                           });
//                       }
//             console.log(response.data.status);
//           } else {
//             console.log(response.data.response);
//           }

//           handleClosebookingSummary();
//           bookeddata();
//         })
//         .catch((error) => {
//           console.error("Error occurred while submitting:", error);
//           alert("There was an error submitting the form. Please try again.");
//         });
//     } catch (error) {
//       console.error("Unexpected error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const handleSubmitEdit = async () => {
//   //   // e.preventDefault();
//   //   setLoading(true);
//   //   const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);

//   //   if (!hasAtLeastOneUnit) {
//   //     alert("You must select at least one unit.");
//   //     setLoading(false);
//   //     return;
//   //   }

//   //   // Format the booking bill data to match API structure
//   //   const formattedBookingBill = bookingBill.map(item => ({
//   //     type: item.type || "method_units",
//   //     service_id: selectedService,
//   //     method_id: item.method_id,
//   //     units_id: item.units_id,
//   //     s_m_qty: item.s_m_qty,
//   //     s_m_rate: item.s_m_rate
//   //   }));

//   //   // const formattedData = {
//   //   //   action: "edit_booking_info",
//   //   //   api_key: "1",
//   //   //   order_id: order_id_appointment,
//   //   //   amount: totalTime.toFixed(2), // Ensure 2 decimal places
//   //   //   discount: Disamount.toFixed(2),
//   //   //   taxes: tax.toFixed(2),
//   //   //   net_amount: (text + tax).toFixed(2),
//   //   //   frequent_discount: "0",
//   //   //   frequent_discount_amount: "0",
//   //   //   ct_cart: {
//   //   //     method: formattedBookingBill
//   //   //   },
//   //   //   time_duration: "40"
//   //   // };

//   //   const formattedData = {
//   //     action: "edit_booking_info",
//   //     api_key: "1",
//   //     order_id: order_id_appointment,
//   //     amount:
//   //       (parseFloat(allsetdata.amount.replace(/[^0-9.]/g, "")) || 0) +
//   //       (parseFloat(calculateTotal().toFixed(2)) || 0),
//   //     taxes: tax.toFixed(2),
//   //     discount: Disamount.toFixed(2),

//   //     net_amount:
//   //       parseFloat(allsetdata.total_amount.replace(/[^0-9.]/g, "")) +
//   //       parseFloat(text), // Ensure proper addition
//   //     frequent_discount: "0",
//   //     frequent_discount_amount:
//   //       parseFloat(allsetdata.discount.replace(/[^0-9.]/g, "")) || 0,
//   //     ct_cart: {
//   //       method: formattedBookingBill,
//   //     },
//   //     time_duration: "40",
//   //   };
//   //   try {
//   //     const response = await axios.post(
//   //       "http://localhost/megaclean/backend/api/book_appointment.php",
//   //       formattedData
//   //     );

//   //     if (response.data.status === "true") {
//   //       setSuccessMessage("Appointment Edit Successfully!")
//   //       console.log("Booking updated successfully");
//   //       handleClosebookingSummary();
//   //       // Optionally refresh the appointments list
//   //       // fetchAppointments(localStorage.getItem("userId"));
//   //     } else {
//   //       console.error("Error updating booking:", response.data);
//   //       alert("Failed to update booking. Please try again.");
//   //     }
//   //   } catch (error) {
//   //     console.error("API call failed:", error);
//   //     alert("An error occurred while updating the booking.");
//   //   }
//   //   finally {
//   //     setLoading(false);
//   //   }
//   // };

//   // const handleSubmitEdit = async () => {
//   //   // e.preventDefault();
//   //   setLoading(true);

//   //   // Ensure at least one unit is selected
//   //   const hasAtLeastOneUnit = bookingBill.some((item) => item.method_id);

//   //   if (!hasAtLeastOneUnit) {
//   //     alert("You must select at least one unit.");
//   //     setLoading(false);
//   //     return;
//   //   }

//   //   // Format the booking bill data to match API structure
//   //   const formattedBookingBill = bookingBill.map((item) => ({
//   //     type: item.type || "method_units",
//   //     service_id: selectedService,
//   //     method_id: item.method_id,
//   //     units_id: item.units_id,
//   //     s_m_qty: item.s_m_qty,
//   //     s_m_rate: item.s_m_rate,
//   //   }));

//   //   // const formattedData = {
//   //   //   action: "edit_booking_info",
//   //   //   api_key: "1",
//   //   //   order_id: order_id_appointment,
//   //   //   amount: totalTime.toFixed(2), // Ensure 2 decimal places
//   //   //   discount: Disamount.toFixed(2),
//   //   //   taxes: tax.toFixed(2),
//   //   //   net_amount: (parseFloat(text) + parseFloat(tax)).toFixed(2), // Ensure proper addition
//   //   //   frequent_discount: "0",
//   //   //   frequent_discount_amount: "0",
//   //   //   ct_cart: {
//   //   //     method: formattedBookingBill,
//   //   //   },
//   //   //   time_duration: "40",
//   //   // };
//   //   const frequencyMap = {
//   //     Once: 1,
//   //     Weekly: 2,
//   //     "Bi-Weekly": 3,
//   //     Monthly: 4,
//   //   };

//   //   // Agar `allsetdata.discount_typename` available hai toh wahi use hoga, warna `selectedFrequency`
//   //   const frequent_discount = allsetdata.discount_typename
//   //     ? allsetdata.discount_typename
//   //     : selectedFrequency;

//   //   // Ab is frequency ka ID store karna hai
//   //   const discountID = frequencyMap[frequent_discount] || null;

//   //   console.log(discountID); // Yeh ID return karega

//   //   const formattedData = {
//   //     action: "edit_booking_info",
//   //     api_key: "1",
//   //     order_id: order_id_appointment,
//   //     amount: totelamount2,
//   //     taxes: abcdata,
//   //     discount: disEdit,

//   //     net_amount: subTotalEdit,
//   //     //  parseFloat(allsetdata.amount.replace(/[^0-9.]/g, "")),
//   //     //  parseFloat(allsetdata.total_amount.replace(/[^0-9.]/g, "")) +
//   //     //  parseFloat(text), // Ensure proper addition
//   //     frequent_discount: discountID,
//   //     frequent_discount_amount: discountedTotal,
//   //     ct_cart: {
//   //       method: formattedBookingBill,
//   //     },
//   //     time_duration: "40",
//   //   };
//   //   try {
//   //     const response = await axios.post(
//   //       `${BaseUrl}/backend/api/book_appointment.php`,
//   //       formattedData
//   //     );

//   //     if (response.data.status === "true") {
//   //       setSuccessMessage("Appointment Updated successfully!");
//   //       handleClosebookingSummary();
//   //       fetchAppointments(localStorage.getItem("userId"));
//   //     } else {
//   //       console.error("Error updating booking:", response.data);
//   //       alert("Failed to update booking. Please try again.");
//   //     }
//   //   } catch (error) {
//   //     console.error("API call failed:", error);
//   //     // alert("An error occurred while updating the booking.");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handleSubmitEdit = async () => {

//     setLoading(true);
//     const hasAtLeastOneUnit = bookingBill.some(item => item.method_id);
//     if (!hasAtLeastOneUnit) {
//       alert("You must select at least one unit.");
//       setLoading(false);
//       return;
//     }

//     const formattedBookingBill = bookingBill.map(item => ({
//       type: item.type || "method_units",
//       service_id: selectedService,
//       method_id: item.method_id,
//       units_id: item.units_id,
//       s_m_qty: item.s_m_qty,
//       s_m_rate: item.s_m_rate,
//     }));

//     const frequencyMapIds = { Once: 1, Weekly: 2, "Bi-Weekly": 3, Monthly: 4 };
//     const frequent_discount1 = allsetdata?.discount_typename || selectedFrequency;
//     setDisType(allsetdata?.discount_typename)
//     const discountID = frequencyMapIds[frequent_discount1] || null;

//     const formattedData = {
//       action: "edit_booking_info",
//       api_key: "1",
//       order_id: order_id_appointment,
//       amount: subtotale.toFixed(2),
//       taxes: tax.toFixed(2),
//       discount: Disamount.toFixed(2),
//       net_amount: finelamount.toFixed(2),
//       frequent_discount: discountID,
//       frequent_discount_amount: "0.00",
//       ct_cart: { method: formattedBookingBill },
//       time_duration: totalTime.toString(),
//     };

//     try {
//       const response = await axios.post(`${BaseUrl}/backend/api/book_appointment.php`, formattedData);
//       if (response.data.status === "true") {
//         setSuccessMessage("Appointment Updated Successfully!");
//         const updatedBookingData = await getbooking(order_id_appointment);
//         if (updatedBookingData) {
//           setallsetdata(updatedBookingData);
//           setAppointments(prev => prev.map(appointment =>
//             appointment.order_id === order_id_appointment ? { ...appointment, ...updatedBookingData } : appointment
//           ));
//         }
//         setShowEditServiceModal(false);
//       }
//       handleClosebookingSummary();
//     } catch (error) {
//       console.error("Error updating booking:", error);
//       // alert("An error occurred while updating the booking.");
//     } finally {
//       setLoading(false);
//     }
//     handleClosebookingSummary()
//   };

//   const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//   const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);

//   // Function to navigate to next month or week
//   const nextMonth = () => {
//     if (activeView === "month") {
//       setCurrentMonth(addMonths(currentMonth, 1)); // Navigate to the next month
//     } else if (activeView === "week") {
//       const nextWeekStart = addDays(endOfWeek(currentMonth), 1); // Go to the start of the next week
//       setCurrentMonth(nextWeekStart);
//     }
//   };

//   // Function to navigate to the next day
//   const nextDay = () => {
//     setCurrentMonth(addDays(currentMonth, 1)); // Navigate to the next day
//   };

//   // Function to navigate to the previous day
//   const prevDay = () => {
//     setCurrentMonth(subDays(currentMonth, 1)); // Navigate to the previous day
//   };
//   // Function to navigate to previous month or week
//   const prevMonth = () => {
//     if (activeView === "month") {
//       setCurrentMonth(subMonths(currentMonth, 1)); // Navigate to the previous month
//     } else if (activeView === "week") {
//       const prevWeekStart = subDays(startOfWeek(currentMonth), 1); // Go to the start of the previous week
//       setCurrentMonth(prevWeekStart);
//     }
//   };
//   const renderDaysInMonth = () => {
//     const startDate = new Date(
//       currentMonth.getFullYear(),
//       currentMonth.getMonth(),
//       1
//     );
//     const endDate = new Date(
//       currentMonth.getFullYear(),
//       currentMonth.getMonth() + 1,
//       0
//     );
//     const days = [];
//     let dayIndex = startDate.getDay();
//     let dayOfMonth = 1;

//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");

//     while (dayIndex > 0) {
//       days.push(<div key={`empty-${dayIndex}`} className="p-4 border"></div>);
//       dayIndex--;
//     }

//     while (dayOfMonth <= endDate.getDate()) {
//       const date = new Date(
//         currentMonth.getFullYear(),
//         currentMonth.getMonth(),
//         dayOfMonth
//       );

//       console.log(bookingappointment)
//       const eventsForDay = bookingappointment.filter(
//         (event) =>
//           format(event?.booking_date_time, "yyyy-MM-dd") ===
//           format(date, "yyyy-MM-dd")
//       );

//       const isToday = format(date, "yyyy-MM-dd") === todayDate;
//       const isPastDate = format(date, "yyyy-MM-dd") < todayDate;
//       const eventsToShow = eventsForDay.slice(0, 4);
//       const remainingEvents = eventsForDay.length - 1;
//       console.log(eventsForDay)

//       days.push(
//         <div
//           key={dayOfMonth}
//           className={`p-1 border border-gray-300 h-32 relative ${
//             isToday ? "bg-gray-200" : ""
//           } ${isPastDate ? "bg-gray-200" : ""}`}
//           onClick={
//             !isPastDate
//               ? () => handleShowBookingSummary2(date)
//               : () => alert("You can't select a past date")
//           }
//         >
//           <p
//             className={clsx("text-center", {
//               " text-center rounded-full bg-blue-700 text-white w-8 h-8 flex items-center justify-center mx-auto font-bold":
//                 isToday,
//             })}
//           >
//             {dayOfMonth}
//           </p>

          
          

//           {eventsForDay.length > 0 && (
            
//             <div className="absolute bottom-0 left-0 w-full px-2 py-1 space-y-1">
//               {/* Show first THREE events only */}
              
//               {eventsForDay.slice(0, 2).map((event, index) => {
                
//                 const shortTitle =
//                   event.title && event.title.length > 2
//                     ? `${event.title.slice(0, 2)}...`
//                     : event.title;

//                 return (
//                   <button
//                     key={index}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleShowModal(event);
//                       setDetailsiud(event.order_id);
//                     }}
//                     className="relative group text-sm bg-customlightGreen text-blue-700 px-2 py-1 rounded mb-1 w-full text-left"
//                     // className="text-sm bg-customlightGreen text-blue-700 px-2 py-1 rounded mb-1 relative w-full text-left"
//                     // title="Edit Right Now clike" // 👈 hover pe full title
//                   >

//               <span className="absolute -top-10 left-1/2 -translate-x-1/2 px-3 py-2 text-sm font-medium bg-black text-white rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition duration-200 z-50 whitespace-nowrap">
//                   Edit Right Now click
//                 </span> 

//                     {/* Mobile view: hidden on md+ */}
//                     <span className="block md:hidden">{shortTitle || "Details"}</span>

//                     {/* Laptop/Desktop view: hidden on mobile */}
//                     <span className="hidden md:block">{event.title || "Details"}</span>
//                   </button>
//                 );
//               })}


//               {/* +More button that shows a popup with all remaining events */}
//               {eventsForDay.length > 2 && (
//                 <button
//                   className="text-xs text-blue-500 w-full text-center relative"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setShowAllEvents(!showAllEvents);
//                   }}
//                 >
//                   +{eventsForDay.length - 2} More
//                   {/* Popup that shows all remaining events */}
//                   {showAllEvents && (
//                     <div className="absolute bottom-full left-0 bg-white text-black p-4 rounded-lg shadow-lg z-30 border border-gray-200 w-64 mb-2">
//                       <div className="flex justify-between items-center mb-2 border-b pb-1">
//                         <h3 className="font-bold text-lg">All Events</h3>
//                         <button
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             setShowAllEvents(false);
//                           }}
//                           className="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded"
//                         >
//                           Close
//                         </button>
//                       </div>

//                       <div className="max-h-64 overflow-y-auto">
//                         {eventsForDay.slice(2).map((event, index) => (
//                           <div
//                             key={index}
//                             className="border-b py-2 last:border-0"
//                           >
//                             <div className="flex justify-between items-center">
//                               <h4 className="font-medium">
//                                 {event.title || "Appointment"}
//                               </h4>
//                               {/* <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
//                       {event.status || "Scheduled"}
//                     </span> */}

//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleShowModal(event);
//                                   setDetailsiud(event.order_id);
//                                   setShowAllEvents(false);
//                                 }}
//                                 className="text-xs bg-blue-600 text-white px-3 py-1 rounded mt-2"
//                               >
//                                 View Details
//                               </button>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </button>
//               )}
//             </div>
//           )}
//         </div>
//       );

//       dayOfMonth++;
//     }

//     return days;
//   };

//   const renderWeekView = () => {
//     const weekStart = startOfWeek(currentMonth, { weekStartsOn: 0 });
//     const weekEnd = endOfWeek(currentMonth, { weekStartsOn: 0 });
//     const weekDays = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
//     const formattedRange = `${format(weekStart, "MMM d")} — ${format(
//       weekEnd,
//       "MMM d, yyyy"
//     )}`;

//     // Current date for highlighting
//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");

//     return (
//       <div className="w-full mx-auto ">
//         <div className="grid grid-cols-8 border border-gray-300 text-center text-sm font-semibold bg-gray-50">
//           <div className="col-span-1 border border-gray-200"></div>
//           {weekDays.map((date, index) => {
//             const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
//             return (
//               <div
//                 key={index}
//                 className={`py-2 border lg:text-base md:text-base border-gray-200 min-[320px]:text-[11px] max-[640px]:text-[11px] ${
//                   isToday ? "bg-blue-100 font-bold" : ""
//                 }`}
//               >
//                 {`${daysOfWeek[date.getDay()]} ${format(date, "MM/dd")}`}
//               </div>
//             );
//           })}
//         </div>

//         <div className="grid grid-cols-8 divide-x border border-gray-300 text-sm">
//           <div className="border-r border-gray-300">
//             {hours.map((hour, index) => (
//               <div
//                 key={index}
//                 className="h-16 flex items-center justify-end pr-2 border-b border-gray-300"
//               >
//                 {hour}
//               </div>
//             ))}
//           </div>

//           {weekDays.map((date, dayIndex) => {
//             const isToday = format(date, "yyyy-MM-dd") === todayDate; // Check if it's today's date
//             const isPastDate = format(date, "yyyy-MM-dd") < todayDate; // Check if it's a past date

//             return (
//               <div
//                 key={dayIndex}
//                 className={`border-b border-gray-300 ${
//                   isToday ? "bg-blue-50" : ""
//                 }`}
//                 onClick={
//                   !isPastDate
//                     ? () => handleShowBookingSummary2(date)
//                     : () => alert("You can't select a past date")
//                 }
//               >
//                 {hours.map((hour, hourIndex) => {
//                   // Corrected hour calculation based on the `date`
//                   const hourStart = format(addHours(date, hourIndex), "HH:00"); // Use `date` here instead of `new Date()`
//                   const hourEnd = format(
//                     addHours(date, hourIndex + 1),
//                     "HH:00"
//                   );

//                   // Filter events for the current hour (for the given date and hour)
//                   const eventsForHour = bookingappointment.filter((event) => {
//                     const eventDateTime = format(
//                       new Date(event?.booking_date_time),
//                       "yyyy-MM-dd HH:00"
//                     ); // Full date and hour
//                     const checkDateTime =
//                       format(date, "yyyy-MM-dd") + " " + hourStart;
//                     return eventDateTime === checkDateTime;
//                   });

//                   return (
//                     <div
//                       key={hourIndex}
//                       className={`h-16 border-b border-gray-300 ${
//                         isToday
//                           ? "bg-blue-100"
//                           : hourIndex % 2 === 0
//                           ? "bg-gray-50"
//                           : "bg-white"
//                       }`}
//                     >
//                       {/* Render event buttons for this hour */}
//                       {eventsForHour.length > 0 && (
//                         <div className="space-y-1">
//                           {eventsForHour.map((event, eventIndex) => (
//                             <button
//                               key={eventIndex}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleShowModal(event); // Show modal with event details
//                                 setDetailsiud(event.order_id); // Set the event's order_id
//                               }}
//                               className="text-xs bg-customlightGreen text-blue-700 px-2 py-1 rounded mb-1"
//                             >
//                               {event.title || "Details"}
//                             </button>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const renderDayView = () => {
//     const day = currentMonth; // Assuming currentMonth is the date representing the current day view
//     const formattedDay = format(day, "EEEE, MMM d, yyyy");

//     const today = new Date();
//     const todayDate = format(today, "yyyy-MM-dd");
//     const isToday = format(day, "yyyy-MM-dd") === todayDate;
//     const isFutureDate = format(day, "yyyy-MM-dd") > todayDate;

//     return (
//       <div className="w-full mx-auto">
//         <div className="text-center text-lg font-medium">{formattedDay}</div>
//         <div className="grid grid-cols-1 divide-y border border-gray-300 text-sm">
//           {hours.map((hour, index) => {
//             const hourStart = format(addHours(formattedDay, index), "HH:00"); // Calculate start time for each hour
//             const hourEnd = format(addHours(formattedDay, index + 1), "HH:00"); // Calculate end time for each hour

//             const eventsForHour = bookingappointment.filter((event) => {
//               const eventDateTime = format(
//                 new Date(event?.booking_date_time),
//                 "yyyy-MM-dd HH:00"
//               );
//               const checkDateTime =
//                 format(formattedDay, "yyyy-MM-dd") + " " + hourStart;
//               return eventDateTime === checkDateTime;
//             });

//             return (
//               <div
//                 key={index}
//                 onClick={
//                   isToday || isFutureDate
//                     ? () => handleShowBookingSummary2(day)
//                     : () => alert("You can't select a past date")
//                 }
//                 className={`py-4 flex items-center px-2 text-base border-b border-gray-300 ${
//                   isToday ? "bg-blue-100" : ""
//                 }`}
//               >
//                 <div className="pr-20">{hour}</div>
//                 {eventsForHour.length > 0 && (
//                   <div className="space-y-1">
//                     {eventsForHour.map((event, eventIndex) => (
//                       <button
//                         key={eventIndex}
//                         onClick={(e) => {
//                           e.stopPropagation(); // Prevent event propagation
//                           handleShowModal(event); // Show modal with event details
//                           setDetailsiud(event.order_id); // Set the event's order_id
//                         }}
//                         className="text-xs bg-customlightGreen text-blue-700 px-2 py-1 rounded mb-1"
//                       >
//                         {event.title || "Details"}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const handleShowModal = (event) => {
//     console.log(event);
//     setSelectedEvent(event);
//     setShowModal(true);
//     setShowEditModal(false);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedEvent(null);
//   };
//   const handleShowEditModal = () => {
//     setShowEditModal(true);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//   };

//   const handleShowBookingSummary = () => {
//     setShowBookingSummary(true);
//   };

//   const handleShowBookingSummary2 = () => {
//     setShowBookingSummary2(true);
//   };
//   const handleCloseBookingSummary = () => {
//     setShowBookingSummary(false);
//     setShowBookingSummary2(false);
//   };
//   const handleGoToToday = () => {
//     setCurrentMonth(new Date()); // Set currentMonth to today's date
//   };

//   const handlePersonalDetailsChange = (e) => {
//     const { name, value } = e.target;
//     setPersonalDetails((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };
//   // Handle same as above toggle
//   const handleSameAsAbove = (e) => {
//     setSameAsAbove(e.target.checked);
//     if (e.target.checked) {
//       setAppointmentDetails(personalDetails);
//     }
//   };
//   // Handle change for appointment details
//   const handleAppointmentDetailsChange = (e) => {
//     const { name, value } = e.target;
//     setAppointmentDetails((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };
//   // const handleQuantityChange = (
//   //   idx,
//   //   increment,
//   //   addon_name,
//   //   addon_price,
//   //   max_quantity
//   // ) => {
//   //   console.log(`Addon Name: ${addon_name}`);

//   //   // Update quantities array
//   //   const newQuantities = [...quantities];
//   //   if (increment) {
//   //     if (newQuantities[idx] >= max_quantity) {
//   //       alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//   //     } else {
//   //       newQuantities[idx] += 1;
//   //     }
//   //   } else {
//   //     newQuantities[idx] = Math.max(0, newQuantities[idx] - 1); // Prevent negative quantities
//   //   }
//   //   setQuantities(newQuantities);

//   //   // Extract quantity and calculate price
//   //   const quantity = newQuantities[idx];
//   //   const totalPrice = quantity * addon_price;

//   //   // Log for debugging
//   //   console.log(`Quantity: ${quantity}, Price: ${totalPrice}`);

//   //   // Update bookingBill
//   //   const updatedBill = [...bookingBill];
//   //   const existingItemIndex = updatedBill.findIndex(
//   //     (item) => item.type === addon_name
//   //   );

//   //   if (existingItemIndex !== -1) {
//   //     if (quantity > 0) {
//   //       // Update existing item
//   //       updatedBill[existingItemIndex] = {
//   //         ...updatedBill[existingItemIndex],
//   //         qty: quantity,
//   //         rate: totalPrice,
//   //         service_id: idx, // Include service_id here if needed
//   //       };
//   //     } else {
//   //       // Remove item if quantity is zero
//   //       updatedBill.splice(existingItemIndex, 1);
//   //     }
//   //   } else if (quantity > 0) {
//   //     // Add new item to bookingBill
//   //     updatedBill.push({
//   //       type: addon_name,
//   //       qty: quantity,
//   //       rate: totalPrice,
//   //       service_id: idx,
//   //     });
//   //   }

//   //   // Update the bookingBill state
//   //   setBookingBill(updatedBill);

//   //   // Update total time by adding 60 minutes for each selected addon
//   //   if (quantity > 0) {
//   //     setTotalTime((prevTime) => prevTime + 60); // Add 60 minutes for each addon
//   //   } else {
//   //     setTotalTime((prevTime) => prevTime - 60); // Subtract 60 minutes when addon is removed
//   //   }

//   //   // Log for debugging
//   //   console.log("Updated Booking Bill:", updatedBill);
//   //   console.log("Total Time:", totalTime);
//   // };


//   const handleQuantityChange = (
//     idx,
//     increment,
//     addon_name,
//     addon_price,
//     max_quantity
//   ) => {
//     // Update quantities array
//     const newQuantities = [...quantities];
//     if (increment) {
//       if (newQuantities[idx] >= max_quantity) {
//         alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//       } else {
//         newQuantities[idx] += 1;
//       }
//     } else {
//       newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
//     }
//     setQuantities(newQuantities);
  
//     // Update bookingBill
//     const quantity = newQuantities[idx];
//     const totalPrice = quantity * addon_price;
  
//     setBookingBill((prevBill) => {
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.type === addon_name
//       );
  
//       let updatedBill = [...prevBill];
  
//       if (existingItemIndex !== -1) {
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             qty: quantity,
//             rate: totalPrice,
//             service_id: idx, // Using index as a unique identifier for addon
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         updatedBill.push({
//           type: addon_name,
//           qty: quantity,
//           rate: totalPrice,
//           service_id: idx,
//         });
//       }
  
//       // Update total time
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);
  
//       return updatedBill;
//     });
//   };
//   // const handleQuantityChangeEdit = (idx, increment, addon_name, addon_price, max_quantity) => {
//   //   console.log(`Addon Name: ${addon_name}`);
//   //   const newQuantities = [...quantities];
//   //   newQuantities[idx] = increment
//   //     ? newQuantities[idx] + 1
//   //     : Math.max(0, newQuantities[idx] - 1);
//   //   setQuantities(newQuantities);
//   //   const quantity = newQuantities[idx];
//   //   const pricePerItem = [20, 30, 40][idx]; // Adjust this array as per your addon prices
//   //   const totalPrice = quantity * pricePerItem;
//   //   console.log(`Quantity: ${quantity}, Price: ${totalPrice}`);
//   //   const updatedBill = [...bookingBill];
//   //   const existingItemIndex = updatedBill.findIndex(
//   //     (item) => item.type === addon_name
//   //   );
//   //   if (existingItemIndex !== -1) {
//   //     if (quantity > 0) {
//   //       updatedBill[existingItemIndex] = {
//   //         ...updatedBill[existingItemIndex],
//   //         s_m_qty: quantity,
//   //         s_m_rate: totalPrice,
//   //         units_id: idx,
//   //       };
//   //     } else {
//   //       updatedBill.splice(existingItemIndex, 1);
//   //     }
//   //   } else if (quantity > 0) {
//   //     updatedBill.push({
//   //       type: "addon",
//   //       s_m_qty: quantity,
//   //       s_m_rate: totalPrice,
//   //       units_id: idx,
//   //     });
//   //   }
//   //   setBookingBill(updatedBill);
//   //   if (quantity > 0) {
//   //     setTotalTime((prevTime) => prevTime + 60); // Add 60 minutes for each addon
//   //   } else {
//   //     setTotalTime((prevTime) => prevTime - 60); // Subtract 60 minutes when addon is removed
//   //   }
//   //   console.log("Updated Booking Bill:", updatedBill);
//   //   console.log("Total Time:", totalTime);
//   // };

//   const handleQuantityChangeEdit = (idx, increment, addon_name, addon_price, max_quantity) => {
//     const newQuantities = [...quantities];
//     if (increment) {
//       if (newQuantities[idx] >= max_quantity) {
//         alert(`Maximum quantity of ${max_quantity} reached for ${addon_name}`);
//         return;
//       }
//       newQuantities[idx] += 1;
//     } else {
//       newQuantities[idx] = Math.max(0, newQuantities[idx] - 1);
//     }
//     setQuantities(newQuantities);
  
//     const quantity = newQuantities[idx];
//     const totalPrice = quantity * addon_price;
  
//     setBookingBill((prevBill) => {
//       const addon = services
//         .find((s) => s.service_id === selectedService)
//         ?.addons[idx];
//       const addonId = addon?.addon_id;
//       const existingItemIndex = prevBill.findIndex(
//         (item) => item.type === "addon" && item.units_id === addonId
//       );
//       let updatedBill = [...prevBill];
  
//       if (existingItemIndex !== -1) {
//         if (quantity > 0) {
//           updatedBill[existingItemIndex] = {
//             ...updatedBill[existingItemIndex],
//             s_m_qty: quantity,
//             s_m_rate: totalPrice,
//           };
//         } else {
//           updatedBill.splice(existingItemIndex, 1);
//         }
//       } else if (quantity > 0) {
//         updatedBill.push({
//           type: "addon",
//           service_id: selectedService,
//           method_id: selectedMethod?.method_id || null,
//           units_id: addonId,
//           name: addon_name,
//           s_m_qty: quantity,
//           s_m_rate: totalPrice,
//         });
//       }
  
//       calculateDiscountedTotal(updatedBill);
//       return updatedBill;
//     });
//   };

//   const getappointmentdetails = async () => {
//     setLoading(true);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "getbookingdetails", // Action to fetch all services
//         order_id: Detailsiud, // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;

//         setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getappointmentdetails();
//   }, [Detailsiud]);

//   const deleteallbooking = async (id) => {
//     setLoading(true);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "delete_recurring_booking", // Action to fetch all services
//         recurring_id: id,
//         api_key: "1", // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data.status === "true") {
//         const services = response.data;
//         setSuccessMessage("Delete Recurring Booking Successfully!");
//         console.log(services);
//         // setDetailsdata(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//     bookeddata();
//     handleCloseModal();
//   };

//   useEffect(() => {
//     deleteallbooking();
//   }, []);

//   const getservicesdata = async () => {
//     setLoading(true);
//     try {
//       // Define the request payload
//       const payload = {
//         action: "all_services", // Action to fetch all services
//         api_key: "1", // API key for authentication
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/services.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data && response.data.status === "true") {
//         const services = response.data;
//         console.log(services.response);
//         setallServices(services.response);
//         setServices(services.response);

//         if (Array.isArray(services.response)) {
//           console.log("Fetched Data:", services); // Log the fetched data
//           // setTableData(services); // Uncomment to update the table
//         } else {
//           console.log("No valid array in response data:", response.data);
//         }
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const bookeddata = async () => {
//     setLoading(true);
//     try {
//       const currentDate = new Date(); // Current date

//       // Format the current date in YYYY-MM-DD format (start date)
//       const start_date = currentDate.toISOString().split("T")[0];

//       // Calculate end date (6 months from the current date)
//       const endDate = new Date(currentDate);
//       endDate.setMonth(currentDate.getMonth() + 6); // Add 6 months to the current date
//       const end_date = endDate.toISOString().split("T")[0]; // Format the end date to YYYY-MM-DD

//       // Define the request payload
//       const payload = {
//         action: "getallbookings", // Action to fetch all services
//         api_key: "1", // API key for authentication
//         start_date: "2024-01-01",
//         end_date: end_date,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/book_appointment.php`,
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data && response.data.status === "true") {
//         const services = response.data;
//         console.log(services.response);

//         if (Array.isArray(services.response)) {
//           console.log("Fetched Data:", services); // Log the fetched data
//           setbookingappointment(services.response);
//           // setTableData(services); // Uncomment to update the table
//         } else {
//           console.log("No valid array in response data:", response.data);
//         }
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     bookeddata();
//   }, []);

//   useEffect(() => {
//     getservicesdata();
//   }, []);

//   // useEffect(() => {
//   //   getdata();
//   // }, []);

//   useEffect(() => {
//     calculateDiscountedTotal(); // Calculate discounted total whenever discount or total changes
//   }, [selectedDiscount]);

//   const frequently_discount = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${BaseUrl}/backend/api/services.php?action=frequently_discount`
//       );

//       console.log("Raw Response:", response.data);

//       // Parse the response if necessary
//       let responseData = response.data;
//       if (typeof responseData === "string") {
//         try {
//           responseData = JSON.parse(responseData.trim()); // Remove extra whitespace and parse
//         } catch (error) {
//           console.log("Error parsing response data:", error);
//           return;
//         }
//       }

//       // Handle the parsed response
//       if (responseData.status === "true") {
//         const services = responseData.data;
//         console.log("Fetched Data:", services);
//         setServices_frequently_discount(services); // Update state
//       } else {
//         console.log("API response indicates failure:", responseData.message);
//       }
//     } catch (error) {
//       console.log("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     frequently_discount();
//   }, []);

//   const handleApplyPromoCode = () => {
//     if (!selectedService || selectedService.length === 0) {
//       alert("Please select at least one service");
//       return;
//     }

//     const today = new Date();
//     const foundPromo = promoCodes.find(
//       (promo) =>
//         promo.coupon_code === promoCode &&
//         promo.status === "on" &&
//         new Date(promo.coupon_expiry) >= today &&
//         parseInt(promo.coupon_used) < parseInt(promo.coupon_limit)
//     );

//     console.log(foundPromo);

//     if (foundPromo) {
//       setidpromocode(foundPromo.id)
//       setAppliedPromoCode(foundPromo);
//       const discountValue =
//         foundPromo.coupon_type === "P"
//           ? (calculateTotal() * parseFloat(foundPromo.coupon_value)) / 100
//           : parseFloat(foundPromo.coupon_value);

//       console.log(discountValue);
//       setPromoDiscount(discountValue);
//       setSuccessMessage("Promo code applied successfully!");
//       setError("");
//     } else {
//       setAppliedPromoCode(null);
//       setPromoDiscount(0);
//       setError("Invalid or expired promo code");
//     }
//   };

//   const handleClick = () => {
//     navigate("admin");
//   };

//   // const handleClosebookingSummary = () => {
//   //   setShowBookingSummary(false);
//   //   setShowBookingSummary2(false);
//   //   setShowEditServiceModal(false);
//   // };
//   const handleClosebookingSummary = () => {
//     setShowBookingSummary(false);
//     setShowBookingSummary2(false);
//     setShowEditServiceModal(false);

//     // Reset states to clear stale data
//     setBookingBill([]);
//     setTotalTime(0);
//     setSelectedService(null);
//     setSelectedMethod(null);
//     setUserSelectedMethods([]);
//     setUserSelectedMethodsId([]);
//     setUserSelectedMethodsUnitsId([]);
//     setUserSelectedMethodsSmqty([]);
//     setUserSelectedAddon([]);
//     setQuantities([0, 0, 0]);
//     setallsetdata(null);
//   };
//   const toggleServicePanel = () => {
//     setIsServiceOpen((prev) => !prev); // Toggle this panel
//     if (!isServiceOpen) {
//       // If opening this panel
//       setIsCalendarOpen(false); // Close others
//       setIsFormOpen(false);
//     }
//   };

//   // const removeItem = (idx) => {
//   //   setBookingBill((prevBill) => prevBill.filter((_, index) => index !== idx));
//   // };
//   useEffect(() => {
//     const maxAddons = Math.max(
//       ...allServices.map((s) => (s.addons ? s.addons.length : 0)),
//       extraServices.length
//     );
//     setQuantities(Array(maxAddons).fill(0));
//   }, [allServices]);
//   const removeItem = (idx) => {
//     setBookingBill((prevBill) => {
//       const updatedBill = prevBill.filter((_, index) => index !== idx);
//       const removedItem = prevBill[idx];
  
//       // Reset the quantity in the quantities array if the removed item is an addon
//       if (removedItem.type) {
//         const addonIndex = extraServices.findIndex(
//           (addon) => addon.name === removedItem.type
//         );
//         if (addonIndex !== -1) {
//           setQuantities((prevQuantities) => {
//             const newQuantities = [...prevQuantities];
//             newQuantities[addonIndex] = 0; // Reset to 0 when removed
//             return newQuantities;
//           });
//         } else {
//           // If the addon is from a service's addons (not extraServices), find it dynamically
//           allServices.forEach((service) => {
//             if (service.addons) {
//               const serviceAddonIndex = service.addons.findIndex(
//                 (addon) => addon.addon_name === removedItem.type
//               );
//               if (serviceAddonIndex !== -1) {
//                 setQuantities((prevQuantities) => {
//                   const newQuantities = [...prevQuantities];
//                   newQuantities[serviceAddonIndex] = 0; // Reset to 0
//                   return newQuantities;
//                 });
//               }
//             }
//           });
//         }
//       }
  
//       // Recalculate total time
//       const newTotalTime = updatedBill.reduce(
//         (time, item) => time + (item.qty || 0) * 60,
//         0
//       );
//       setTotalTime(newTotalTime);
  
//       return updatedBill;
//     });
//   };
//   const removeItemEdit = (idx) => {
//     setBookingBill((prevBill) => {
//       const itemToRemove = prevBill[idx];
//       const updatedBill = prevBill.filter((_, index) => index !== idx);
  
//       // If removing a submethod
//       if (itemToRemove.type === "method_units") {
//         // No direct state to reset for dropdown, it will reset to "" automatically
//       }
  
//       // If removing an add-on
//       if (itemToRemove.type === "addon") {
//         const addonIndex = services
//           .find((s) => s.service_id === selectedService)
//           ?.addons.findIndex((a) => a.addon_id === itemToRemove.units_id);
//         if (addonIndex !== undefined) {
//           setQuantities((prev) => {
//             const newQuantities = [...prev];
//             newQuantities[addonIndex] = 0;
//             return newQuantities;
//           });
//           setUserSelectedAddon((prev) =>
//             prev.filter((id) => id !== itemToRemove.units_id)
//           );
//         }
//       }
  
//       return updatedBill;
//     });
//   };

//   const handleMethodSelection = (method, id) => {
//     switch ((method.method_title, id)) {
//       case "Residential Services":
//         setResidential(true);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Commercial Services":
//         setResidential(false);
//         setCommercial(true);
//         setofficeResidential(false);
//         officesetCommercial(false);
//         break;
//       case "Property Based":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(true);
//         officesetCommercial(false);
//         break;
//       case "Area Based (Feet)":
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(true);
//         break;
//       default:
//         // Reset all states if no match is found
//         setResidential(false);
//         setCommercial(false);
//         setofficeResidential(false);
//         officesetCommercial(false);
//     }

//     setSelectedMethod(method, id);
//   };

//   const handlePrevMonth = () => {
//     setCurrentDate(
//       new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
//     );
//   };

//   const handleNextMonth = () => {
//     setCurrentDate(
//       new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
//     );
//   };

//   const handleUserTypeChange = (value) => {
//     setUserType(value); // Set the user type

//     if (value === "new") {
//       // Reset the form fields for a new user
//       setUserDetails({
//         id: "",
//         email: "",
//         password: "",
//         firstName: "",
//         lastName: "",
//         phone: "",
//         streetAddress: "",
//         zipCode: "",
//         city: "",
//         state: "",
//         specialRequests: "",
//       });
//     } else if (value === "existing") {
//       // Optionally, handle the reset when switching to "Existing User"
//       setUserDetails({
//         id: optiondata?.id || "",
//         email: optiondata?.user_email || "",
//         password: optiondata?.user_pwd || "",
//         firstName: optiondata?.first_name || "",
//         lastName: optiondata?.last_name || "",
//         phone: optiondata?.phone || "",
//         streetAddress: optiondata?.address || optiondata?.street_address || "",
//         city: optiondata?.city || "",
//         state: optiondata?.state || "",
//         zipCode: optiondata?.zip || "",
//         specialRequests: optiondata?.notes || "",
//       });
//     }
//   };

//   const handleConfirmClick = (id) => {
//     console.log(`Confirming appointment with ID: ${id}`);
//     // Add logic for confirming the appointment here
//   };

//   const handleChangedata = (event) => {
//     const selectedId = event.target.value;
//     setSelectedOption(selectedId); // Update the selected option

//     const selectedUser = crmgetdata.find((user) => user.id === selectedId); // Find the selected user
//     setoptiondata(selectedUser);

//     if (selectedUser) {
//       // Populate the form fields with the selected user's data
//       setUserDetails({
//         id: selectedUser.id || "",
//         email: selectedUser.user_email || "",
//         password: selectedUser.user_pwd || "",
//         firstName: selectedUser.first_name || "",
//         lastName: selectedUser.last_name || "",
//         phone: selectedUser.phone || "",
//         streetAddress:
//           selectedUser.address || selectedUser.street_address || "",
//         city: selectedUser.city || "",
//         state: selectedUser.state || "",
//         zipCode: selectedUser.zip || "",
//         specialRequests: selectedUser.notes || "",
//       });
//     } else {
//       // Reset the form if no user is selected
//       setUserDetails({
//         id: "",
//         email: "",
//         password: "",
//         firstName: "",
//         lastName: "",
//         phone: "",
//         streetAddress: "",
//         zipCode: "",
//         city: "",
//         state: "",
//         specialRequests: "",
//       });
//     }
//   };

//   const handleUserDetailsChange = (event) => {
//     const { name, value } = event.target;
//     setUserDetails({ ...userDetails, [name]: value });
//   };

//   // const handleSubmitdata = (e) => {
//   //   e.preventDefault(); // Prevent the default form submission behavior
//   //   setLoading(true);

//   //   const data = {
//   //     action: "add_customerdata",
//   //     api_key: "1", // Use the actual API key for authentication
//   //     email: userDetails.email,
//   //     password: userDetails.password,
//   //     first_name: userDetails.firstName,
//   //     last_name: userDetails.lastName,
//   //     phone: userDetails.phone,
//   //     address: userDetails.streetAddress,
//   //     zipcode: userDetails.zipCode,
//   //     city: userDetails.city,
//   //     state: userDetails.state,
//   //     notes: userDetails.specialRequests,
//   //   };

//   //   try {
//   //     axios
//   //       .post(`${BaseUrl}/backend/api/add_customer.php`, data)
//   //       .then((response) => {
//   //         console.log(response.data);

//   //         if (response.data.status === "true") {
//   //           // Handle success (e.g., show success message or redirect)
//   //           alert("Customer created successfully!");
//   //           setSuccessMessage("Add Customer successfully!");
//   //           getservicesdata();
//   //           setuseriddata(response.data.customer_data.id);
//   //         } else {
//   //           // Handle failure (e.g., show error message)
//   //           alert("Customer created successfully!");
//   //           getservicesdata();
//   //         }
//   //       })
//   //       .catch((error) => {
//   //         // Handle any errors during the request
//   //         console.error("Error occurred while submitting:", error);
//   //         alert("There was an error submitting the form. Please try again.");
//   //       });
//   //   } catch (error) {
//   //     console.error("Unexpected error:", error);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!userDetails.email) {
//       newErrors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(userDetails.email)) {
//       newErrors.email = "Email is invalid";
//     }
//     // Password Validation
//     if (!userDetails.password) {
//       newErrors.password = "Password is required";
//     } else if (userDetails.password.length < 8) {
//       newErrors.password = "Password must be at least 8 characters";
//     }
//     if (!userDetails.firstName) {
//       newErrors.firstName = "First Name is required";
//     }
//     if (!userDetails.lastName) {
//       newErrors.lastName = "Last Name is required";
//     }
//     if (!userDetails.phone) {
//       newErrors.phone = "Phone is required";
//     }
//     if (!userDetails.streetAddress) {
//       newErrors.streetAddress = "Street Address is required";
//     }
//     if (!userDetails.zipCode) {
//       newErrors.zipCode = "Zip Code is required";
//     }
//     if (!userDetails.city) {
//       newErrors.city = "City is required";
//     }
//     if (!userDetails.state) {
//       newErrors.state = "State is required";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
//   // const handleSubmitdata = (e) => {
//   //   e.preventDefault(); // Prevent the default form submission behavior

//   //   // Clear existing errors
//   //   const newErrors = {};

//   //   // Validate password length
//   //   if (userDetails.password && userDetails.password.length > 8) {
//   //     newErrors.password = "Password must be at most 8 characters.";
//   //   }

//   //   // If errors exist, update the error state and prevent form submission
//   //   if (Object.keys(newErrors).length > 0) {
//   //     setErrors(newErrors);
//   //     return;
//   //   }

//   //   // Proceed with form submission if no validation errors
//   //   if (validateForm()) {
//   //     setLoading(true);

//   //     const data = {
//   //       action: "add_customerdata",
//   //       api_key: "1", // Use the actual API key for authentication
//   //       email: userDetails.email,
//   //       password: userDetails.password,
//   //       first_name: userDetails.firstName,
//   //       last_name: userDetails.lastName,
//   //       phone: userDetails.phone,
//   //       address: userDetails.streetAddress,
//   //       zipcode: userDetails.zipCode,
//   //       city: userDetails.city,
//   //       state: userDetails.state,
//   //       notes: userDetails.specialRequests,
//   //     };

//   //     // Send the data using axios POST request
//   //     axios
//   //       .post(`${BaseUrl}/backend/api/add_customer.php`, data)
//   //       .then((response) => {
//   //         console.log(response.data);

//   //         if (response.data.status === "true") {
//   //           // Handle success (e.g., show success message or redirect)
//   //           alert("Customer created successfully!");
//   //           setSuccessMessage("Add Customer successfully!");
//   //           getservicesdata();
//   //           setuseriddata(response.data.customer_data.id);
//   //         } else {
//   //           // Handle failure (e.g., show error message)
//   //           getservicesdata();
//   //         }
//   //       })
//   //       .catch((error) => {
//   //         // Handle any errors during the request
//   //         console.error("Error occurred while submitting:", error);
//   //         alert("There was an error submitting the form. Please try again.");
//   //       })
//   //       .finally(() => {
//   //         setLoading(false);
//   //       });
//   //   }
//   // };

// const handleSubmitdata = (e) => {
//   e.preventDefault(); // Prevent the default form submission behavior

//   // Initialize errors object
//   const newErrors = {};

//   // Required fields validation
//   if (!userDetails.email) {
//     newErrors.email = "Email is required.";
//   } else if (!/\S+@\S+\.\S+/.test(userDetails.email)) {
//     newErrors.email = "Please enter a valid email address.";
//   }

//   if (!userDetails.password) {
//     newErrors.password = "Password is required.";
//   } else if (userDetails.password.length !== 8) {
//     newErrors.password = "Password must be exactly 8 characters.";
//   }

//   if (!userDetails.firstName) {
//     newErrors.firstName = "First Name is required.";
//   }

//   if (!userDetails.lastName) {
//     newErrors.lastName = "Last Name is required.";
//   }

//   if (!userDetails.phone) {
//     newErrors.phone = "Phone number is required.";
//   } else if (!/^\d{10}$/.test(userDetails.phone)) {
//     newErrors.phone = "Phone number must be exactly 10 digits.";
//   }

//   if (!userDetails.streetAddress) {
//     newErrors.streetAddress = "Street Address is required.";
//   }

//   if (!userDetails.zipCode) {
//     newErrors.zipCode = "Zip Code is required.";
//   } else if (!/^\d{6}$/.test(userDetails.zipCode)) {
//     newErrors.zipCode = "Zip Code must be exactly 6 digits.";
//   }

//   if (!userDetails.city) {
//     newErrors.city = "City is required.";
//   }

//   if (!userDetails.state) {
//     newErrors.state = "State is required.";
//   }

//   // Update errors state
//   setErrors(newErrors);

//   // If there are errors, stop form submission
//   if (Object.keys(newErrors).length > 0) {
//     return;
//   }

//   // Proceed with form submission if no validation errors
//   setLoading(true);

//   const data = {
//     action: "add_customerdata",
//     api_key: "1",
//     email: userDetails.email,
//     password: userDetails.password,
//     first_name: userDetails.firstName,
//     last_name: userDetails.lastName,
//     phone: userDetails.phone,
//     address: userDetails.streetAddress,
//     zipcode: userDetails.zipCode,
//     city: userDetails.city,
//     state: userDetails.state,
//     notes: userDetails.specialRequests,
//     vc_status: vacuum === "yes" ? "Y" : "N",
//     p_status: parking === "yes" ? "Y" : "N",
//     contact_status: access === "home" ? "Active" : access,
//   };

//   console.log(data);

//   // Send the data using axios POST request
//   axios
//     .post(`${BaseUrl}/backend/api/add_customer.php`, data)
//     .then((response) => {
//       console.log(response.data);

//       if (response.data.status === "true") {
//         alert("Customer created successfully!");
//         setSuccessMessage("Add Customer successfully!");
//         getservicesdata();
//         setuseriddata(response.data.customer_data.id);
//       } else {
//         getservicesdata();
//       }
//     })
//     .catch((error) => {
//       console.error("Error occurred while submitting:", error);
//       alert("There was an error submitting the form. Please try again.");
//     })
//     .finally(() => {
//       setLoading(false);
//     });
// };
//   const handleCancelPromo = () => {
//     setPromoDiscount(0);
//     setAppliedPromoCode(null);
//     setPromoCode(""); // Reset input field
//     setError(""); // Clear error messages
//   };

//   const scrollRef = useRef(null);

//   const scroll = (direction) => {
//     const container = scrollRef.current;
//     if (container) {
//       const scrollAmount = container.offsetWidth * 0.8; // Scroll 80% of container width
//       container.scrollBy({
//         left: direction === "next" ? scrollAmount : -scrollAmount,
//         behavior: "smooth",
//       });
//     }
//   };

//   return (
//     <div className="relative min-h-screen">
//     {/* Loading Indicator */}
//       {loading && (
//            <div className="fixed inset-0 flex items-center justify-center z-50">
//              <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
//                <FadeLoader 
//                  height={15}
//                  width={5}
//                  color="#ffffff"
//                  ariaLabel="loading"
//                />
//                <h1 className="mt-1 text-lg text-white">Please wait...</h1>
//              </div>
//            </div>
//          )}
         

//         <div className="container mx-auto mt-8 xl:px-24 ">
//         {successMessage && (
//             <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
//               <span className="block sm:inline">{successMessage}</span>
//             </div>
//           )}

//           {error && (
//             <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
//               <span className="block sm:inline">{error}</span>
//             </div>
//           )}
//           <div className="flex flex-wrap space-x-4 mb-3">
//             <h1 className="text-[rgb(0,182,255)]  font-semibold">✔ confirm</h1>
//             <h1 className="text-green-500 font-semibold">👍 Complete</h1>
//             <h1 className="text-blue-500 font-semibold">↻ Reschedule</h1>
//             <h1 className="text-black font-semibold">👎🏻 Reject</h1>
//             <h1 className="text-red-500 font-semibold">❌ Delete</h1>
//             <h1 className="text-red-500 font-semibold">
//               🗑️ Delete All Recurring
//             </h1>
//           </div>

//           <div className="flex sm:flex-col min-[320px]:flex-col max-[640px]:flex-col lg:flex-row lg:justify-between lg:items-center mb-4 text-teal-50 bg-customGreen p-4 sm:justify-start sm:items-start min-[320px]:justify-start max-[640px]:justify-start min-[320px]:items-start max-[640px]:items-start bg-blue-800 ">
//             <div className="lg:w-1/4">
//               <div className="flex flex-col items-center space-y-3 sm:space-y-">
//                 <div className="flex items-center space-x-4">
//                   <button
//                     onClick={activeView === "day" ? prevDay : prevMonth}
//                     className="text-lg"
//                   >
//                     <MdKeyboardDoubleArrowLeft />
//                   </button>

//                   <p
//                     className="text-white-400 font-bold text-xs sm:text-xs md:text-base cursor-pointer hover:text-white"
//                     onClick={handleGoToToday}
//                   >
//                     Today
//                   </p>

//                   <button
//                     onClick={activeView === "day" ? nextDay : nextMonth}
//                     className="text-lg "
//                   >
//                     <MdKeyboardDoubleArrowRight />
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="lg:w-2/4 flex justify-center items-center">
//               <span className="text-lg font-bold">
//                 {activeView === "month" ? (
//                   <>
//                     <span>
//                       {format(currentMonth, "MMMM")}-
//                       {format(currentMonth, "yyyy")}
//                     </span>
//                   </>
//                 ) : activeView === "week" ? (
//                   `${format(startOfWeek(currentMonth), "MMM d")} — ${format(
//                     endOfWeek(currentMonth),
//                     "MMM d, yyyy"
//                   )}`
//                 ) : (
//                   format(currentMonth, "MMMM d, yyyy")
//                 )}
//               </span>
//             </div>
//             <div className="lg:w-1/4">
//               <div className="mt-sm flex justify-center lg:justify-end w-full space-x-2">
//                 <p
//                   className={`py-sm px-md text-base pr-3 cursor-pointer ${
//                     activeView === "month"
//                       ? `bg-slate-dark rounded-md shadow-md font-bold hover:bg-slate-darker`
//                       : `bg-transparent hover:bg-gray-dark rounded-md shadow-md`
//                   }`}
//                   onClick={() => setActiveView("month")}
//                 >
//                   Month
//                 </p>

//                 <p
//                   className={`py-sm px-md text-base pr-3 cursor-pointer ${
//                     activeView === "week"
//                       ? `bg-slate-dark rounded-md shadow-md font-bold hover:bg-slate-darker`
//                       : `bg-transparent hover:bg-gray-dark rounded-md shadow-md`
//                   }`}
//                   onClick={() => setActiveView("week")}
//                 >
//                   Week
//                 </p>

//                 <p
//                   className={`py-sm px-md text-base pr-3 cursor-pointer ${
//                     activeView === "day"
//                       ? `bg-slate-dark rounded-md shadow-md font-bold hover:bg-slate-darker`
//                       : `bg-transparent hover:bg-gray-dark rounded-md shadow-md`
//                   }`}
//                   onClick={() => setActiveView("day")}
//                 >
//                   Day
//                 </p>
//               </div>
//             </div>
//           </div>

//           {activeView === "month" && (
//             <>
//               <div className="grid grid-cols-7  text-center ">
//                 {daysOfWeek?.map((day) => (
//                   <div key={day}>{day}</div>
//                 ))}
//               </div>
//               <div className="grid grid-cols-7 border-red-700">
//                 {renderDaysInMonth()}
//               </div>
//             </>
//           )}
//           {activeView === "week" && renderWeekView()}
//           {activeView === "day" && renderDayView()}

//           {showModal && detailsdata && (
//             <div className="fixed inset-0 py-16 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 ">
//               <div className="bg-white p-6 overflow-y-auto   h-[500px] rounded-lg w-full max-w-md sm:max-w-lg md:w-auto  lg:max-w-2xl xl:max-w-3xl min-[320px]:w-3/4 max-[640px]:w-3/4  overflow-auto">
//                 {/* Modal Header */}
//                 <div className="flex justify-between items-center mb-4">
//                   <h2 className="text-xl font-bold">Booking Details</h2>
//                   <button
//                     onClick={handleCloseModal}
//                     className="text-gray-500 hover:text-gray-700 font-bold"
//                   >
//                     X
//                   </button>
//                 </div>

//                 {/* Booking Info */}
//                 <div className="space-y-6">
//                 <div className="flex flex-col sm:flex-row justify-between items-center">
//                   <span className="font-medium mb-3">Booking Status:</span>
//                   <span className="font-bold mb-3 text-green-600">
//                     {detailsdata.booking_status}
//                   </span>
//                   <div className="flex items-center ">
//                     {detailsdata.booking_status !== "CO" ? (
//                       <button
//                         onClick={() => openEditServiceModal(detailsdata)}
//                         className="text-black flex items-center gap-2 p-2 border rounded-md hover:bg-blue-500 hover:text-white"
//                       >
//                         <FaEdit /> Edit Booking Details
//                       </button>
//                     ) : (
//                       <div className="w-[150px]"></div> // Placeholder to maintain layout
//                     )}
//                   </div>
//                 </div>

//                   <div className="space-y-4">
//                     <table>
//                       <tr>
//                         <td className="font-bold w-24">Booking Date </td>

//                         <td>
//                           {detailsdata?.appointment_starttime}
//                           {detailsdata?.appointment_start_time}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="font-bold">Service</td>
//                         <td>{detailsdata?.service_title}</td>
//                       </tr>
//                       <tr>
//                         <td className="font-bold">Methods</td>
//                         <td>{detailsdata?.method_title}</td>
//                       </tr>
//                       <tr>
//                         <td className="font-bold">Units</td>
//                         <td>{detailsdata?.unit_title}</td>
//                       </tr>{" "}
//                       <tr>
//                         <td className="font-bold">Addons</td>
//                         <td>{detailsdata?.addons_title}</td>
//                       </tr>{" "}
//                       <tr>
//                         <td className="font-bold">Price</td>
//                         <td>{detailsdata?.booking_price}</td>
//                       </tr>{" "}
//                       <tr>
//                         <td className="font-bold">Duration</td>
//                         <td>{detailsdata?.booking_duration}</td>
//                       </tr>
//                     </table>
//                   </div>
//                   <div className="flex justify-between">
//                     <h2 className="text-xl font-bold">Customer Detail</h2>
//                     <Link to={`/admin/editcustomer/${selectedEvent.client_id}`}>
//                       <button className="text-blue-500 mt-2 sm:mt-0">
//                         <span className="text-2xl">
//                           <BiSolidEdit />
//                         </span>
//                       </button>
//                     </Link>
//                   </div>

//                   {/* Customer Information */}
//                   <div className="space-y-4">
//                     <table>
//                       <tr>
//                         <td className="font-bold w-20">Name</td>
//                         <td>{detailsdata?.client_name}</td>
//                       </tr>
//                       <tr>
//                         <td className="font-bold ">Email </td>
//                         <td>{detailsdata?.client_email}</td>
//                       </tr>
//                       <tr>
//                         <td className="font-bold ">Phone:</td>
//                         <td>{detailsdata?.client_phone}</td>
//                       </tr>
//                       {/* <tr>
//                         <td className="font-bold ">Notes:</td>
//                         <td>{detailsdata?.client_notes}</td>
//                       </tr> */}
//                       <tr>
//                         <td className="font-bold">Address:</td>
//                         <td>
//                           <a
//                             href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//                               detailsdata?.client_address
//                             )}`}
//                             target="_blank"
//                             style={{ color: "blue" }}
//                             rel="noopener noreferrer"
//                           >
//                             {detailsdata?.client_address}
//                           </a>
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="font-bold ">Payment:</td>
//                         <td>{detailsdata?.payment_type}</td>
//                       </tr>
//                     </table>
//                   </div>
//                   {/* Assign Appointment */}
//                   <div className="flex-col sm:flex-row justify-between items-center mt-4">
//                       <div className="flex items-center sm:w-auto">
//                         <div className="border p-2 rounded-md bg-white w-full shadow-md space-y-2  max-h-72 overflow-y-auto">
//                           <div className="p-2 text-gray-700 font-medium">Assign Appointment to Staff:</div>
//                           {adminData?.length > 0 ? (
//                             <div className="grid grid-cols-1 sm:grid-cols-5 gap-2 p-2">
//                               {adminData.map((staff) => (
//                                 <div
//                                   key={staff.id}
//                                   className="flex items-center space-x-3 hover:bg-gray-100 p-1 rounded"
//                                 >
//                                   <input
//                                     type="checkbox"
//                                     value={staff?.id}
//                                     checked={selectedStaff.includes(staff?.id)}
//                                     onChange={(e) => {
//                                       const id = e?.target?.value;
//                                       setSelectedStaff((prev) =>
//                                         e?.target?.checked
//                                           ? [...prev, id]
//                                           : prev?.filter((staffId) => staffId !== id)
//                                       );
//                                     }}
//                                     className="h-4 w-4 text-blue-600 cursor-pointer focus:ring-blue-500"
//                                   />
//                                   <span className="text-gray-800">{staff.fullname}</span>
//                                 </div>
//                               ))}
//                             </div>
//                           ) : (
//                             <p className="text-gray-500 text-center">No staff available</p>
//                           )}
//                            <div className="mt-2 flex justify-end ">
//                         <button className="text-blue-500 bg-gray-200 border border-gray-400 rounded-md p-1 hover:bg-gray-300 transition-colors"  onClick={handleEditClick}>
//                           <span className="text-2xl">
//                             <BiSolidEdit />
//                           </span>
//                         </button>
//                       </div>
//                         </div>
                       
//                       </div>

                    
//                   </div>
//                 </div>

//                 {/* Action Buttons */}
//                 <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
//                   {detailsdata.booking_status === "R" && (
//                     <>
//                       <button
//                         type="button"
//                         onClick={() => handaldeleted(detailsdata.id)}
//                         className="text-red-500 font-semiboldpx-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         ✖ Delete
//                       </button>

//                       <button
//                         type="button"
//                         onClick={() =>
//                           deleteallbooking(detailsdata.recurring_id)
//                         }
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         🗑️ Delete All Recurring
//                       </button>
//                     </>
//                   )}

//                   {detailsdata.booking_status === "A" && (
//                     <>
//                       <button
//                         type="button"
//                         onClick={() =>
//                           handalconfirm_appointment(detailsdata.id)
//                         }
//                         className="text-[rgb(0,182,255)] font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                       >
//                         ✔ confirm
//                       </button>

//                       <button
//                         type="button"
//                         onClick={() => handleRescheduleClick(detailsdata.id)}
//                         className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                       >
//                         ↻ Reschedule
//                       </button>

//                       <button
//                         type="button"
//                         onClick={handleRejectClick}
//                         className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         👎🏻 Reject
//                       </button>

//                       {/* Reschedule Modal */}
//                       {detailsdata && showRescheduleModal && (
//                         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                           <div className="bg-white p-6 rounded-md shadow-lg w-96">
//                             <h2 className="text-lg font-semibold mb-4">
//                               Reschedule Appointment
//                             </h2>
//                             {/* Amount Input */}
//                             <div className="mb-4">
//                               <label
//                                 htmlFor="amount"
//                                 className="block text-gray-700 mb-2"
//                               >
//                                 Amount:
//                               </label>
//                               <input
//                                 type="number"
//                                 id="amount"
//                                 value={
//                                   detailsdata?.booking_price
//                                     ? detailsdata.booking_price.replace(
//                                         /[^0-9.-]+/g,
//                                         ""
//                                       )
//                                     : ""
//                                 }
//                                 className="w-full px-3 py-2 border rounded-md"
//                               />
//                             </div>

//                             {/* Date Picker (Calendar) */}
//                             <div className="mb-4">
//                               <label
//                                 htmlFor="date"
//                                 className="block text-gray-700 mb-2"
//                               >
//                                 Select Date:
//                               </label>
//                               <input
//                                 type="datetime-local"
//                                 id="date"
//                                 value={rescheduleDate}
//                                 onChange={(e) =>
//                                   setRescheduleDate(e.target.value)
//                                 }
//                                 className="w-full px-3 py-2 border rounded-md"
//                               />
//                             </div>

//                             {/* Notes Input */}
//                             <div className="mb-4">
//                               <label
//                                 htmlFor="notes"
//                                 className="block text-gray-700 mb-2"
//                               >
//                                 Notes:
//                               </label>
//                               <textarea
//                                 id="notes"
//                                 value={notes}
//                                 onChange={(e) => setNotes(e.target.value)}
//                                 className="w-full px-3 py-2 border rounded-md"
//                                 placeholder="Add any notes"
//                               />
//                             </div>

//                             {/* Action Buttons */}
//                             <div className="flex justify-end gap-4">
//                               <button
//                                 type="button"
//                                 onClick={closeRescheduleModal}
//                                 className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                               >
//                                 Cancel
//                               </button>
//                               <button
//                                 type="submit"
//                                 onClick={(e) => handleUpdate(e, rescheduleDate)}
//                                 className="bg-blue-500 text-white px-4 py-2 rounded-md"
//                               >
//                                 Update
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       )}

//                       {/* Reject Form */}
//                       {showForm && (
//                         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                           <form
//                             onSubmit={(e) => handleReject(detailsdata.id, e)}
//                             className="bg-white p-6 rounded-md shadow-lg w-96"
//                           >
//                             <h2 className="text-lg font-semibold mb-4">
//                               Enter Reject Reason
//                             </h2>
//                             <label
//                               htmlFor="rejectReason"
//                               className="block text-gray-700 mb-2"
//                             >
//                               Reason:
//                             </label>
//                             <input
//                               type="text"
//                               id="rejectReason"
//                               value={rejectReason}
//                               onChange={(e) => setRejectReason(e.target.value)}
//                               className="w-full px-3 py-2 border rounded-md mb-4"
//                               placeholder="Reason for rejection"
//                             />
//                             <div className="flex justify-end gap-4">
//                               <button
//                                 type="button"
//                                 onClick={() => setShowForm(false)}
//                                 className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                               >
//                                 Cancel
//                               </button>
//                               <button
//                                 type="submit"
//                                 className="bg-red-500 text-white px-4 py-2 rounded-md"
//                               >
//                                 Submit
//                               </button>
//                             </div>
//                           </form>
//                         </div>
//                       )}

//                       <button
//                         type="button"
//                         onClick={() => handaldeleted(detailsdata.id)}
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         ✖ Delete
//                       </button>

//                       <button
//                         type="button"
//                         onClick={() =>
//                           deleteallbooking(detailsdata.recurring_id)
//                         }
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         🗑️ Delete All Recurring
//                       </button>
//                     </>
//                   )}

//                   {detailsdata.booking_status === "C" && (
//                     <>
//                       <button
//                         type="button"
//                         onClick={() =>
//                           handalapointment_complete(detailsdata.id)
//                         }
//                         className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                       >
//                         👍 Complete
//                       </button>

//                       <button
//                         type="button"
//                         onClick={() => handaldeleted(detailsdata.id)}
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         ✖ Delete
//                       </button>

//                       <button
//                         type="button"
//                         onClick={() =>
//                           deleteallbooking(detailsdata.recurring_id)
//                         }
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         🗑️ Delete All Recurring
//                       </button>
//                     </>
//                   )}
//                   {detailsdata.booking_status === "RS" && (
//                     <>
//                       <button
//                         type="button"
//                         onClick={() =>
//                           handalapointment_complete(detailsdata.id)
//                         }
//                         className="text-green-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                       >
//                         👍 Complete
//                       </button>

//                       <button
//                         type="button"
//                         onClick={() => handleRescheduleClick(detailsdata.id)}
//                         className="text-blue-500 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto mb-4 sm:mb-0"
//                       >
//                         ↻ Reschedule
//                       </button>

//                       <button
//                         type="button"
//                         onClick={handleRejectClick}
//                         className=" text-black-600 font-semibold  px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         👎🏻 Reject
//                       </button>

//                       {/* Reschedule Modal */}
//                       {detailsdata && showRescheduleModal && (
//                         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                           <div className="bg-white p-6 rounded-md shadow-lg w-96">
//                             <h2 className="text-lg font-semibold mb-4">
//                               Reschedule Appointment
//                             </h2>
//                             {/* Amount Input */}
//                             <div className="mb-4">
//                               <label
//                                 htmlFor="amount"
//                                 className="block text-gray-700 mb-2"
//                               >
//                                 Amount:
//                               </label>
//                               <input
//                                 type="number"
//                                 id="amount"
//                                 value={
//                                   detailsdata?.booking_price
//                                     ? detailsdata.booking_price?.replace(
//                                         /[^0-9.-]+/g,
//                                         ""
//                                       )
//                                     : ""
//                                 }
//                                 className="w-full px-3 py-2 border rounded-md"
//                               />
//                             </div>

//                             {/* Date Picker (Calendar) */}
//                             <div className="mb-4">
//                               <label
//                                 htmlFor="date"
//                                 className="block text-gray-700 mb-2"
//                               >
//                                 Select Date:
//                               </label>
//                               <input
//                                 type="datetime-local"
//                                 id="date"
//                                 value={rescheduleDate}
//                                 onChange={(e) =>
//                                   setRescheduleDate(e.target.value)
//                                 }
//                                 className="w-full px-3 py-2 border rounded-md"
//                               />
//                             </div>

//                             {/* Notes Input */}
//                             <div className="mb-4">
//                               <label
//                                 htmlFor="notes"
//                                 className="block text-gray-700 mb-2"
//                               >
//                                 Notes:
//                               </label>
//                               <textarea
//                                 id="notes"
//                                 value={notes}
//                                 onChange={(e) => setNotes(e.target.value)}
//                                 className="w-full px-3 py-2 border rounded-md"
//                                 placeholder="Add any notes"
//                               />
//                             </div>

//                             {/* Action Buttons */}
//                             <div className="flex justify-end gap-4">
//                               <button
//                                 type="button"
//                                 onClick={closeRescheduleModal}
//                                 className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                               >
//                                 Cancel
//                               </button>
//                               <button
//                                 type="submit"
//                                 onClick={(e) => handleUpdate(e, rescheduleDate)}
//                                 className="bg-blue-500 text-white px-4 py-2 rounded-md"
//                               >
//                                 Update
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       )}

//                       {/* Reject Form */}
//                       {showForm && (
//                         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//                           <form
//                             onSubmit={(e) => handleReject(detailsdata.id, e)}
//                             className="bg-white p-6 rounded-md shadow-lg w-96"
//                           >
//                             <h2 className="text-lg font-semibold mb-4">
//                               Enter Reject Reason
//                             </h2>
//                             <label
//                               htmlFor="rejectReason"
//                               className="block text-gray-700 mb-2"
//                             >
//                               Reason:
//                             </label>
//                             <input
//                               type="text"
//                               id="rejectReason"
//                               value={rejectReason}
//                               onChange={(e) => setRejectReason(e.target.value)}
//                               className="w-full px-3 py-2 border rounded-md mb-4"
//                               placeholder="Reason for rejection"
//                             />
//                             <div className="flex justify-end gap-4">
//                               <button
//                                 type="button"
//                                 onClick={() => setShowForm(false)}
//                                 className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
//                               >
//                                 Cancel
//                               </button>
//                               <button
//                                 type="submit"
//                                 className="bg-red-500 text-white px-4 py-2 rounded-md"
//                               >
//                                 Submit
//                               </button>
//                             </div>
//                           </form>
//                         </div>
//                       )}

//                       <button
//                         type="button"
//                         onClick={() => handaldeleted(detailsdata.id)}
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         ✖ Delete
//                       </button>

//                       <button
//                         type="button"
//                         onClick={() =>
//                           deleteallbooking(detailsdata.recurring_id)
//                         }
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         🗑️ Delete All Recurring
//                       </button>
//                     </>
//                   )}

//                   {detailsdata.booking_status === "CO" && (
//                     <>
//                       <div className="text-gray-500">
//                         This Appointment Is Completed
//                       </div>

//                       <button
//                         type="button"
//                         onClick={() => handaldeleted(detailsdata.id)}
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         ✖ Delete
//                       </button>

//                       <button
//                         type="button"
//                         onClick={() =>
//                           deleteallbooking(detailsdata.recurring_id)
//                         }
//                         className="text-red-500 font-semibold px-4 py-2 rounded-md w-full sm:w-auto"
//                       >
//                         🗑️ Delete All Recurring
//                       </button>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//           {showEditServiceModal && (
//             <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
//               <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-auto max-h-[90vh] overflow-y-auto">
//                 <div className="sticky top-0 bg-white z-10 px-6 py-4 border-b flex justify-between items-center">
//                   <h2 className="text-xl font-semibold text-gray-800">
//                     Edit Booking
//                   </h2>
//                   <button
//                     onClick={handleClosebookingSummary}
//                     className="text-gray-500 hover:text-gray-700 transition-colors p-2 rounded-full hover:bg-gray-100"
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <line x1="18" y1="6" x2="6" y2="18"></line>
//                       <line x1="6" y1="6" x2="18" y2="18"></line>
//                     </svg>
//                   </button>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-6">
//                   {/* Left Column - Booking Form */}
//                   <div className="lg:col-span-2">
//                     <form onSubmit={handleSubmitEdit} className="space-y-6">
//                       {/* Service Selection Panel */}
//                       <div className="bg-white rounded-lg shadow-md border border-gray-100">
//                         <div
//                           className="flex justify-between items-center bg-gradient-to-r from-blue-500 to-blue-600 p-4 rounded-t-lg cursor-pointer text-white"
//                           onClick={toggleServicePanel}
//                         >
//                           <h3 className="font-medium">Choose Service</h3>
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="20"
//                             height="20"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           >
//                             <polyline points="6 9 12 15 18 9"></polyline>
//                           </svg>
//                         </div>

//                         <div className="p-4">
//                           {/* Services Grid */}
//                           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
//                             {services?.map((service) => (
//                               <div
//                                 key={service.service_id}
//                                 onClick={() => {
//                                   if (service.service_id) {
//                                     if (selectedService === service.service_id) {
//                                       // If the same service is clicked again, unselect it
//                                       setSelectedService(null);
//                                       setUserSelectedMethods([]); // Clear userSelectedMethods to sync with single selection
//                                     } else {
//                                       // Select the new service
//                                       setSelectedService(service.service_id);
//                                       setUserSelectedMethods([service.service_id]); // Update userSelectedMethods for single selection
//                                     }
//                                   } else {
//                                     console.error("Service ID is missing", service);
//                                   }
//                                 }}
//                                 className={`cursor-pointer border rounded-lg overflow-hidden shadow-sm transition೭all duration-200 hover:shadow-md ${
//                                   userSelectedMethods.includes(service.service_id)
//                                     ? "ring-2 ring-blue-400"
//                                     : ""
//                                 } ${
//                                   selectedService === service.service_id
//                                     ? "ring-2 ring-blue-500 transform scale-[1.02]"
//                                     : ""
//                                 }`}
//                               >
//                                 <div className="relative">
//                                   <img
//                                     src={service?.service_image}
//                                     className="w-full h-32 object-cover"
//                                     // alt={service?.service_title || "Service"}
//                                   />
//                                   <div className="absolute inset-0 flex items-center justify-center text-white font-medium bg-black bg-opacity-40 text-center p-2">
//                                     {service?.service_title}
//                                   </div>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>

//                           {/* Selected Service Details */}
//                           {selectedService && (
//                             <div className="mt-6 space-y-6">
//                               {services
//                                 .filter((s) => s.service_id === selectedService)
//                                 ?.map((service) => (
//                                   <div key={service.service_id}>
//                                     {/* Units Section */}
//                                     {service.units &&
//                                       service.units.length > 0 && (
//                                         <div className="bg-gray-50 p-4 rounded-lg mb-6">
//                                           <h3 className="font-medium text-gray-700 mb-4">
//                                             Units
//                                           </h3>
//                                           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                             {service.units?.map((unit) => (
//                                               <div
//                                                 key={unit.units_id}
//                                                 className="flex items-center space-x-4"
//                                               >
//                                                 <div className="w-full">
//                                                   <div className="flex items-center space-x-2 mb-2">
//                                                     <label className="block font-medium text-gray-700">
//                                                       {unit.unit_title}
//                                                     </label>
//                                                     <img
//                                                       src={Bed}
//                                                       className="w-5 h-5"
//                                                       alt="Unit Icon"
//                                                     />
//                                                   </div>
//                                                   <select
//                                                     className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-white"
//                                                     value={
//                                                       bedroom[unit.units_id] ||
//                                                       unit.unit_min
//                                                     }
//                                                     onChange={(e) =>
//                                                       handleBedroomChange(
//                                                         unit.units_id,
//                                                         parseInt(e.target.value)
//                                                       )
//                                                     }
//                                                   >
//                                                     {Array.from(
//                                                       {
//                                                         length:
//                                                           unit.unit_max -
//                                                           unit.unit_min +
//                                                           1,
//                                                       },
//                                                       (_, i) => (
//                                                         <option
//                                                           key={
//                                                             i + unit.unit_min
//                                                           }
//                                                           value={
//                                                             i + unit.unit_min
//                                                           }
//                                                         >
//                                                           {i}
//                                                         </option>
//                                                       )
//                                                     )}
//                                                   </select>
//                                                 </div>
//                                               </div>
//                                             ))}
//                                           </div>
//                                         </div>
//                                       )}


//                                     {/* Methods Section */}
//                                     {service.methods &&
//                                       service.methods.length > 0 && (
//                                         <div className="space-y-6">
//                                           <div>
//                                             <h3 className="font-medium text-gray-700 mb-3">
//                                               Methods
//                                             </h3>
//                                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                                               {service.methods?.map(
//                                                 (method) => (
//                                                   <button
//                                                     type="button"
//                                                     key={method.method_id}
//                                                     onClick={() => {
//                                                       handleMethodSelection(
//                                                         method,
//                                                         method.method_id
//                                                       );
//                                                     }}
//                                                     className={`p-3 border rounded-lg text-center transition-all duration-200 ${
//                                                       (selectedMethod &&
//                                                         selectedMethod.method_id ===
//                                                           method.method_id) ||
//                                                       userSelectedMethodsId.includes(
//                                                         method.method_id
//                                                       )
//                                                         ? "bg-blue-500 text-white border-blue-500 shadow-md"
//                                                         : "bg-white hover:bg-blue-50 border-gray-200"
//                                                     }`}
//                                                   >
//                                                     {method?.method_title}
//                                                   </button>
//                                                 )
//                                               )}
//                                             </div>
//                                           </div>
//                                          {selectedMethod && (
//                                           <div className="mt-6">
//                                             {selectedMethod.submethods && selectedMethod.submethods.length > 0 ? (
//                                               <div className="space-y-4">
//                                                 <h3 className="font-medium text-gray-700">Options</h3>
//                                                 {selectedMethod.submethods.map((submethod) => {
//                                                   const bookedItem = bookingBill.find(
//                                                     (item) => item.units_id === submethod.unit_id && item.type === "method_units"
//                                                   );
//                                                   return (
//                                                     <div
//                                                       key={submethod.unit_id}
//                                                       className={`${
//                                                         userSelectedMethodsUnitsId.includes(submethod.unit_id)
//                                                           ? "border-blue-200 bg-blue-50"
//                                                           : "border-gray-200"
//                                                       } p-4 border rounded-lg shadow-sm transition-all duration-300`}
//                                                     >
//                                                       <h4 className="font-medium text-gray-700 mb-3">
//                                                         {submethod.unit_title} (₹{submethod.unit_price})
//                                                       </h4>
//                                                       <div className="mb-4">
//                                                         <label className="block font-medium mb-2">Select Quantity</label>
//                                                         <select
//                                                           className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                                           value={bookedItem?.s_m_qty || ""}
//                                                           onChange={(e) => {
//                                                             const quantity = parseInt(e.target.value, 10) || 0;
//                                                             editItemToBill(
//                                                               submethod.unit_id,
//                                                               submethod.unit_title,
//                                                               quantity,
//                                                               submethod.unit_price
//                                                             );
//                                                           }}
//                                                         >
//                                                           <option value="">Select Quantity</option>
//                                                           {[...Array(submethod.unit_max - submethod.unit_min + 1).keys()].map(
//                                                             (qty) => {
//                                                               const quantity = qty + 1;
//                                                               return (
//                                                                 <option key={quantity} value={quantity}>
//                                                                   {quantity}
//                                                                 </option>
//                                                               );
//                                                             }
//                                                           )}
//                                                         </select>
//                                                       </div>
//                                                     </div>
//                                                   );
//                                                 })}
//                                               </div>
//                                             ) : (
//                                               <p className="text-gray-500 italic">No options available for this method.</p>
//                                             )}
//                                           </div>
//                                         )}
//                                         </div>
//                                       )}

//                                     {/* Add-ons Section */}
//                                     {selectedMethod && service.addons?.length > 0 && (
//                                         <div className="mt-8">
//                                           <h3 className="font-medium text-gray-700 mb-4">Add-ons</h3>
//                                           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                                             {service.addons.map((addon, index) => (
//                                               <div
//                                                 key={addon.addon_id}
//                                                 className={`border rounded-lg overflow-hidden shadow-sm transition-all duration-200 ${
//                                                   userSelectedAddon.includes(addon.addon_id)
//                                                     ? "border-blue-300 bg-blue-50"
//                                                     : "border-gray-200 bg-white hover:border-blue-200"
//                                                 }`}
//                                                 onClick={() => handleAddonSelection(addon.addon_id)}
//                                               >
//                                                 <div className="p-4">
//                                                   <div className="text-center mb-3">
//                                                     <p className="font-medium text-gray-800">{addon.addon_name}</p>
//                                                   </div>
//                                                   <div className="text-center mb-4">
//                                                     <p className="text-blue-600 font-medium">₹{addon.addon_price}</p>
//                                                   </div>
//                                                   <div className="flex items-center justify-center gap-3">
//                                                     <button
//                                                       type="button"
//                                                       onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         handleQuantityChangeEdit(
//                                                           index,
//                                                           false,
//                                                           addon.addon_name,
//                                                           addon.addon_price,
//                                                           addon.addon_maxqty
//                                                         );
//                                                       }}
//                                                       className="p-1 w-8 h-8 flex items-center justify-center bg-red-100 text-red-600 rounded-full hover:bg-red-200 transition-colors"
//                                                     >
//                                                       -
//                                                     </button>
//                                                     <span className="text-lg font-medium w-8 text-center">
//                                                       {quantities[index]}
//                                                     </span>
//                                                     <button
//                                                       type="button"
//                                                       onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         handleQuantityChangeEdit(
//                                                           index,
//                                                           true,
//                                                           addon.addon_name,
//                                                           addon.addon_price,
//                                                           addon.addon_maxqty
//                                                         );
//                                                       }}
//                                                       className="p-1 w-8 h-8 flex items-center justify-center bg-green-100 text-green-600 rounded-full hover:bg-green-200 transition-colors"
//                                                     >
//                                                       +
//                                                     </button>
//                                                   </div>
//                                                 </div>
//                                               </div>
//                                             ))}
//                                           </div>
//                                         </div>
//                                       )}
                                                                
//                                     {selectedAppointment && (
//                                     <div className="mt-8">
//                                       <h3 className="font-medium text-gray-700 mb-4">Select Provider</h3>
//                                       <div className="flex flex-wrap gap-4">
//                                         {selectedAppointment.staff_names ? (
//                                           selectedAppointment.staff_names.split(",").map((name, index) => (
//                                             <div key={index} className="text-center">
//                                               <div className="w-20 h-20 bg-blue-500 text-white rounded-full flex items-center justify-center text-xl font-semibold">
//                                                 Provider
//                                               </div>
//                                               <p className="mt-2 text-gray-700">{name.trim() || "N/A"}</p>
//                                             </div>
//                                           ))
//                                         ) : (
//                                           <p className="text-gray-500 italic">No staff assigned.</p>
//                                         )}
//                                       </div>
//                                     </div>
//                                   )}
//                                   </div>
//                                 ))}
//                             </div>
//                           )}

//                         </div>
//                       </div>

//                           {/* Submit Button */}
//                           <div className="flex justify-center">
//                             <button
//                               type="submit"
//                               className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition duration-200 shadow-md hover:shadow-lg"
//                             >
//                               Submit Booking
//                             </button>
//                           </div>
//                         </form>
//                       </div>

//                         {/* Right Column - Bhhhhhooking Summary */}
//                         <div className="lg:col-span-1">
//                           <div className="bg-white border rounded-lg shadow-lg p-6 sticky top-24">
//                             <h2 className="text-lg font-bold text-gray-800 border-b pb-3 mb-4">
//                               Booking Summary
//                             </h2>

//                             {/* Date and Time */}
//                             <div className="space-y-4 mb-6">
//                               <div className="flex items-center text-sm text-gray-600">
//                                 <div className="flex items-center space-x-2">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="18"
//                                     height="18"
//                                     viewBox="0 0 24 24"
//                                     fill="none"
//                                     stroke="currentColor"
//                                     strokeWidth="2"
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                   >
//                                     <rect
//                                       x="3"
//                                       y="4"
//                                       width="18"
//                                       height="18"
//                                       rx="2"
//                                       ry="2"
//                                     ></rect>
//                                     <line x1="16" y1="2" x2="16" y2="6"></line>
//                                     <line x1="8" y1="2" x2="8" y2="6"></line>
//                                     <line x1="3" y1="10" x2="21" y2="10"></line>
//                                   </svg>
//                                   <span className="font-medium text-gray-700">
//                                     Date & Time:
//                                   </span>
//                                   <div>
//                                     {selectedDate && selectedTime ? (
//                                       <p>
//                                         {selectedDate} @ {selectedTime}
//                                       </p>
//                                     ) : allsetdata?.booking_date_time ? (
//                                       <p>{allsetdata?.booking_date_time}</p>
//                                     ) : (
//                                       <p className="text-gray-400 italic">
//                                         Not selected
//                                       </p>
//                                     )}
//                                   </div>
//                                 </div>
//                               </div>

//                                 {/* Frequency */}
//                                 <div className="flex items-center text-sm text-gray-600">
//                                   <div className="flex items-center space-x-2">
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       width="18"
//                                       height="18"
//                                       viewBox="0 0 24 24"
//                                       fill="none"
//                                       stroke="currentColor"
//                                       strokeWidth="2"
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                     >
//                                       <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
//                                     </svg>
//                                     <span className="font-medium text-gray-700">
//                                       Frequency:
//                                     </span>
//                                     <p>
//                                       {allsetdata?.discount_typename
//                                         ? allsetdata?.discount_typename
//                                         : selectedFrequency}
//                                     </p>
//                                   </div>
//                                 </div>

//                                 {/* Duration */}
//                                 <div className="flex items-center text-sm text-gray-600">
//                                   <div className="flex items-center space-x-2">
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       width="18"
//                                       height="18"
//                                       viewBox="0 0 24 24"
//                                       fill="none"
//                                       stroke="currentColor"
//                                       strokeWidth="2"
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                     >
//                                       <circle cx="12" cy="12" r="10"></circle>
//                                       <polyline points="12 6 12 12 16 14"></polyline>
//                                     </svg>
//                                     <span className="font-medium text-gray-700">
//                                       Duration:{" "}
//                                       {allsetdata?.order_duration
//                                         ? `${Math.round(
//                                             allsetdata?.order_duration / 60
//                                           )} Hours`
//                                         : "-"}
//                                     </span>
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="mb-6">
//                                 <h3 className="font-bold text-gray-800 mb-3">Cart Items:</h3>
//                                 {bookingBill.length === 0 ? (
//                                   <div>
//                                     <div className="flex items-center text-sm text-gray-600">
//                                       <span className="font-medium text-gray-700">Service:</span>
//                                       <p>{allsetdata?.service_id || "N/A"}</p>
//                                     </div>
//                                     {allsetdata?.cart_items?.map((item, idx) => (
//                                       <div key={idx} className="flex items-center text-sm text-gray-600">
//                                         <span className="font-medium text-gray-700">
//                                           {item.type === "method_units" ? "Method" : "Addon"}:
//                                         </span>
//                                         <p>{item.method_name || "N/A"} (x{item.s_m_qty}) - ₹{item.s_m_rate}</p>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 ) : (
                              
//                               <ul className="space-y-2">
//                               {bookingBill.map((item, idx) => (
//                                 <li
//                                   key={idx}
//                                   className="flex justify-between items-center py-2 border-b border-gray-100"
//                                 >
//                                   <span className="text-gray-700">{item.name}</span>
//                                   <span className="text-gray-700">
//                                     <span className="text-gray-500 text-sm">(x{item.s_m_qty})</span>
//                                   </span>
//                                   <div className="flex gap-4">
//                                     <span>₹{item.s_m_rate}</span>
//                                     <span onClick={() => removeItemEdit(idx)} className="text-red-500 cursor-pointer">
//                                       X
//                                     </span>
//                                   </div>
//                                 </li>
//                               ))}
//                             </ul>
//                           )}
//                         </div>
//                         <div className="border-t pt-4">
//                         <div className="flex justify-between mb-2">
//                           <p>Sub Total:</p>
//                           <p>₹{subtotale.toFixed(2)}</p>
//                         </div>
//                         <div className="flex justify-between mb-2">
//                           <p>Discount:</p>
//                           <p>- ₹{discountedTotal.toFixed(2)}</p>
//                         </div>
//                         <div className="flex justify-between mb-4">
//                           <p>Tax:</p>
//                           <p>₹{tax.toFixed(2)}</p>
//                         </div>
//                         <div className="flex justify-between font-bold text-lg">
//                           <p>Total:</p>
//                           <p>₹{finelamount.toFixed(2)}</p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             // <>
//             //   <div className="w-full fixed inset-0  bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
//             //     <div className="flex flex-col overflow-auto  scrollbar-none   rounded-lg bg-white p-2 w-1/2 h-[950px] overflow-y-auto min-[320px]:w-3/4 max-[640px]:w-3/4 min-[320px]:p-0 max-[640px]:p-0  ">
//             //       <div className="w-full max-w-6xl mx-auto">
//             //         <div className="">
//             //           {/* Left Section - Booking Form */}
//             //           <div className="col-span-2  px-4 ">
//             //             <div className="flex justify-between items-center">
//             //               <p>Edit Booking</p>
//             //               <button
//             //                 className=" text-2xl"
//             //                 onClick={handleClosebookingSummary}
//             //               >
//             //                 x
//             //               </button>
//             //             </div>
//             //             {/* <p className="text-center text-gray-700 mb-4">Amroli Surat</p> */}
//             //             <form onSubmit={handleSubmitEdit} className="">
//             //               <div
//             //                 className="flex justify-between bg-gray-400 p-2 rounded-sm text-lg font-medium"
//             //                 onClick={toggleServicePanel}
//             //               >
//             //                 <p>Choose Services</p>
//             //                 {/* Toggling icons */}
//             //               </div>

//             //               <div className="p-4 ">
//             //                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6 min-[320px]:grid-cols-2 max-[640px]:grid-cols-2">
//             //                   {services?.map((service) => (
//             //                     <div
//             //                       key={service.service_id}
//             //                       onClick={() => {
//             //                         if (service.service_id) {
//             //                           setSelectedService(service.service_id);
//             //                         } else {
//             //                           console.error(
//             //                             "Service ID is missing",
//             //                             service
//             //                           );
//             //                         }
//             //                       }}
//             //                       className={`cursor-pointer border rounded-lg text-center shadow-md ${
//             //                         userSelectedMethods.includes(service.service_id)
//             //                           ? "shadow-red-500"
//             //                           : ""
//             //                       } ${
//             //                         selectedService === service.service_id
//             //                           ? "bg-blue-400 text-white"
//             //                           : "bg-white"
//             //                       } hover:bg-blue-300`}
//             //                     >
//             //                       <div className="relative">
//             //                         <img
//             //                           src={service?.service_image} // Ensure the image path is correct
//             //                           // alt={service?.service_title || "Service"} // Use service_title in alt
//             //                           className="w-full h-52 object-cover rounded-md min-[320px]:h-36 max-[640px]:h-36"
//             //                         />
//             //                         <div className="absolute inset-0 flex items-center justify-center text-white font-bold bg-black bg-opacity-50 rounded-md">
//             //                           {service?.service_title}
//             //                         </div>
//             //                       </div>
//             //                     </div>
//             //                   ))}
//             //                 </div>

//             //                 {/* Conditionally render the selected service details */}
//             //                 {selectedService && (
//             //                   <div>
//             //                     {console.log(
//             //                       services.filter(
//             //                         (s) => s.service_id === selectedService
//             //                       )
//             //                     )}
//             //                     {/* Find the selected service */}
//             //                     {services
//             //                       .filter((s) => s.service_id === selectedService)
//             //                       ?.map((service) => (
//             //                         <>
//             //                           <div>
//             //                             {/* Dropdowns */}
//             //                             {service.units &&
//             //                               service.units.length > 0 && (
//             //                                 <div>
//             //                                   {service.units?.map((unit) => (
//             //                                     <div
//             //                                       key={unit.unit_id}
//             //                                       className="flex gap-4 mb-6"
//             //                                     >
//             //                                       <div>
//             //                                         <div className="flex items-center space-x-2">
//             //                                           {/* Display the unit title */}
//             //                                           <label className="block font-medium mb-2">
//             //                                             {unit.unit_title}
//             //                                           </label>
//             //                                           <img
//             //                                             src={Bed}
//             //                                             className="w-6 h-6"
//             //                                             alt="Unit Icon"
//             //                                           />
//             //                                         </div>
//             //                                         <select
//             //                                           className={`w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-400 ${
//             //                                             selectedOptions[
//             //                                               unit.unit_id
//             //                                             ]
//             //                                               ? "bg-green-200"
//             //                                               : "bg-white"
//             //                                           }`}
//             //                                           value={
//             //                                             bedroom[unit.unit_id] ||
//             //                                             unit.unit_min
//             //                                           } // Default to `unit_min`
//             //                                           onChange={(e) =>
//             //                                             handleBedroomChange(
//             //                                               unit.units_id,
//             //                                               parseInt(e.target.value)
//             //                                             )
//             //                                           }
//             //                                         >
//             //                                           {Array?.from(
//             //                                             {
//             //                                               length:
//             //                                                 unit.unit_max -
//             //                                                 unit.unit_min +
//             //                                                 1,
//             //                                             },
//             //                                             (_, i) => (
//             //                                               <option
//             //                                                 key={i + unit.unit_min}
//             //                                                 value={
//             //                                                   i + unit.unit_min
//             //                                                 }
//             //                                               >
//             //                                                 {i}
//             //                                               </option>
//             //                                             )
//             //                                           )}
//             //                                         </select>
//             //                                       </div>
//             //                                     </div>
//             //                                   ))}
//             //                                 </div>
//             //                               )}
//             //                             {service.methods &&
//             //                               service.methods.length > 0 && (
//             //                                 <div className="flex flex-col space-y-6">
//             //                                   {/* Upper part: Methods Buttons */}
//             //                                   <div>
//             //                                     <h3>Methods</h3>
//             //                                     <div className="grid grid-cols-2 gap-4">
//             //                                       {service.methods?.map(
//             //                                         (method) => (
//             //                                           <button
//             //                                             type="button"
//             //                                             key={method.method_id}
//             //                                             onClick={() => {
//             //                                               // Handle method selection
//             //                                               handleMethodSelection(
//             //                                                 method,
//             //                                                 method.method_id
//             //                                               );
//             //                                             }}
//             //                                             className={`p-4 border rounded-lg text-center shadow-md ${
//             //                                               (selectedMethod &&
//             //                                                 selectedMethod.method_id ===
//             //                                                   method.method_id) ||
//             //                                               userSelectedMethodsId.includes(
//             //                                                 method.method_id
//             //                                               )
//             //                                                 ? "bg-blue-400 text-white"
//             //                                                 : "bg-white"
//             //                                             }`}
//             //                                           >
//             //                                             {method.method_title}
//             //                                           </button>
//             //                                         )
//             //                                       )}
//             //                                     </div>
//             //                                   </div>

//             //                                   {/* Bottom part: Submethods and Quantity Buttons */}
//             //                                   <div>
//             //                                     {selectedMethod && (
//             //                                       <div className="mt-6">
//             //                                         {selectedMethod.submethods &&
//             //                                         selectedMethod.submethods
//             //                                           .length > 0 ? (
//             //                                           <>
//             //                                             {/* Mobile View - Dropdown */}
//             //                                             <div className="md:hidden">
//             //                                               {selectedMethod.submethods.map(
//             //                                                 (submethod) => (
//             //                                                   <div
//             //                                                     key={
//             //                                                       submethod.unit_id
//             //                                                     }
//             //                                                     className="mb-4"
//             //                                                   >
//             //                                                     <label className="block font-medium mb-2">
//             //                                                       {
//             //                                                         submethod.unit_title
//             //                                                       }
//             //                                                     </label>
//             //                                                     <select
//             //                                                       className="w-full p-2 border rounded-lg"
//             //                                                       onChange={(e) => {
//             //                                                         const selectedQuantity =
//             //                                                           parseInt(
//             //                                                             e.target
//             //                                                               .value,
//             //                                                             10
//             //                                                           );
//             //                                                         editItemToBill(
//             //                                                           submethod.unit_id,
//             //                                                           submethod.unit_title,
//             //                                                           selectedQuantity,
//             //                                                           submethod.unit_price
//             //                                                         );
//             //                                                       }}
//             //                                                     >
//             //                                                       <option value="">
//             //                                                         Select Quantity
//             //                                                       </option>
//             //                                                       {[
//             //                                                         ...Array(
//             //                                                           submethod.unit_max -
//             //                                                             submethod.unit_min +
//             //                                                             1
//             //                                                         ).keys(),
//             //                                                       ].map((qty) => {
//             //                                                         const quantity =
//             //                                                           1 + qty;
//             //                                                         return (
//             //                                                           <option
//             //                                                             key={
//             //                                                               quantity
//             //                                                             }
//             //                                                             value={
//             //                                                               quantity
//             //                                                             }
//             //                                                           >
//             //                                                             {quantity}
//             //                                                           </option>
//             //                                                         );
//             //                                                       })}
//             //                                                     </select>
//             //                                                   </div>
//             //                                                 )
//             //                                               )}
//             //                                             </div>

//             //                                             {/* Desktop View - Buttons */}
//             //                                             <div className="hidden md:block">
//             //                                               {selectedMethod.submethods.map(
//             //                                                 (submethod) => (
//             //                                                   <div
//             //                                                     key={
//             //                                                       submethod.unit_id
//             //                                                     }
//             //                                                     className="p-4 border rounded-lg shadow-md mb-4"
//             //                                                   >
//             //                                                     <h4>
//             //                                                       {
//             //                                                         submethod.unit_title
//             //                                                       }
//             //                                                     </h4>
//             //                                                     <div className="flex gap-2">
//             //                                                       {[
//             //                                                         ...Array(
//             //                                                           submethod.unit_max -
//             //                                                             submethod.unit_min +
//             //                                                             1
//             //                                                         ).keys(),
//             //                                                       ].map((qty) => {
//             //                                                         const quantity =
//             //                                                           1 + qty;
//             //                                                         return (
//             //                                                           <button
//             //                                                             type="button"
//             //                                                             key={
//             //                                                               quantity
//             //                                                             }
//             //                                                             onClick={() =>
//             //                                                               editItemToBill(
//             //                                                                 submethod.unit_id,
//             //                                                                 submethod.unit_title,
//             //                                                                 quantity,
//             //                                                                 submethod.unit_price
//             //                                                               )
//             //                                                             }
//             //                                                             className="px-6 py-2 border rounded-lg shadow-md bg-white hover:bg-blue-300"
//             //                                                           >
//             //                                                             {quantity}
//             //                                                           </button>
//             //                                                         );
//             //                                                       })}
//             //                                                     </div>
//             //                                                   </div>
//             //                                                 )
//             //                                               )}
//             //                                             </div>
//             //                                           </>
//             //                                         ) : (
//             //                                           <p>
//             //                                             No submethods available for
//             //                                             this method.
//             //                                           </p>
//             //                                         )}
//             //                                       </div>
//             //                                     )}
//             //                                   </div>
//             //                                 </div>
//             //                               )}

//             //                             {selectedMethod &&
//             //                               service.addons?.length > 0 && (
//             //                                 <div className="mt-6">
//             //                                   <h3>Add-ons</h3>
//             //                                   <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//             //                                     {service.addons.map(
//             //                                       (addon, index) => (
//             //                                         <div
//             //                                           key={addon.addon_id}
//             //                                           className={`p-4 border rounded-lg text-center bg-white shadow-md
//             //                                           ${
//             //                                             userSelectedAddon.includes(
//             //                                               addon.addon_id
//             //                                             )
//             //                                               ? "bg-blue-400 text-black shadow-red-600"
//             //                                               : "bg-white"
//             //                                           } hover:bg-blue-300`}
//             //                                           onClick={() =>
//             //                                             handleAddonSelection(
//             //                                               addon.addon_id
//             //                                             )
//             //                                           }
//             //                                         >
//             //                                           <div className="flex items-center justify-center mb-4">
//             //                                             <p className="text-lg mb-4">
//             //                                               {addon.addon_name}
//             //                                             </p>
//             //                                           </div>
//             //                                           <div className="flex items-center justify-center mb-4">
//             //                                             <p className="text-lg mb-4">
//             //                                               Price: ₹
//             //                                               {addon.addon_price}
//             //                                             </p>
//             //                                           </div>

//             //                                           {/* Quantity Control */}
//             //                                           <div className="flex items-center justify-center gap-2">
//             //                                             <button
//             //                                               type="button"
//             //                                               onClick={() =>
//             //                                                 handleQuantityChangeEdit(
//             //                                                   index,
//             //                                                   false,
//             //                                                   addon.addon_name
//             //                                                 )
//             //                                               }
//             //                                               className="p-2 bg-red-400 text-white rounded-lg"
//             //                                             >
//             //                                               -
//             //                                             </button>
//             //                                             <span className="text-lg">
//             //                                               {quantities[index]}
//             //                                             </span>
//             //                                             <button
//             //                                               type="button"
//             //                                               onClick={() =>
//             //                                                 handleQuantityChangeEdit(
//             //                                                   index,
//             //                                                   true,
//             //                                                   addon.addon_name
//             //                                                 )
//             //                                               }
//             //                                               className="p-2 bg-green-400 text-white rounded-lg"
//             //                                             >
//             //                                               +
//             //                                             </button>
//             //                                           </div>
//             //                                         </div>
//             //                                       )
//             //                                     )}
//             //                                   </div>
//             //                                 </div>
//             //                               )}
//             //                           </div>
//             //                         </>
//             //                       ))}
//             //                   </div>
//             //                 )}

//             //                 {/* <div className="p-4">
//             //                   <div className="flex flex-wrap justify-center sm:justify-start gap-4">
//             //                     {Services_frequently_discount.map((v) => (
//             //                       <div className="flex flex-col items-center w-28 sm:w-auto">
//             //                         <button
//             //                           type="button"
//             //                           className={`px-6 py-2 w-full sm:w-auto border rounded-md ${
//             //                             selectedFrequency === v.discount_typename
//             //                               ? "border-teal-500 text-teal-500"
//             //                               : "border-gray-300"
//             //                           }`}
//             //                           onClick={() => {
//             //                             setSelectedFrequency(v.discount_typename);
//             //                             setSelectedDiscount(10);
//             //                             setselectedservices(v.id);
//             //                           }}
//             //                         >
//             //                           {v.discount_typename}
//             //                         </button>
//             //                         <p className="text-sm text-gray-500 mt-2">
//             //                           {v.labels}
//             //                         </p>
//             //                       </div>
//             //                     ))}
//             //                   </div>
//             //                 </div> */}
//             //                 {/* Service Provider Section */}
//             //               </div>
//             //               <div className="flex justify-center mt-6">
//             //                 <button
//             //                   type="submit"
//             //                   className="bg-blue-800 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-600 transition duration-300"
//             //                 >
//             //                   Submit Booking
//             //                 </button>
//             //               </div>
//             //             </form>
//             //             <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-10 p-6 bg-white sticky top-10 mb-7">
//             //               <h2 className="text-xl font-bold text-center border-b pb-3 mb-4">
//             //                 Booking Summary
//             //               </h2>
//             //               <div className="flex items-center  text-sm text-gray-600 mb-4">
//             //                 <div className="flex items-center space-x-2">
//             //                   <span className="material-icons text-gray-500">
//             //                     calendar today :
//             //                   </span>
//             //                   {selectedDate && selectedTime && (
//             //                     <p>
//             //                       {selectedDate} @ {selectedTime}
//             //                     </p>
//             //                   )}
//             //                 </div>
//             //               </div>
//             //               <div className="flex items-center space-x-2">
//             //                 <span className="material-icons text-gray-500">
//             //                   auto renew :
//             //                 </span>
//             //                 <p>{selectedFrequency}</p>
//             //               </div>
//             //               <div className="flex items-center space-x-2 mb-4 text-gray-600">
//             //                 <span className="material-icons text-gray-500">
//             //                   Time duration :
//             //                 </span>
//             //                 <p>Reminder</p>
//             //               </div>
//             //               <div className="mb-6">
//             //                 <h3 className="font-bold mb-2">Cart Items :</h3>
//             //                 {bookingBill.length === 0 ? (
//             //                   <p className="text-gray-500">No items selected.</p>
//             //                 ) : (
//             //                   <ul>
//             //                     {bookingBill?.map((item, idx) => (
//             //                       <li
//             //                         key={idx}
//             //                         className="flex justify-between mb-2"
//             //                       >
//             //                         <span>
//             //                           {item.type} (x{item.qty})
//             //                         </span>

//             //                         <span>₹{item.rate}</span>
//             //                       </li>
//             //                     ))}
//             //                     {/* Third Service - Property-Based Items */}
//             //                   </ul>
//             //                 )}
//             //               </div>
//             //               <div className="border-t pt-4 text-gray-600">
//             //                 <div className="flex justify-between mb-2">
//             //                   <p>Sub Total :</p>
//             //                   <p>
//             //                     ₹{isNaN(calculateTotal()) ? 0 : calculateTotal()}
//             //                   </p>
//             //                 </div>
//             //                 {/* <div className="flex justify-between mb-2">
//             //                  <p>Frequently Discount:- </p>
//             //                  <p>-{Disamount}</p>
//             //                </div> */}
//             //                 <div className="flex justify-between mb-4">
//             //                   <p>Tax :</p>
//             //                   <p>{tax}</p>
//             //                 </div>
//             //                 <div className="flex justify-between font-bold text-lg">
//             //                   <p>Total :</p>
//             //                   <p>₹{parseFloat(text + tax)}</p>
//             //                 </div>
//             //               </div>
//             //             </div>
//             //           </div>
//             //         </div>
//             //       </div>
//             //     </div>
//             //   </div>
//             // </>
//           )}

//           {showBookingSummary2 && (
//             <>
//               <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
//                 <div className="flex flex-col overflow-auto scrollbar-none rounded-lg bg-white p-4 md:p-6 lg:p-8 w-full max-w-md md:max-w-2xl lg:max-w-4xl h-[80vh] md:h-auto max-h-screen">
//                   <div className="w-full mx-auto">
//                     <div className="">
//                       {/* Left Section - Booking Form */}
//                       <div className="col-span-2  px-4 ">
//                         <div className="flex justify-between items-center">
//                           {/* <button
//                             onClick={handleClick}
//                             className="px-4 py-2 mt-3 bg-blue-500 text-white flex items-end justify-end rounded-md hover:bg-blue-600 transition duration-200"
//                           >
//                             My Booking
//                           </button> */}
//                           <div></div>
//                           <button
//                             className=" text-2xl"
//                             onClick={handleClosebookingSummary}
//                           >
//                             x
//                           </button>
//                         </div>
//                         <h1 className="text-3xl font-medium text-center text-blue-800 mb-6 min-[320px]:pt-4 max-[640px]:pt-4 min-[320px]:text-[24px] max-[640px]:text-[24px]">
//                           Add Manual Booking
//                         </h1>
//                         {/* <p className="text-center text-gray-700 mb-4">Amroli Surat</p> */}

//                         <form onSubmit={handleSubmit} className="">
//                           <div
//                             className="flex justify-between bg-gray-400 p-2 rounded-sm text-lg font-medium"
//                             onClick={toggleServicePanel}
//                           >
//                             <p>Choose Services</p>
//                             {/* Toggling icons */}
//                             <p className="px-3">
//                               {isServiceOpen ? (
//                                 <MdOutlineKeyboardArrowUp />
//                               ) : (
//                                 <MdOutlineKeyboardArrowDown />
//                               )}
//                             </p>
//                           </div>
//                           <div
//                             className={`transition-all ease-in-out duration-1000 scrollbar-none mb-4 border border-gray-300 overflow-hidden ${
//                               isServiceOpen
//                                 ? "opacity-100 translate-y-0 max-h-[500px] overflow-y-auto"
//                                 : "opacity-0 translate-y-4 max-h-0"
//                             }`}
//                           >
//                             {isServiceOpen && (
//                               <div className="p-4   ">
//                                 {/* Service Location */}
//                                 <div>
//                                   <label
//                                     htmlFor="serviceLocation"
//                                     className="block text-lg font-medium text-gray-800 pb-2"
//                                   >
//                                     Where would you like us to provide service?
//                                   </label>
//                                 </div>

//                                 {/* Zip Code Input */}
//                                 <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
//                                 <div className="flex flex-col w-full">
//                                     <label
//                                       htmlFor="zipCode"
//                                       className="block text-lg font-medium text-gray-800"
//                                     >
//                                       Zip Code
//                                     </label>
//                                     <input
//                                       type="number"
//                                       id="zipCode"
//                                       name="zipCode"
//                                       value={formData.zipCode}
//                                       onChange={handleZipCodeChange} // Use new handler
//                                       className="mt-2 p-2 w-full border border-gray-400 rounded-md"
//                                       placeholder="Enter Zip Code"
//                                       onInput={(e) => {
//                                         if (e.target.value.length > 6) {
//                                           e.target.value = e.target.value.slice(0, 6); // Max 6 digits
//                                         }
//                                       }}
//                                     />
//                                     {/* Display error message if zip code is invalid */}
//                                     {zipCodeError && (
//                                       <p className="text-red-500 text-sm mt-1">{zipCodeError}</p>
//                                     )}
                                    
//                                   </div>
//                                 </div>

//                                 {/* Choose Service */}
//                                 <div>
//                                   <label
//                                     htmlFor="selectedService"
//                                     className="block text-lg font-medium text-gray-800 min-[320px]:pt-4  max-[640px]:pt-4"
//                                   >
//                                     Choose Service
//                                   </label>
//                                 </div>

//                                 {/* Services */}
//                                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6 min-[320px]:grid-cols-2 max-[640px]:grid-cols-2">
//                                   {allServices?.map((service) => (
//                                     <div
//                                       key={service.service_id}
//                                       onClick={() => {
//                                         if (service.service_id) {
//                                           if (selectedService === service.service_id) {
//                                             // If the same service is clicked again, unselect it
//                                             setSelectedService(null);
//                                           } else {
//                                             // Select the new service
//                                             setSelectedService(service.service_id);
//                                           }
//                                         } else {
//                                           console.error("Service ID is missing", service);
//                                         }
//                                       }}
//                                       className={`cursor-pointer border rounded-lg text-center transition-all duration-300 ${
//                                         selectedService === service.service_id
//                                           ? "bg-blue-400 text-white shadow-lg shadow-blue-500"
//                                           : "bg-white hover:bg-blue-300"
//                                       }`}
//                                     >
//                                       {service?.service_image ? (
//                                         // If image exists, show image with title overlay
//                                         <div className="relative">
//                                           <img
//                                             src={service.service_image}
//                                             className="w-full h-52 object-cover rounded-md min-[320px]:h-36 max-[640px]:h-36"
//                                           />
//                                           <div className="absolute inset-0 flex items-center justify-center text-white font-bold bg-black bg-opacity-50 rounded-md">
//                                             {service?.service_title}
//                                           </div>
//                                         </div>
//                                       ) : (
//                                         // If no image, show only title with a colored background
//                                         <div className="flex items-center justify-center h-20 p-4 text-white font-bold bg-blue-500 rounded-md">
//                                           {service?.service_title}
//                                         </div>
//                                       )}
//                                     </div>
//                                   ))}
//                                 </div>

//                                 {/* Conditionally render the selected service details */}
//                                 {selectedService && (
//                                   <div>
//                                     {/* Find the selected service */}
//                                     {allServices
//                                       .filter(
//                                         (s) => s.service_id === selectedService
//                                       )
//                                       ?.map((service) => (
//                                         <>
//                                           <div>
//                                             {/* Dropdowns */}
//                                             {service.units &&
//                                               service.units.length > 0 && (
//                                                 <div>
//                                                   {service.units?.map(
//                                                     (unit) => (
//                                                       <div
//                                                         key={unit.unit_id}
//                                                         className="flex gap-4 mb-6"
//                                                       >
//                                                         <div>
//                                                           <div className="flex items-center space-x-2">
//                                                             {/* Display the unit title */}
//                                                             <label className="block font-medium mb-2">
//                                                               {unit.unit_title}
//                                                             </label>
//                                                             <img
//                                                               src={Bed}
//                                                               className="w-6 h-6"
//                                                               alt="Unit Icon"
//                                                             />
//                                                           </div>
//                                                           <select
//                                                             className={`w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-400 ${
//                                                               selectedOptions[
//                                                                 unit.unit_id
//                                                               ]
//                                                                 ? "bg-green-500"
//                                                                 : "bg-white"
//                                                             }`}
//                                                             value={
//                                                               bedroom[
//                                                                 unit.unit_id
//                                                               ] || unit.unit_min
//                                                             } // Default to `unit_min`
//                                                             onChange={(e) =>
//                                                               handleBedroomChange(
//                                                                 unit.unit_id,
//                                                                 parseInt(
//                                                                   e.target.value
//                                                                 )
//                                                               )
//                                                             }
//                                                           >
//                                                             {Array.from(
//                                                               {
//                                                                 length:
//                                                                   unit.unit_max -
//                                                                   unit.unit_min +
//                                                                   1,
//                                                               },
//                                                               (_, i) => (
//                                                                 <option
//                                                                   key={
//                                                                     i +
//                                                                     unit.unit_min
//                                                                   }
//                                                                   value={
//                                                                     i +
//                                                                     unit.unit_min
//                                                                   }
//                                                                 >
//                                                                   {i}
//                                                                 </option>
//                                                               )
//                                                             )}
//                                                           </select>
//                                                         </div>
//                                                       </div>
//                                                     )
//                                                   )}
//                                                 </div>
//                                               )}

//                                             {/* Render methods */}
//                                             {service.methods &&
//                                               service.methods.length > 0 && (
//                                                 <div className="flex flex-col space-y-6">
//                                                   {/* Upper part: Methods Buttons */}
//                                                   <div>
//                                                     <h3>Methods</h3>
//                                                     <div className="grid grid-cols-2 gap-4">
//                                                       {service.methods?.map(
//                                                         (method) => (
//                                                           <button
//                                                             type="button"
//                                                             key={
//                                                               method.method_id
//                                                             }
//                                                             onClick={() => {
//                                                               // Handle method selection
//                                                               handleMethodSelection(
//                                                                 method,
//                                                                 method.method_id
//                                                               );
//                                                             }}
//                                                             className={`p-4 border rounded-lg text-center shadow-md ${
//                                                               selectedMethod &&
//                                                               selectedMethod.method_id ===
//                                                                 method.method_id
//                                                                 ? "bg-blue-400 text-white"
//                                                                 : "bg-white"
//                                                             }`}
//                                                           >
//                                                             {
//                                                               method.method_title
//                                                             }
//                                                           </button>
//                                                         )
//                                                       )}
//                                                     </div>
//                                                   </div>

//                                                   {/* Bottom part: Submethods and Quantity Buttons */}
//                                                   <div>
//                                                     {selectedMethod && (
//                                                       <div className="mt-6">
//                                                         {selectedMethod.submethods &&
//                                                         selectedMethod
//                                                           .submethods.length >
//                                                           0 ? (
//                                                           <>
//                                                             {/* Mobile View - Dropdown */}
//                                                             <div className="md:hidden">
//                                                               {selectedMethod.submethods.map(
//                                                                 (submethod) => (
//                                                                   <div
//                                                                     key={
//                                                                       submethod.unit_id
//                                                                     }
//                                                                     className="mb-4"
//                                                                   >
//                                                                     <label className="block font-medium mb-2">
//                                                                       {
//                                                                         submethod.unit_title
//                                                                       }
//                                                                       {
//                                                                         submethod.unit_price
//                                                                       }
//                                                                     </label>
//                                                                     <select
//                                                                       className="w-full p-2 border rounded-lg"
//                                                                       onChange={(
//                                                                         e
//                                                                       ) => {
//                                                                         const selectedQuantity =
//                                                                           parseInt(
//                                                                             e
//                                                                               .target
//                                                                               .value,
//                                                                             10
//                                                                           );
//                                                                         addItemToBill(
//                                                                           submethod.unit_id,
//                                                                           submethod.unit_title,
//                                                                           selectedQuantity,
//                                                                           submethod.unit_price
//                                                                         );
//                                                                       }}
//                                                                     >
//                                                                       <option value="">
//                                                                         Select
//                                                                         Quantity
//                                                                       </option>
//                                                                       {[
//                                                                         ...Array(
//                                                                           submethod.unit_max -
//                                                                             submethod.unit_min +
//                                                                             1
//                                                                         ).keys(),
//                                                                       ].map(
//                                                                         (
//                                                                           qty
//                                                                         ) => {
//                                                                           const quantity =
//                                                                             1 +
//                                                                             qty;
//                                                                           return (
//                                                                             <option
//                                                                               key={
//                                                                                 quantity
//                                                                               }
//                                                                               value={
//                                                                                 quantity
//                                                                               }
//                                                                             >
//                                                                               {
//                                                                                 quantity
//                                                                               }
//                                                                             </option>
//                                                                           );
//                                                                         }
//                                                                       )}
//                                                                     </select>
//                                                                   </div>
//                                                                 )
//                                                               )}
//                                                             </div>

//                                                             {/* Desktop View - Buttons */}
//                                                             <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-2 gap-2">
//                                                               {selectedMethod.submethods.map(
//                                                                 (submethod) => (
//                                                                   <div
//                                                                     key={
//                                                                       submethod.unit_id
//                                                                     }
//                                                                     className="mb-4"
//                                                                   >
//                                                                     <label className="block font-medium mb-2">
//                                                                       {
//                                                                         submethod.unit_title
//                                                                       }{" "}
//                                                                       &nbsp;(₹
//                                                                       {
//                                                                         submethod.unit_price
//                                                                       }
//                                                                       )
//                                                                     </label>
//                                                                     <select
//                                                                       className="w-full p-2 border rounded-lg"
//                                                                       onChange={(e) => {
//                                                                         const selectedQuantity = parseInt(e.target.value, 10);
//                                                                         addItemToBill(
//                                                                           submethod.unit_id,
//                                                                           submethod.unit_title,
//                                                                           selectedQuantity,
//                                                                           submethod.unit_price,
//                                                                           service.service_title
//                                                                         );
//                                                                       }}
//                                                                       value={
//                                                                         bookingBill.find((item) => item.unit_id === submethod.unit_id)?.qty || ""
//                                                                       }
//                                                                     >
//                                                                      <option value="">Select Quantity</option>
//                                                                       {[...Array(submethod.unit_max - submethod.unit_min + 1).keys()].map((qty) => {
//                                                                         const quantity = qty + 1;
//                                                                         return (
//                                                                           <option key={quantity} value={quantity}>
//                                                                             {quantity}
//                                                                           </option>
//                                                                         );
//                                                                       })}
//                                                                     </select>
//                                                                   </div>
//                                                                 )
//                                                               )}
//                                                             </div>
//                                                           </>
//                                                         ) : (
//                                                           <p>
//                                                             No submethods
//                                                             available for this
//                                                             method.
//                                                           </p>
//                                                         )}
//                                                       </div>
//                                                     )}
//                                                   </div>
//                                                 </div>
//                                               )}

//                                                       {selectedMethod && (
//                                                         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                                                           {service.addons?.map((addon, index) => (
//                                                             <div
//                                                               key={index}
//                                                               className="p-4 border rounded-lg text-center bg-white shadow-md"
//                                                             >
//                                                               <p className="text-lg font-semibold mb-2">{addon.addon_name}</p>
//                                                               <p className="text-lg mb-2">Price: ₹{addon.addon_price}</p>
//                                                              {quantities[index] >= addon.addon_maxqty && (
//                                                              <p className="text-xs text-red-500 mb-3">
//                                                                  {addon.addon_name} are Max {addon.addon_maxqty} reached
//                                                                 </p>
//                                                              )}  
//                                                               <div className="flex items-center justify-center gap-2">
//                                                                 <button
//                                                                   type="button"
//                                                                   onClick={() =>
//                                                                     handleQuantityChange(
//                                                                       index,
//                                                                       false,
//                                                                       addon.addon_name,
//                                                                       addon.addon_price,
//                                                                       addon.addon_maxqty
//                                                                     )
//                                                                   }
//                                                                   className="p-2 bg-red-400 text-white rounded-lg"
//                                                                 >
//                                                                   -
//                                                                 </button>
//                                                                 <span className="text-lg">{quantities[index] || 0}</span>
//                                                                 <button
//                                                                   type="button"
//                                                                   onClick={() =>
//                                                                     handleQuantityChange(
//                                                                       index,
//                                                                       true,
//                                                                       addon.addon_name,
//                                                                       addon.addon_price,
//                                                                       addon.addon_maxqty
//                                                                     )
//                                                                   }
//                                                                   className="p-2 bg-green-400 text-white rounded-lg"
//                                                                   disabled={quantities[index] >= addon.addon_maxqty}
//                                                                 >
//                                                                   +
//                                                                 </button>
//                                                               </div>
//                                                             </div>
//                                                           ))}
//                                                         </div>
//                                                       )}

//                                             {/* Render addons */}
//                                             {/* {service.addons && service.addons.length > 0 && (
//                                                       <div>
//                                                         <h3>Addons</h3>
//                                                         {service.addons?.map((addon) => (
//                                                           <div key={addon.addon_id}>
//                                                             <h4>{addon.addon_name}</h4>
//                                                             <p>Price: ${addon.addon_price}</p>
//                                                             <p>Max Quantity: {addon.addon_maxqty}</p>
//                                                           </div>
//                                                         ))}
//                                                       </div>
//                                                     )} */}
//                                           </div>
//                                         </>
//                                       ))}
//                                   </div>
//                                 )}

//                            <div className="p-4">
//                           <h2 className="text-lg font-semibold mb-4 text-center sm:text-left">
//                             How often would you like us to provide service ? ( Four Month Booking schedule Manage ) 
//                           </h2>
//                           <div className="flex flex-wrap justify-center sm:justify-start gap-4">
//                             {Services_frequently_discount?.map((v) => {
//                               // Construct the dynamic message using days and booking_count
//                               const message =
//                                 v.discount_typename === "Once"
//                                   ? "One-time booking."
//                                   : `Service every ${v.days} days, ${v.booking_count} bookings counted annually.`;

//                                   return (
//                                     <div key={v.id} className="flex flex-col items-center w-28 sm:w-auto">
//                                       <button
//                                         type="button"
//                                         className={`px-6 py-2 w-full sm:w-auto border rounded-md ${
//                                           selectedFrequency === v.discount_typename
//                                             ? "border-teal-500 text-teal-500"
//                                             : "border-gray-300"
//                                         }`}
//                                         onClick={() => {
//                                           if (selectedFrequency === v.discount_typename) {
//                                             // If the same button is clicked again, unselect it
//                                             setSelectedFrequency(null); // Clear the selected frequency
//                                             setSelectedDiscount(null); // Clear the selected discount
//                                             setselectedservices(null); // Clear the selected service
//                                           } else {
//                                             // Select the new frequency
//                                             setSelectedFrequency(v.discount_typename);
//                                             setSelectedDiscount(v.rates);
//                                             setselectedservices(v.id);
//                                           }
//                                         }}
//                                       >
//                                         {v.discount_typename}
//                                       </button>
//                                       {/* Display the original labels */}
//                                       <p className="text-sm text-gray-500 mt-2">{v.labels}</p>
//                                       {/* Display the dynamic message only for the selected frequency with bold and improved styling */}
//                                       {selectedFrequency === v.discount_typename && (
//                                         <p className="text-sm font-bold text-gray-700 mt-1 text-center">
//                                           {message}
//                                         </p>
//                                       )}
//                                     </div>
//                                   );
//                                 })}
//                               </div>
//                             </div>
//                                 {/* Service Provider Section */}
//                                 <div>
//                                       <h2 className="text-lg font-semibold mb-4">
//                                         Please select provider
//                                       </h2>

//                                       <div className="relative px-4 pb-4">
//                                         {/* Previous Button */}
//                                         <button
//                                           type="button"
//                                           onClick={() => scroll("prev")}
//                                           className="absolute left-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
//                                         >
//                                           <svg
//                                             xmlns="http://www.w3.org/2000/svg"
//                                             className="w-6 h-6"
//                                             fill="none"
//                                             viewBox="0 0 24 24"
//                                             stroke="currentColor"
//                                           >
//                                             <path
//                                               strokeLinecap="round"
//                                               strokeLinejoin="round"
//                                               strokeWidth={2}
//                                               d="M15 19l-7-7 7-7"
//                                             />
//                                           </svg>
//                                         </button>

//                                         {/* Scrollable Container */}
//                                         <div
//                                           ref={scrollRef}
//                                           className="flex overflow-x-auto lg:flex lg:space-x-8 px-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
//                                         >
//                                           {adminData?.length > 0 ? (
//                                             adminData.map((provider, index) => (
//                                               <div
//                                                 key={index}
//                                                 className={`flex flex-col items-center cursor-pointer flex-shrink-0 ${
//                                                   selectedProvider === provider
//                                                     ? "border-teal-500"
//                                                     : "border-gray-300"
//                                                 } border rounded-md p-4 m-2 sm:m-5 w-full sm:w-auto max-w-xs mx-auto`}
//                                                 onClick={() => {
//                                                   if (selectedProvider === provider) {
//                                                     // If the same provider is clicked again, unselect it
//                                                     setSelectedProvider(null);
//                                                     setgetidbyadmin(null); // Clear the staff ID
//                                                   } else {
//                                                     // Select the new provider
//                                                     setSelectedProvider(provider);
//                                                     setgetidbyadmin(provider.id); // Set the staff ID
//                                                   }
//                                                 }}
//                                               >
//                                                 <img
//                                                   src={provider.image || "default-image.jpg"} // Fallback image if none provided
//                                                   className="w-16 h-16 sm:w-24 sm:h-24 rounded-full mb-2 object-cover"
//                                                 />
//                                                 <p className="font-semibold text-gray-800 text-center text-sm sm:text-base">
//                                                   {provider.fullname}
//                                                 </p>
//                                                 <p>{renderRatingStars(provider.rating)}</p>
//                                               </div>
//                                             ))
//                                           ) : (
//                                             <p className="text-gray-500 text-center w-full">
//                                               No staff available for the selected service.
//                                             </p>
//                                           )}
//                                         </div>

//                                         {/* Next Button */}
//                                         <button
//                                           type="button"
//                                           onClick={() => scroll("next")}
//                                           className="absolute right-0 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full z-10 opacity-75 hover:opacity-100 transition-opacity"
//                                         >
//                                           <svg
//                                             xmlns="http://www.w3.org/2000/svg"
//                                             className="w-6 h-6"
//                                             fill="none"
//                                             viewBox="0 24 24"
//                                             stroke="currentColor"
//                                           >
//                                             <path
//                                               strokeLinecap="round"
//                                               strokeLinejoin="round"
//                                               strokeWidth={2}
//                                               d="M9 5l7 7-7 7"
//                                             />
//                                           </svg>
//                                         </button>
//                                       </div>
//                                     </div>
//                               </div>
//                             )}
//                           </div>

//                           {/* Calendar Section */}
//                           <div>
//                             <div
//                               className="flex justify-between bg-gray-400 p-2  rounded-sm text-lg font-medium"
//                               onClick={toggleCalendarPanel}
//                             >
//                               <p>Calendar</p>

//                               {/* Toggling icons */}
//                               <p className="px-3">
//                                 {isCalendarOpen ? (
//                                   <MdOutlineKeyboardArrowUp />
//                                 ) : (
//                                   <MdOutlineKeyboardArrowDown />
//                                 )}
//                               </p>
//                             </div>

//                             <div
//                               className={`transition-all ease-in-out duration-1000  mb-4 overflow-hidden scrollbar-none  ${
//                                 isCalendarOpen
//                                   ? "opacity-100 translate-y-0 max-h-[500px] overflow-y-auto"
//                                   : "opacity-0 translate-y-4 max-h-0"
//                               }`}
//                             >
//                               {isCalendarOpen && (
//                                 <div className="flex flex-col items-center mb-6 px-2 py-2 overflow-hidden border border-gray-300">
//                                   <div className="flex justify-between items-center w-full max-w-4xl px-4 mb-4">
//                                     <button
//                                       type="button"
//                                       onClick={handlePrevMonth}
//                                       className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
//                                     >
//                                       Previous
//                                     </button>
//                                     <h2 className="text-xl font-semibold text-gray-700">
//                                       {currentDate.toLocaleString("default", {
//                                         month: "long",
//                                       })}{" "}
//                                       {currentDate.getFullYear()}
//                                     </h2>
//                                     <button
//                                       type="button"
//                                       onClick={handleNextMonth}
//                                       className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md shadow-md hover:bg-gray-300"
//                                     >
//                                       Next
//                                     </button>
//                                   </div>

//                                   <div className="grid grid-cols-4 sm:grid-cols-7 gap-4 p-4 bg-gray-100 rounded-2xl shadow-inner">
//                                   {calendar?.map((week, index) => (
//                                     <div key={index} className="contents">
//                                       {week?.map((day, dayIndex) => {
//                                         const currentDay = new Date(
//                                           currentDate.getFullYear(),
//                                           currentDate.getMonth(),
//                                           day
//                                         );
//                                         const isPastDate =
//                                           currentDay < new Date().setHours(0, 0, 0, 0);
//                                         const isSelected = daySelected === day && !isPastDate;
//                                         const isToday =
//                                           day === new Date().getDate() &&
//                                           currentDate.getMonth() === new Date().getMonth() &&
//                                           currentDate.getFullYear() === new Date().getFullYear();

//                                         return (
//                                           <button
//                                             key={dayIndex}
//                                             type="button"
//                                             className={`w-12 h-12 sm:w-16 sm:h-12 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out 
//                                               ${day ? "cursor-pointer" : "cursor-default"}
//                                               ${day ? "hover:bg-blue-200 hover:text-white hover:shadow-lg hover:scale-110" : "opacity-0"}
//                                               ${
//                                                 isPastDate
//                                                 ? "bg-gray-300 text-gray-500 cursor-not-allowed"
//                                                 : isSelected
//                                                 ? "!bg-blue-500 !text-white"
//                                                 : isToday
//                                                 ? "bg-red-500 text-gray-800"
//                                                 : "bg-white text-gray-700 border border-gray-200"
//                                               }`}
//                                             onClick={() => handleDateClick(day)}
//                                             disabled={!day || isPastDate}
//                                           >
//                                             {day}
//                                           </button>
//                                         );
//                                       })}
//                                     </div>
//                                   ))}
//                                 </div>
//                                 {/* Today Button */}
//                           <div className="flex justify-center mt-4">
//                             <button
//                               type="button"
//                               onClick={() => {
//                                 const today = new Date();
//                                 setCurrentDate(today);
//                                 handleDateClick(today.getDate());
//                                 setSelectedDate(today);
//                               }}
//                               className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600 transition duration-200"
//                             >
//                               Today
//                             </button>
//                           </div>

//                           {selectedDate && (
//                                 <div className="mt-4">
//                                   <h3 className="text-lg text-red-800 font-semibold mb-4">
//                                     Available Times for {format(selectedDate, "dd-MM-yyyy")}
//                                   </h3>
//                                   <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
//                                     {timeSlots?.map((slot, index) => {
//                                       const [hours, minutes] = slot.split(":");
//                                       const slotDate = new Date(selectedDate);
//                                       slotDate.setHours(parseInt(hours), parseInt(minutes), 0);
//                                       const isPast = slotDate < new Date();

//                                       return (
//                                         <button
//                                           type="button"
//                                           key={index}
//                                           onClick={() => !isPast && handleTimeSelect(slot)}
//                                           disabled={isPast}
//                                           className={`
//                                             py-3 px-4 rounded-xl text-sm font-semibold transition-all duration-200
//                                             ${
//                                               isPast
//                                                 ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-60"
//                                                 : selectedTime === slot
//                                                 ? "bg-blue-600 text-white shadow-md transform scale-105"
//                                                 : "bg-white text-gray-800 hover:bg-blue-50 hover:text-blue-600 border border-gray-200"
//                                             }
//                                           `}
//                                         >
//                                           <div className="flex flex-col items-center space-y-1">
//                                             <span>{slot}</span>
//                                             <span className="text-xs font-normal">
//                                               {isPast ? "Not Available" : "Available"}
//                                             </span>
//                                           </div>
//                                         </button>
//                                       );
//                                     })}
//                                   </div>
//                                 </div>
//                               )}
//                                 </div>
//                               )}
//                             </div>
//                           </div>

//                           {/* Form Section */}
//                           <div>
//                             <div
//                               className="flex justify-between bg-gray-400 p-2  rounded-sm text-lg font-medium"
//                               onClick={toggleFormPanel}
//                             >
//                               <p>Form</p>

//                               {/* Toggling icons */}
//                               <p className="px-3">
//                                 {isFormOpen ? (
//                                   <MdOutlineKeyboardArrowUp />
//                                 ) : (
//                                   <MdOutlineKeyboardArrowDown />
//                                 )}
//                               </p>
//                             </div>

//                             <div
//                               className={`transition-all scrollbar-none ease-in-out duration-1000 overflow-hidden ${
//                                 isFormOpen
//                                   ? "opacity-100 translate-y-0 max-h-[500px] overflow-y-auto"
//                                   : "opacity-0 translate-y-4 max-h-0"
//                               }`}
//                             >
//                               <div className=" mx-auto p-6 border border-gray-300 ">
//                                 <h2 className="text-xl font-bold mb-4">
//                                   Your Personal Details
//                                 </h2>
//                                 <p className="text-sm text-gray-600 mb-4">
//                                   Please provide your address and contact
//                                   details
//                                 </p>

//                                 {/* User Type Selector */}
//                                 <div className="flex items-center space-x-6 mb-6">
//                                   <label className="flex items-center">
//                                     <input
//                                       type="radio"
//                                       name="userType"
//                                       value="existing"
//                                       checked={userType === "existing"}
//                                       onChange={() =>
//                                         handleUserTypeChange("existing")
//                                       }
//                                       className="mr-2"
//                                     />
//                                     Existing User
//                                   </label>
//                                   <label className="flex items-center">
//                                     <input
//                                       type="radio"
//                                       name="userType"
//                                       value="new"
//                                       checked={userType === "new"}
//                                       onChange={() =>
//                                         handleUserTypeChange("new")
//                                       }
//                                       className="mr-2"
//                                     />
//                                     New User
//                                   </label>
//                                 </div>
//                                 {/* <div className="flex items-center space-x-6 mb-6">
//                                   {isAuthenticated ? (
//                                     <label className="flex items-center">
//                                       <input
//                                         type="radio"
//                                         name="userType"
//                                         value="existing"
//                                         checked
//                                         readOnly
//                                         className="mr-2"
//                                       />
//                                       Existing User
//                                     </label>
//                                   ) : (
//                                     <label className="flex items-center">
//                                       <input
//                                         type="radio"
//                                         name="userType"
//                                         value="new"
//                                         checked
//                                         readOnly
//                                         className="mr-2"
//                                       />
//                                       New User
//                                     </label>
//                                   )}
//                                 </div> */}

//                                 {userType === "existing" ? (
//                                   <div>
//                                     <select
//                                       id="crm-dropdown"
//                                       value={selectedOption || ""}
//                                       onChange={handleChangedata}
//                                       className="border p-2 rounded-md bg-white focus:ring-2 focus:ring-blue-500"
//                                     >
//                                       <option value="">-- Select --</option>
//                                       {crmgetdata.map((option) => (
//                                         <option
//                                           key={option.id}
//                                           value={option.id}
//                                         >
//                                           {option.first_name} {option.last_name}
//                                         </option>
//                                       ))}
//                                     </select>
//                                     <form className="mt-5 grid grid-cols-1 gap-4 mb-6">
//                                       <input
//                                         type="email"
//                                         name="email"
//                                         placeholder="Preferred Email"
//                                         value={userDetails.email || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md w-full"
//                                       />
//                                       <input
//                                         type="password"
//                                         name="password"
//                                         placeholder="Preferred Password"
//                                         value={userDetails.password || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md w-full"
//                                       />
//                                       <div className="grid grid-cols-2 gap-4">
//                                         <input
//                                           type="text"
//                                           name="firstName"
//                                           placeholder="First Name"
//                                           value={userDetails.firstName || ""}
//                                           onChange={handleUserDetailsChange}
//                                           className="border p-2 rounded-md"
//                                         />
//                                         <input
//                                           type="text"
//                                           name="lastName"
//                                           placeholder="Last Name"
//                                           value={userDetails.lastName || ""}
//                                           onChange={handleUserDetailsChange}
//                                           className="border p-2 rounded-md"
//                                         />
//                                       </div>
//                                       <div className="grid grid-cols-2 gap-4">
//                                         <input
//                                           type="text"
//                                           name="phone"
//                                           placeholder="Phone"
//                                           value={userDetails.phone || ""}
//                                           onChange={handleUserDetailsChange}
//                                           className="border p-2 rounded-md"
//                                         />
//                                         <input
//                                           type="text"
//                                           name="streetAddress"
//                                           placeholder="Street Address"
//                                           value={
//                                             userDetails.streetAddress || ""
//                                           }
//                                           onChange={handleUserDetailsChange}
//                                           className="border p-2 rounded-md w-full"
//                                         />
//                                       </div>
//                                       <div className="grid grid-cols-3 gap-4">
//                                         <input
//                                           type="text"
//                                           name="zipCode"
//                                           placeholder="Zip CodeHHHHHHHH"
//                                           value={userDetails.zipCode || ""}
//                                           onChange={handleUserDetailsChange}
//                                           className="border p-2 rounded-md"
//                                         />
//                                         <input
//                                           type="text"
//                                           name="city"
//                                           placeholder="City"
//                                           value={userDetails.city || ""}
//                                           onChange={handleUserDetailsChange}
//                                           className="border p-2 rounded-md"
//                                         />
//                                         <input
//                                           type="text"
//                                           name="state"
//                                           placeholder="State"
//                                           value={userDetails.state || ""}
//                                           onChange={handleUserDetailsChange}
//                                           className="border p-2 rounded-md"
//                                         />
//                                       </div>
//                                       <textarea
//                                         name="specialRequests"
//                                         placeholder="Special Requests (Notes)"
//                                         value={
//                                           userDetails.specialRequests || ""
//                                         }
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md w-full"
//                                         rows="3"
//                                       ></textarea>
//                                       {/* <button
//                                         onClick={handleSubmitdata}
//                                         className="bg-blue-500 text-white p-2 rounded-md w-full"
//                                       >
//                                         Booked
//                                       </button> */}
//                                     </form>
//                                   </div>
//                                 ) : (
//                                   <div className="grid grid-cols-1 gap-4 mb-6 p-6 bg-white shadow-lg rounded-lg max-w-lg mx-auto">
//                                     {/* Email */}
//                                     <div>
//                                     <input
//                                       type="email"
//                                       name="email"
//                                       placeholder="Preferred Email"
//                                       value={userDetails.email || ""}
//                                       onChange={handleUserDetailsChange}
//                                       className="border p-2 rounded-md w-full"
//                                     />
//                                     {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
//                                   </div>

//                                   {/* Password */}
//                                   <div>
//                                     <input
//                                       type="password"
//                                       name="password"
//                                       placeholder="Preferred Password"
//                                       value={userDetails.password || ""}
//                                       onChange={handleUserDetailsChange}
//                                       className="border p-2 rounded-md w-full"
//                                     />
//                                     {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
//                                   </div>

//                                   {/* First Name and Last Name */}
//                                   <div className="grid grid-cols-2 gap-4">
//                                     <div>
//                                       <input
//                                         type="text"
//                                         name="firstName"
//                                         placeholder="First Name"
//                                         value={userDetails.firstName || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md"
//                                       />
//                                       {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
//                                     </div>
//                                     <div>
//                                       <input
//                                         type="text"
//                                         name="lastName"
//                                         placeholder="Last Name"
//                                         value={userDetails.lastName || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md"
//                                       />
//                                       {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
//                                     </div>
//                                   </div>

//                                   {/* Phone and Street Address */}
//                                   <div className="grid grid-cols-2 gap-4">
//                                     <div>
//                                       <input
//                                         type="text"
//                                         name="phone"
//                                         placeholder="Phone"
//                                         value={userDetails.phone || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md"
//                                       />
//                                       {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
//                                     </div>
//                                     <div>
//                                       <input
//                                         type="text"
//                                         name="streetAddress"
//                                         placeholder="Street Address"
//                                         value={userDetails.streetAddress || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md w-full"
//                                       />
//                                       {errors.streetAddress && <p className="text-red-500 text-sm mt-1">{errors.streetAddress}</p>}
//                                     </div>
//                                   </div>

//                                   {/* Zip Code, City, and State */}
//                                   <div className="grid grid-cols-3 gap-4">
//                                     <div>
//                                       <input
//                                         type="text"
//                                         name="zipCode"
//                                         placeholder="Zip Code"
//                                         value={userDetails.zipCode || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md"
//                                       />
//                                       {errors.zipCode && <p className="text-red-500 text-sm mt-1">{errors.zipCode}</p>}
//                                     </div>
//                                     <div>
//                                       <input
//                                         type="text"
//                                         name="city"
//                                         placeholder="City"
//                                         value={userDetails.city || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md"
//                                       />
//                                       {errors.city && <p className="text-red-500 text-sm mt-1">{errors.city}</p>}
//                                     </div>
//                                     <div>
//                                       <input
//                                         type="text"
//                                         name="state"
//                                         placeholder="State"
//                                         value={userDetails.state || ""}
//                                         onChange={handleUserDetailsChange}
//                                         className="border p-2 rounded-md"
//                                       />
//                                       {errors.state && <p className="text-red-500 text-sm mt-1">{errors.state}</p>}
//                                     </div>
//                                   </div>
//                                     {/* Special Requests */}
//                                     <textarea
//                                       name="specialRequests"
//                                       placeholder="Special Requests (Notes)"
//                                       value={userDetails.specialRequests || ""}
//                                       onChange={handleUserDetailsChange}
//                                       className="border p-2 rounded-md w-full"
//                                       rows="3"
//                                     ></textarea>

//                                     {/* Vacuum Cleaner */}
//                                     <div className="flex justify-between items-center mb-4">
//                                       <span className="text-gray-700">
//                                         Do you have a vacuum cleaner?
//                                       </span>
//                                       <div className="flex space-x-4">
//                                         <label className="flex items-center space-x-1">
//                                           <input
//                                             type="radio"
//                                             name="vacuum"
//                                             value="yes"
//                                             checked={vacuum === "yes"}
//                                             onChange={() => setVacuum("yes")}
//                                             className="accent-blue-500"
//                                           />
//                                           <span>Yes</span>
//                                         </label>
//                                         <label className="flex items-center space-x-1">
//                                           <input
//                                             type="radio"
//                                             name="vacuum"
//                                             value="no"
//                                             checked={vacuum === "no"}
//                                             onChange={() => setVacuum("no")}
//                                             className="accent-gray-500"
//                                           />
//                                           <span>No</span>
//                                         </label>
//                                       </div>
//                                     </div>

//                                     {/* Parking */}
//                                     <div className="flex justify-between items-center mb-4">
//                                       <span className="text-gray-700">
//                                         Do you have parking?
//                                       </span>
//                                       <div className="flex space-x-4">
//                                         <label className="flex items-center space-x-1">
//                                           <input
//                                             type="radio"
//                                             name="parking"
//                                             value="yes"
//                                             checked={parking === "yes"}
//                                             onChange={() => setParking("yes")}
//                                             className="accent-blue-500"
//                                           />
//                                           <span>Yes</span>
//                                         </label>
//                                         <label className="flex items-center space-x-1">
//                                           <input
//                                             type="radio"
//                                             name="parking"
//                                             value="no"
//                                             checked={parking === "no"}
//                                             onChange={() => setParking("no")}
//                                             className="accent-gray-500"
//                                           />
//                                           <span>No</span>
//                                         </label>
//                                       </div>
//                                     </div>

//                                     {/* How will we get in? */}
//                                     <div className="mb-4">
//                                       <label className="block text-gray-700 mb-2">
//                                         How will we get in?
//                                       </label>
//                                       <select
//                                         value={access}
//                                         onChange={(e) =>
//                                           setAccess(e.target.value)
//                                         }
//                                         className="w-full p-2 border border-gray-300 rounded-lg"
//                                       >
//                                         <option value="I'll be at home">
//                                           I'll be at home
//                                         </option>
//                                         <option value="Please call me">
//                                           Please call me
//                                         </option>
//                                         <option value="The key is with the doorman">
//                                           The key is with the doorman
//                                         </option>
//                                         <option value="other">Other</option>
//                                       </select>
//                                     </div>

//                                     {/* Submit Button */}
//                                     <button
//                                       onClick={handleSubmitdata}
//                                       className="bg-blue-500 text-white p-2 rounded-md w-full"
//                                     >
//                                       Booked And New User Created
//                                     </button>
//                                   </div>
//                                   // <div className="grid grid-cols-1 gap-4 mb-6">
//                                   //   <input
//                                   //     type="email"
//                                   //     name="email"
//                                   //     placeholder="Preferred Email"
//                                   //     value={userDetails.email || ""}
//                                   //     onChange={handleUserDetailsChange}
//                                   //     className="border p-2 rounded-md w-full"
//                                   //   />
//                                   //   <input
//                                   //     type="password"
//                                   //     name="password"
//                                   //     placeholder="Preferred Password"
//                                   //     value={userDetails.password || ""}
//                                   //     onChange={handleUserDetailsChange}
//                                   //     className="border p-2 rounded-md w-full"
//                                   //   />
//                                   //   <div className="grid grid-cols-2 gap-4">
//                                   //     <input
//                                   //       type="text"
//                                   //       name="firstName"
//                                   //       placeholder="First Name"
//                                   //       value={userDetails.firstName || ""}
//                                   //       onChange={handleUserDetailsChange}
//                                   //       className="border p-2 rounded-md"
//                                   //     />
//                                   //     <input
//                                   //       type="text"
//                                   //       name="lastName"
//                                   //       placeholder="Last Name"
//                                   //       value={userDetails.lastName || ""}
//                                   //       onChange={handleUserDetailsChange}
//                                   //       className="border p-2 rounded-md"
//                                   //     />
//                                   //   </div>
//                                   //   <div className="grid grid-cols-2 gap-4">
//                                   //     <input
//                                   //       type="text"
//                                   //       name="phone"
//                                   //       placeholder="Phone"
//                                   //       value={userDetails.phone || ""}
//                                   //       onChange={handleUserDetailsChange}
//                                   //       className="border p-2 rounded-md"
//                                   //     />
//                                   //     <input
//                                   //       type="text"
//                                   //       name="streetAddress"
//                                   //       placeholder="Street Address"
//                                   //       value={userDetails.streetAddress || ""}
//                                   //       onChange={handleUserDetailsChange}
//                                   //       className="border p-2 rounded-md w-full"
//                                   //     />
//                                   //   </div>
//                                   //   <div className="grid grid-cols-3 gap-4">
//                                   //     <input
//                                   //       type="text"
//                                   //       name="zipCode"
//                                   //       placeholder="Zip Code"
//                                   //       value={userDetails.zipCode || ""}
//                                   //       onChange={handleUserDetailsChange}
//                                   //       className="border p-2 rounded-md"
//                                   //     />
//                                   //     <input
//                                   //       type="text"
//                                   //       name="city"
//                                   //       placeholder="City"
//                                   //       value={userDetails.city || ""}
//                                   //       onChange={handleUserDetailsChange}
//                                   //       className="border p-2 rounded-md"
//                                   //     />
//                                   //     <input
//                                   //       type="text"
//                                   //       name="state"
//                                   //       placeholder="State"
//                                   //       value={userDetails.state || ""}
//                                   //       onChange={handleUserDetailsChange}
//                                   //       className="border p-2 rounded-md"
//                                   //     />
//                                   //   </div>
//                                   //   <textarea
//                                   //     name="specialRequests"
//                                   //     placeholder="Special Requests (Notes)"
//                                   //     value={userDetails.specialRequests || ""}
//                                   //     onChange={handleUserDetailsChange}
//                                   //     className="border p-2 rounded-md w-full"
//                                   //     rows="3"
//                                   //   ></textarea>
//                                   //   <button
//                                   //     onClick={handleSubmitdata}
//                                   //     className="bg-blue-500 text-white p-2 rounded-md w-full"
//                                   //   >
//                                   //     Booked And New User Created
//                                   //   </button>
//                                   // </div>
//                                 )}
//                                 {/* Promo Code */}
//                                 {/* <div className=" items-center mb-6  ">
//                                   <input
//                                     type="text"
//                                     placeholder="Have a promocode?"
//                                     className="border p-2 rounded-md w-full "
//                                   />
//                                   <button className="mt-4 bg-teal-600 text-white py-2 px-4 rounded-md hover:bg-teal-700">
//                                     Apply
//                                   </button>
//                                 </div> */}

//                                 <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-5 p-5 bg-white">
//                                   <h3 className="text-lg font-semibold mb-3">
//                                     Apply Promo Code
//                                   </h3>
//                                   <div className="flex gap-2">
//                                     <input
//                                       type="text"
//                                       value={promoCode}
//                                       onChange={(e) =>
//                                         setPromoCode(e.target.value)
//                                       }
//                                       placeholder="Enter promo code"
//                                       className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                     />
//                                     <button
//                                       type="button"
//                                       onClick={handleApplyPromoCode}
//                                       className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
//                                     >
//                                       Apply
//                                     </button>
//                                   </div>

//                                   {/* Error Message */}
//                                   {error && (
//                                     <p className="text-red-600 mt-2">{error}</p>
//                                   )}

//                                   {/* Success Message & Cancel Button */}
//                                   {appliedPromoCode && (
//                                     <div className="flex justify-between items-center mt-2 p-2 bg-green-100 rounded-md">
//                                       <p className="text-green-700">
//                                         Promo code "
//                                         {appliedPromoCode.coupon_code}" applied!
//                                         ({appliedPromoCode.coupon_value}
//                                         {appliedPromoCode.coupon_type === "P"
//                                           ? "%"
//                                           : "$"}{" "}
//                                         off)
//                                       </p>
//                                       <button
//                                         type="button"
//                                         onClick={handleCancelPromo}
//                                         className="text-red-600 font-semibold hover:underline"
//                                       >
//                                         Cancel
//                                       </button>
//                                     </div>
//                                   )}
//                                 </div>

//                                 {/* Payment Method */}
//                                 <div className="mb-6">
//                                   <h3 className="font-bold mb-2">
//                                     Preferred Payment Method
//                                   </h3>

//                                   {/* Pay Locally option */}
//                                   <label className="flex items-center">
//                                     <input
//                                       type="radio"
//                                       name="paymentMethod"
//                                       value="payLocally"
//                                       checked={paymentMethod === "payLocally"}
//                                       onChange={handlePaymentChange}
//                                       className="mr-2"
//                                     />
//                                     Pay Locally
//                                   </label>

//                                   {/* Pay Online option */}
//                                   <label className="flex items-center ">
//                                     <input
//                                       type="radio"
//                                       name="paymentMethod"
//                                       value="payOnline"
//                                       checked={paymentMethod === "payOnline"}
//                                       onChange={handlePaymentChange}
//                                       className="mr-2"
//                                     />
//                                     Pay Online
//                                   </label>
//                                 </div>

//                                 {/* Terms & Conditions */}
//                                 {/* <div className="mb-6">
//                               <label className="items-center">
//                                 <input type="checkbox" className="mr-2" />I have
//                                 read and accepted the{" "}
//                                 <a href="/" className="text-teal-600 underline">
//                                   Terms & Conditions
//                                 </a>
//                                 .
//                               </label>
//                             </div> */}
//                                 <div className="mb-6">
//                                   <label className="items-center flex">
//                                     <input
//                                       type="checkbox"
//                                       className="mr-2"
//                                       checked={isChecked}
//                                       onChange={() => setIsChecked(!isChecked)}
//                                     />
//                                     I have read and accepted the{" "}
//                                     <a
//                                       href="/"
//                                       className="text-teal-600 underline"
//                                     >
//                                       Terms & Conditions
//                                     </a>
//                                     .
//                                   </label>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           {/* Submit Button */}
//                           <div className="flex justify-center mt-6">
//                             <button
//                               type="submit"
//                               className="bg-blue-800 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-600 transition duration-300"
//                             >
//                               Submit Booking
//                             </button>
//                           </div>
//                         </form>
//                         <div className="max-w-md mx-auto border rounded-lg shadow-lg mt-10 p-6 bg-white sticky top-10 mb-7">
//                           <h2 className="text-xl font-bold text-center border-b pb-3 mb-4">
//                             Booking Summary
//                           </h2>

//                           <div className="flex items-center  text-sm text-gray-600 mb-4">
//                             {/* Booking Details */}

//                             <div className="flex items-center space-x-2">
//                               <span className="material-icons text-gray-500">
//                                 Calendar today :
//                               </span>
//                               {selectedDate && selectedTime && (
//                                 <p>
//                                   {selectedDate} @ {selectedTime}
//                                 </p>
//                               )}
//                             </div>
//                           </div>
//                           <div className="flex items-center space-x-2">
//                             <span className="material-icons text-gray-500">
//                               Auto renew :
//                             </span>
//                             <p>{selectedFrequency}</p>
//                           </div>
//                           <div className="flex items-center space-x-2 mb-4 text-gray-600">
//                             <span className="material-icons text-gray-500">
//                               Time duration :
//                             </span>
//                             <p>
//                               {Math.floor(totalTime / 60)} hours{" "}
//                               {totalTime % 60} Minutes
//                             </p>
//                           </div>

//                           <div className="mb-6">
//                             <h3 className="font-bold mb-2">Cart Items :</h3>
//                             {bookingBill.length === 0 ? (
//                               <p className="text-gray-500">
//                                 No items selected.
//                               </p>
//                             ) : (
//                               <ul>
//                                 {bookingBill.map((item, idx) => (
//                                   <li
//                                     key={idx}
//                                     className="flex justify-between mb-2"
//                                   >
//                                     <span>
//                                       {item.name}
//                                       {item.type} (x{item.qty})
//                                     </span>

//                                     <div className="flex gap-4">
//                                       <span> ₹{item.rate}</span>
//                                       <span
//                                         onClick={() => removeItem(idx)}
//                                         className="text-red-500 cursor-pointer"
//                                       >
//                                         X
//                                       </span>
//                                     </div>
//                                   </li>
//                                 ))}

//                                 {/* Third Service - Property-Based Items */}

//                                 <>
//                                   {Object.keys(propertyQuantities).map((item) =>
//                                     propertyQuantities[item] > 0 ? (
//                                       <li
//                                         key={item}
//                                         className="flex justify-between mb-2"
//                                       >
//                                         <span>
//                                           {item.charAt(0).toUpperCase() +
//                                             item.slice(1)}{" "}
//                                           (x
//                                           {propertyQuantities[item]})
//                                         </span>
//                                         <span>
//                                           ${propertyQuantities[item] * 10}
//                                         </span>
//                                       </li>
//                                     ) : null
//                                   )}

//                                   {damagedFloors > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>
//                                         Damaged Floors (x{damagedFloors})
//                                       </span>
//                                       <span>${damagedFloors * 10}</span>
//                                     </li>
//                                   )}

//                                   {doorJams > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>Door Jams (x{doorJams})</span>
//                                       <span>${doorJams * 10}</span>
//                                     </li>
//                                   )}
//                                 </>

//                                 {/* Third Service - Area-Based Items */}

//                                 <>
//                                   {area > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>Cleaning Area ({area} sq.ft)</span>
//                                       <span>${area * 2}</span>
//                                     </li>
//                                   )}

//                                   {extraDamagedFloors > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>
//                                         Extra Damaged Floors (x
//                                         {extraDamagedFloors})
//                                       </span>
//                                       <span>${extraDamagedFloors * 10}</span>
//                                     </li>
//                                   )}

//                                   {extraDoorJams > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>
//                                         Extra Door Jams (x{extraDoorJams})
//                                       </span>
//                                       <span>${extraDoorJams * 10}</span>
//                                     </li>
//                                   )}
//                                 </>

//                                 <>
//                                   {Object.keys(officeQuantities).map((item) =>
//                                     officeQuantities[item] > 0 ? (
//                                       <li
//                                         key={item}
//                                         className="flex justify-between mb-2"
//                                       >
//                                         <span>
//                                           {item.charAt(0).toUpperCase() +
//                                             item.slice(1)}{" "}
//                                           (x
//                                           {officeQuantities[item]})
//                                         </span>
//                                         <span>
//                                           ${officeQuantities[item] * 10}
//                                         </span>
//                                       </li>
//                                     ) : null
//                                   )}

//                                   {packing > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>Packing Cleaning (x{packing})</span>
//                                       <span>${packing * 10}</span>
//                                     </li>
//                                   )}

//                                   {storeroom > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>
//                                         StoreRoom Cleaning (x{storeroom})
//                                       </span>
//                                       <span>${storeroom * 10}</span>
//                                     </li>
//                                   )}
//                                 </>

//                                 {/* Fourth Service - Area-Based Items */}

//                                 <>
//                                   {officearea > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>
//                                         Cleaning Area ({officearea} sq.ft)
//                                       </span>
//                                       <span>${officearea * 2}</span>
//                                     </li>
//                                   )}

//                                   {officeextraDamagedFloors > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>
//                                         Parking Cleaning (x
//                                         {officeextraDamagedFloors})
//                                       </span>
//                                       <span>
//                                         ${officeextraDamagedFloors * 10}
//                                       </span>
//                                     </li>
//                                   )}

//                                   {officeextraDoorJams > 0 && (
//                                     <li className="flex justify-between mb-2">
//                                       <span>
//                                         StoreRoom Cleaning (x
//                                         {officeextraDoorJams})
//                                       </span>
//                                       <span>${officeextraDoorJams * 10}</span>
//                                     </li>
//                                   )}
//                                 </>
//                               </ul>
//                             )}
//                           </div>

//                           <div className="border-t pt-4 text-black-800">
//                             <div className="flex justify-between mb-2">
//                               <p>Sub Total :</p>
//                               <p>
//                                 ₹
//                                 {isNaN(calculateTotal()) ? 0 : calculateTotal()}
//                               </p>
//                             </div>
//                             <div className="flex justify-between mb-2">
//                               <p>Frequently Discount:- </p>
//                               <p>-{Disamount}</p>
//                             </div>
//                             {appliedPromoCode && (
//                               <div className="flex justify-between mb-2">
//                                 <p>
//                                   Promo Code ({appliedPromoCode.coupon_code}) :
//                                 </p>
//                                 <p>-₹{promoDiscount}</p>
//                               </div>
//                             )}
//                             <div className="flex justify-between mb-4">
//                               <p>Tax :</p>
//                               <p>{tax}</p>
//                             </div>
//                             <div className="flex justify-between font-bold text-lg">
//                               <p>Total :</p>
//                               <p>₹{parseFloat(text)}</p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
     
//     </div>
//   );
// };

// export default Calendar;
		


  